var MetricTypes = {
    STRING: 1,
    NUMBER: 2,
    TIMESTAMP: 3,
    OBJECT: 4
};

function getMetricTypeByValue(metric) {
    if (metric.type === MetricTypes.TIMESTAMP) {
        return "timestamp";
    }
    else if (metric.type === MetricTypes.NUMBER) {
        return "number";
    }
    else if (metric.type === MetricTypes.STRING) {
        return "string";
    }
    else if (metric.type === MetricTypes.OBJECT) {
        return "object";
    }
    return "unknown";
}
function getTypeByValue(value) {
    if (value.constructor === Date) {
        return "timestamp";
    }
    else if (typeof value === "number") {
        return "number";
    }
    else if (typeof value === "string") {
        return "string";
    }
    else if (typeof value === "object") {
        return "object";
    }
    else {
        return "string";
    }
}
function serializeMetric(metric) {
    const serializedMetrics = {};
    const type = getMetricTypeByValue(metric);
    if (type === "object") {
        const values = Object.keys(metric.value).reduce((memo, key) => {
            const innerType = getTypeByValue(metric.value[key]);
            if (innerType === "object") {
                const composite = defineNestedComposite(metric.value[key]);
                memo[key] = {
                    type: "object",
                    description: "",
                    context: {},
                    composite,
                };
            }
            else {
                memo[key] = {
                    type: innerType,
                    description: "",
                    context: {},
                };
            }
            return memo;
        }, {});
        serializedMetrics.composite = values;
    }
    serializedMetrics.name = normalizeMetricName(metric.path.join("/") + "/" + metric.name);
    serializedMetrics.type = type;
    serializedMetrics.description = metric.description;
    serializedMetrics.context = {};
    return serializedMetrics;
}
function defineNestedComposite(values) {
    return Object.keys(values).reduce((memo, key) => {
        const type = getTypeByValue(values[key]);
        if (type === "object") {
            memo[key] = {
                type: "object",
                description: "",
                context: {},
                composite: defineNestedComposite(values[key]),
            };
        }
        else {
            memo[key] = {
                type,
                description: "",
                context: {},
            };
        }
        return memo;
    }, {});
}
function normalizeMetricName(name) {
    if (typeof name !== "undefined" && name.length > 0 && name[0] !== "/") {
        return "/" + name;
    }
    else {
        return name;
    }
}
function getMetricValueByType(metric) {
    const type = getMetricTypeByValue(metric);
    if (type === "timestamp") {
        return Date.now();
    }
    else {
        return publishNestedComposite(metric.value);
    }
}
function publishNestedComposite(values) {
    if (typeof values !== "object") {
        return values;
    }
    return Object.keys(values).reduce((memo, key) => {
        const value = values[key];
        if (typeof value === "object" && value.constructor !== Date) {
            memo[key] = publishNestedComposite(value);
        }
        else if (value.constructor === Date) {
            memo[key] = new Date(value).getTime();
        }
        else if (value.constructor === Boolean) {
            memo[key] = value.toString();
        }
        else {
            memo[key] = value;
        }
        return memo;
    }, {});
}
function flatten(arr) {
    return arr.reduce((flat, toFlatten) => {
        return flat.concat(Array.isArray(toFlatten) ? flatten(toFlatten) : toFlatten);
    }, []);
}
function getHighestState(arr) {
    return arr.sort((a, b) => {
        if (!a.state) {
            return 1;
        }
        if (!b.state) {
            return -1;
        }
        return b.state - a.state;
    })[0];
}
function aggregateDescription(arr) {
    let msg = "";
    arr.forEach((m, idx, a) => {
        const path = m.path.join(".");
        if (idx === a.length - 1) {
            msg += path + "." + m.name + ": " + m.description;
        }
        else {
            msg += path + "." + m.name + ": " + m.description + ",";
        }
    });
    if (msg.length > 100) {
        return msg.slice(0, 100) + "...";
    }
    else {
        return msg;
    }
}
function composeMsgForRootStateMetric(system) {
    const aggregatedState = system.root.getAggregateState();
    const merged = flatten(aggregatedState);
    const highestState = getHighestState(merged);
    const aggregateDesc = aggregateDescription(merged);
    return {
        description: aggregateDesc,
        value: highestState.state,
    };
}

function gw3 (connection, config) {
    if (!connection || typeof connection !== "object") {
        throw new Error("Connection is required parameter");
    }
    let joinPromise;
    let session;
    const init = (repo) => {
        let resolveReadyPromise;
        joinPromise = new Promise((resolve) => {
            resolveReadyPromise = resolve;
        });
        session = connection.domain("metrics");
        session.onJoined((reconnect) => {
            if (!reconnect && resolveReadyPromise) {
                resolveReadyPromise();
                resolveReadyPromise = undefined;
            }
            const rootStateMetric = {
                name: "/State",
                type: "object",
                composite: {
                    Description: {
                        type: "string",
                        description: "",
                    },
                    Value: {
                        type: "number",
                        description: "",
                    },
                },
                description: "System state",
                context: {},
            };
            const defineRootMetricsMsg = {
                type: "define",
                metrics: [rootStateMetric],
            };
            session.send(defineRootMetricsMsg);
            if (reconnect) {
                replayRepo(repo);
            }
        });
        session.join({
            system: config.system,
            service: config.service,
            instance: config.instance
        });
    };
    const replayRepo = (repo) => {
        replaySystem(repo.root);
    };
    const replaySystem = (system) => {
        createSystem(system);
        system.metrics.forEach((m) => {
            createMetric(m);
        });
        system.subSystems.forEach((ss) => {
            replaySystem(ss);
        });
    };
    const createSystem = async (system) => {
        if (system.parent === undefined) {
            return;
        }
        await joinPromise;
        const metric = {
            name: normalizeMetricName(system.path.join("/") + "/" + system.name + "/State"),
            type: "object",
            composite: {
                Description: {
                    type: "string",
                    description: "",
                },
                Value: {
                    type: "number",
                    description: "",
                },
            },
            description: "System state",
            context: {},
        };
        const createMetricsMsg = {
            type: "define",
            metrics: [metric],
        };
        session.send(createMetricsMsg);
    };
    const updateSystem = async (system, state) => {
        await joinPromise;
        const shadowedUpdateMetric = {
            type: "publish",
            values: [{
                    name: normalizeMetricName(system.path.join("/") + "/" + system.name + "/State"),
                    value: {
                        Description: state.description,
                        Value: state.state,
                    },
                    timestamp: Date.now(),
                }],
        };
        session.send(shadowedUpdateMetric);
        const stateObj = composeMsgForRootStateMetric(system);
        const rootMetric = {
            type: "publish",
            peer_id: connection.peerId,
            values: [{
                    name: "/State",
                    value: {
                        Description: stateObj.description,
                        Value: stateObj.value,
                    },
                    timestamp: Date.now(),
                }],
        };
        session.send(rootMetric);
    };
    const createMetric = async (metric) => {
        const metricClone = cloneMetric(metric);
        await joinPromise;
        const m = serializeMetric(metricClone);
        const createMetricsMsg = {
            type: "define",
            metrics: [m],
        };
        session.send(createMetricsMsg);
        if (typeof metricClone.value !== "undefined") {
            updateMetricCore(metricClone);
        }
    };
    const updateMetric = async (metric) => {
        const metricClone = cloneMetric(metric);
        await joinPromise;
        updateMetricCore(metricClone);
    };
    const updateMetricCore = (metric) => {
        if (canUpdate()) {
            const value = getMetricValueByType(metric);
            const publishMetricsMsg = {
                type: "publish",
                values: [{
                        name: normalizeMetricName(metric.path.join("/") + "/" + metric.name),
                        value,
                        timestamp: Date.now(),
                    }],
            };
            return session.sendFireAndForget(publishMetricsMsg);
        }
        return Promise.resolve();
    };
    const cloneMetric = (metric) => {
        const metricClone = { ...metric };
        if (typeof metric.value === "object" && metric.value !== null) {
            metricClone.value = { ...metric.value };
        }
        return metricClone;
    };
    const canUpdate = () => {
        try {
            const func = config.canUpdateMetric ?? (() => true);
            return func();
        }
        catch {
            return true;
        }
    };
    return {
        init,
        createSystem,
        updateSystem,
        createMetric,
        updateMetric,
    };
}

var Helpers = {
    validate: (definition, parent, transport) => {
        if (definition === null || typeof definition !== "object") {
            throw new Error("Missing definition");
        }
        if (parent === null || typeof parent !== "object") {
            throw new Error("Missing parent");
        }
        if (transport === null || typeof transport !== "object") {
            throw new Error("Missing transport");
        }
    },
};

class BaseMetric {
    definition;
    system;
    transport;
    value;
    type;
    path = [];
    name;
    description;
    get repo() {
        return this.system?.repo;
    }
    get id() { return `${this.system.path}/${name}`; }
    constructor(definition, system, transport, value, type) {
        this.definition = definition;
        this.system = system;
        this.transport = transport;
        this.value = value;
        this.type = type;
        Helpers.validate(definition, system, transport);
        this.path = system.path.slice(0);
        this.path.push(system.name);
        this.name = definition.name;
        this.description = definition.description;
        transport.createMetric(this);
    }
    update(newValue) {
        this.value = newValue;
        return this.transport.updateMetric(this);
    }
}

class NumberMetric extends BaseMetric {
    constructor(definition, system, transport, value) {
        super(definition, system, transport, value, MetricTypes.NUMBER);
    }
    incrementBy(num) {
        this.update(this.value + num);
    }
    increment() {
        this.incrementBy(1);
    }
    decrement() {
        this.incrementBy(-1);
    }
    decrementBy(num) {
        this.incrementBy(num * -1);
    }
}

class ObjectMetric extends BaseMetric {
    constructor(definition, system, transport, value) {
        super(definition, system, transport, value, MetricTypes.OBJECT);
    }
    update(newValue) {
        this.mergeValues(newValue);
        return this.transport.updateMetric(this);
    }
    mergeValues(values) {
        return Object.keys(this.value).forEach((k) => {
            if (typeof values[k] !== "undefined") {
                this.value[k] = values[k];
            }
        });
    }
}

class StringMetric extends BaseMetric {
    constructor(definition, system, transport, value) {
        super(definition, system, transport, value, MetricTypes.STRING);
    }
}

class TimestampMetric extends BaseMetric {
    constructor(definition, system, transport, value) {
        super(definition, system, transport, value, MetricTypes.TIMESTAMP);
    }
    now() {
        this.update(new Date());
    }
}

function system(name, repo, protocol, parent, description) {
    if (!repo) {
        throw new Error("Repository is required");
    }
    if (!protocol) {
        throw new Error("Transport is required");
    }
    const _transport = protocol;
    const _name = name;
    const _description = description || "";
    const _repo = repo;
    const _parent = parent;
    const _path = _buildPath(parent);
    let _state = {};
    const id = _arrayToString(_path, "/") + name;
    const root = repo.root;
    const _subSystems = [];
    const _metrics = [];
    function subSystem(nameSystem, descriptionSystem) {
        if (!nameSystem || nameSystem.length === 0) {
            throw new Error("name is required");
        }
        const match = _subSystems.filter((s) => s.name === nameSystem);
        if (match.length > 0) {
            return match[0];
        }
        const _system = system(nameSystem, _repo, _transport, me, descriptionSystem);
        _subSystems.push(_system);
        return _system;
    }
    function setState(state, stateDescription) {
        _state = { state, description: stateDescription };
        _transport.updateSystem(me, _state);
    }
    function stringMetric(definition, value) {
        return _getOrCreateMetric(definition, MetricTypes.STRING, value, (metricDef) => new StringMetric(metricDef, me, _transport, value));
    }
    function numberMetric(definition, value) {
        return _getOrCreateMetric(definition, MetricTypes.NUMBER, value, (metricDef) => new NumberMetric(metricDef, me, _transport, value));
    }
    function objectMetric(definition, value) {
        return _getOrCreateMetric(definition, MetricTypes.OBJECT, value, (metricDef) => new ObjectMetric(metricDef, me, _transport, value));
    }
    function timestampMetric(definition, value) {
        return _getOrCreateMetric(definition, MetricTypes.TIMESTAMP, value, (metricDef) => new TimestampMetric(metricDef, me, _transport, value));
    }
    function _getOrCreateMetric(metricObject, expectedType, value, createMetric) {
        let metricDef = { name: "" };
        if (typeof metricObject === "string") {
            metricDef = { name: metricObject };
        }
        else {
            metricDef = metricObject;
        }
        const matching = _metrics.filter((shadowedMetric) => shadowedMetric.name === metricDef.name);
        if (matching.length > 0) {
            const existing = matching[0];
            if (existing.type !== expectedType) {
                throw new Error(`A metric named ${metricDef.name} is already defined with different type.`);
            }
            if (typeof value !== "undefined") {
                existing
                    .update(value)
                    .catch(() => { });
            }
            return existing;
        }
        const metric = createMetric(metricDef);
        _metrics.push(metric);
        return metric;
    }
    function _buildPath(shadowedSystem) {
        if (!shadowedSystem || !shadowedSystem.parent) {
            return [];
        }
        const path = _buildPath(shadowedSystem.parent);
        path.push(shadowedSystem.name);
        return path;
    }
    function _arrayToString(path, separator) {
        return ((path && path.length > 0) ? path.join(separator) : "");
    }
    function getAggregateState() {
        const aggState = [];
        if (Object.keys(_state).length > 0) {
            aggState.push({
                name: _name,
                path: _path,
                state: _state.state,
                description: _state.description,
            });
        }
        _subSystems.forEach((shadowedSubSystem) => {
            const result = shadowedSubSystem.getAggregateState();
            if (result.length > 0) {
                aggState.push(...result);
            }
        });
        return aggState;
    }
    const me = {
        get name() {
            return _name;
        },
        get description() {
            return _description;
        },
        get repo() {
            return _repo;
        },
        get parent() {
            return _parent;
        },
        path: _path,
        id,
        root,
        get subSystems() {
            return _subSystems;
        },
        get metrics() {
            return _metrics;
        },
        subSystem,
        getState: () => {
            return _state;
        },
        setState,
        stringMetric,
        timestampMetric,
        objectMetric,
        numberMetric,
        getAggregateState,
    };
    _transport.createSystem(me);
    return me;
}

class Repository {
    root;
    constructor(options, protocol) {
        protocol.init(this);
        this.root = system("", this, protocol);
        this.addSystemMetrics(this.root, options.clickStream || options.clickStream === undefined);
    }
    addSystemMetrics(rootSystem, useClickStream) {
        if (typeof navigator !== "undefined") {
            rootSystem.stringMetric("UserAgent", navigator.userAgent);
        }
        if (useClickStream && typeof document !== "undefined") {
            const clickStream = rootSystem.subSystem("ClickStream");
            const documentClickHandler = (e) => {
                if (!e.target) {
                    return;
                }
                const target = e.target;
                const className = target ? target.getAttribute("class") ?? "" : "";
                clickStream.objectMetric("LastBrowserEvent", {
                    type: "click",
                    timestamp: new Date(),
                    target: {
                        className,
                        id: target.id,
                        type: "<" + target.tagName.toLowerCase() + ">",
                        href: target.href || "",
                    },
                });
            };
            clickStream.objectMetric("Page", {
                title: document.title,
                page: window.location.href,
            });
            if (document.addEventListener) {
                document.addEventListener("click", documentClickHandler);
            }
            else {
                document.attachEvent("onclick", documentClickHandler);
            }
        }
        rootSystem.stringMetric("StartTime", (new Date()).toString());
        const urlMetric = rootSystem.stringMetric("StartURL", "");
        const appNameMetric = rootSystem.stringMetric("AppName", "");
        if (typeof window !== "undefined") {
            if (typeof window.location !== "undefined") {
                const startUrl = window.location.href;
                urlMetric.update(startUrl);
            }
            if (typeof window.glue42gd !== "undefined") {
                appNameMetric.update(window.glue42gd.appName);
            }
        }
    }
}

class NullProtocol {
    init(repo) {
    }
    createSystem(system) {
        return Promise.resolve();
    }
    updateSystem(metric, state) {
        return Promise.resolve();
    }
    createMetric(metric) {
        return Promise.resolve();
    }
    updateMetric(metric) {
        return Promise.resolve();
    }
}

class PerfTracker {
    api;
    lastCount = 0;
    initialPublishTimeout = 10 * 1000;
    publishInterval = 60 * 1000;
    system;
    constructor(api, initialPublishTimeout, publishInterval) {
        this.api = api;
        this.initialPublishTimeout = initialPublishTimeout ?? this.initialPublishTimeout;
        this.publishInterval = publishInterval ?? this.publishInterval;
        this.scheduleCollection();
        this.system = this.api.subSystem("performance", "Performance data published by the web application");
    }
    scheduleCollection() {
        setTimeout(() => {
            this.collect();
            setInterval(() => {
                this.collect();
            }, this.publishInterval);
        }, this.initialPublishTimeout);
    }
    collect() {
        try {
            this.collectMemory();
            this.collectEntries();
        }
        catch {
        }
    }
    collectMemory() {
        const memory = window.performance.memory;
        this.system.stringMetric("memory", JSON.stringify({
            totalJSHeapSize: memory.totalJSHeapSize,
            usedJSHeapSize: memory.usedJSHeapSize
        }));
    }
    collectEntries() {
        const allEntries = window.performance.getEntries();
        if (allEntries.length <= this.lastCount) {
            return;
        }
        this.lastCount = allEntries.length;
        const jsonfiedEntries = allEntries.map((i) => i.toJSON());
        this.system.stringMetric("entries", JSON.stringify(jsonfiedEntries));
    }
}

var metrics = (options) => {
    let protocol;
    if (!options.connection || typeof options.connection !== "object") {
        protocol = new NullProtocol();
    }
    else {
        protocol = gw3(options.connection, options);
    }
    const repo = new Repository(options, protocol);
    let rootSystem = repo.root;
    if (!options.disableAutoAppSystem) {
        rootSystem = rootSystem.subSystem("App");
    }
    const api = addFAVSupport(rootSystem);
    initPerf(api, options.pagePerformanceMetrics);
    return api;
};
function initPerf(api, config) {
    if (typeof window === "undefined") {
        return;
    }
    const perfConfig = window?.glue42gd?.metrics?.pagePerformanceMetrics;
    if (perfConfig) {
        config = perfConfig;
    }
    if (config?.enabled) {
        new PerfTracker(api, config.initialPublishTimeout, config.publishInterval);
    }
}
function addFAVSupport(system) {
    const reportingSystem = system.subSystem("reporting");
    const def = {
        name: "features"
    };
    let featureMetric;
    const featureMetricFunc = (name, action, payload) => {
        if (typeof name === "undefined" || name === "") {
            throw new Error("name is mandatory");
        }
        else if (typeof action === "undefined" || action === "") {
            throw new Error("action is mandatory");
        }
        else if (typeof payload === "undefined" || payload === "") {
            throw new Error("payload is mandatory");
        }
        if (!featureMetric) {
            featureMetric = reportingSystem.objectMetric(def, { name, action, payload });
        }
        else {
            featureMetric.update({
                name,
                action,
                payload
            });
        }
    };
    system.featureMetric = featureMetricFunc;
    return system;
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createRegistry(options) {
    if (options && options.errorHandling
        && typeof options.errorHandling !== "function"
        && options.errorHandling !== "log"
        && options.errorHandling !== "silent"
        && options.errorHandling !== "throw") {
        throw new Error("Invalid options passed to createRegistry. Prop errorHandling should be [\"log\" | \"silent\" | \"throw\" | (err) => void], but " + typeof options.errorHandling + " was passed");
    }
    var _userErrorHandler = options && typeof options.errorHandling === "function" && options.errorHandling;
    var callbacks = {};
    function add(key, callback, replayArgumentsArr) {
        var callbacksForKey = callbacks[key];
        if (!callbacksForKey) {
            callbacksForKey = [];
            callbacks[key] = callbacksForKey;
        }
        callbacksForKey.push(callback);
        if (replayArgumentsArr) {
            setTimeout(function () {
                replayArgumentsArr.forEach(function (replayArgument) {
                    var _a;
                    if ((_a = callbacks[key]) === null || _a === void 0 ? void 0 : _a.includes(callback)) {
                        try {
                            if (Array.isArray(replayArgument)) {
                                callback.apply(undefined, replayArgument);
                            }
                            else {
                                callback.apply(undefined, [replayArgument]);
                            }
                        }
                        catch (err) {
                            _handleError(err, key);
                        }
                    }
                });
            }, 0);
        }
        return function () {
            var allForKey = callbacks[key];
            if (!allForKey) {
                return;
            }
            allForKey = allForKey.reduce(function (acc, element, index) {
                if (!(element === callback && acc.length === index)) {
                    acc.push(element);
                }
                return acc;
            }, []);
            if (allForKey.length === 0) {
                delete callbacks[key];
            }
            else {
                callbacks[key] = allForKey;
            }
        };
    }
    function execute(key) {
        var argumentsArr = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            argumentsArr[_i - 1] = arguments[_i];
        }
        var callbacksForKey = callbacks[key];
        if (!callbacksForKey || callbacksForKey.length === 0) {
            return [];
        }
        var results = [];
        callbacksForKey.forEach(function (callback) {
            try {
                var result = callback.apply(undefined, argumentsArr);
                results.push(result);
            }
            catch (err) {
                results.push(undefined);
                _handleError(err, key);
            }
        });
        return results;
    }
    function _handleError(exceptionArtifact, key) {
        var errParam = exceptionArtifact instanceof Error ? exceptionArtifact : new Error(exceptionArtifact);
        if (_userErrorHandler) {
            _userErrorHandler(errParam);
            return;
        }
        var msg = "[ERROR] callback-registry: User callback for key \"" + key + "\" failed: " + errParam.stack;
        if (options) {
            switch (options.errorHandling) {
                case "log":
                    return console.error(msg);
                case "silent":
                    return;
                case "throw":
                    throw new Error(msg);
            }
        }
        console.error(msg);
    }
    function clear() {
        callbacks = {};
    }
    function clearKey(key) {
        var callbacksForKey = callbacks[key];
        if (!callbacksForKey) {
            return;
        }
        delete callbacks[key];
    }
    return {
        add: add,
        execute: execute,
        clear: clear,
        clearKey: clearKey
    };
}
createRegistry.default = createRegistry;
var lib = createRegistry;


var CallbackRegistryFactory = /*@__PURE__*/getDefaultExportFromCjs(lib);

class InProcTransport {
    gw;
    registry = CallbackRegistryFactory();
    client;
    constructor(settings, logger) {
        this.gw = settings.facade;
        this.gw.connect((_client, message) => {
            this.messageHandler(message);
        }).then((client) => {
            this.client = client;
        });
    }
    get isObjectBasedTransport() {
        return true;
    }
    sendObject(msg) {
        if (this.client) {
            this.client.send(msg);
            return Promise.resolve(undefined);
        }
        else {
            return Promise.reject(`not connected`);
        }
    }
    send(_msg) {
        return Promise.reject("not supported");
    }
    onMessage(callback) {
        return this.registry.add("onMessage", callback);
    }
    onConnectedChanged(callback) {
        callback(true);
        return () => { };
    }
    close() {
        return Promise.resolve();
    }
    open() {
        return Promise.resolve();
    }
    name() {
        return "in-memory";
    }
    reconnect() {
        return Promise.resolve();
    }
    messageHandler(msg) {
        this.registry.execute("onMessage", msg);
    }
}

class SharedWorkerTransport {
    logger;
    worker;
    registry = CallbackRegistryFactory();
    constructor(workerFile, logger) {
        this.logger = logger;
        this.worker = new SharedWorker(workerFile);
        this.worker.port.onmessage = (e) => {
            this.messageHandler(e.data);
        };
    }
    get isObjectBasedTransport() {
        return true;
    }
    sendObject(msg) {
        this.worker.port.postMessage(msg);
        return Promise.resolve();
    }
    send(_msg) {
        return Promise.reject("not supported");
    }
    onMessage(callback) {
        return this.registry.add("onMessage", callback);
    }
    onConnectedChanged(callback) {
        callback(true);
        return () => { };
    }
    close() {
        return Promise.resolve();
    }
    open() {
        return Promise.resolve();
    }
    name() {
        return "shared-worker";
    }
    reconnect() {
        return Promise.resolve();
    }
    messageHandler(msg) {
        this.registry.execute("onMessage", msg);
    }
}

class Utils {
    static isNode() {
        if (typeof Utils._isNode !== "undefined") {
            return Utils._isNode;
        }
        if (typeof window !== "undefined") {
            Utils._isNode = false;
            return false;
        }
        try {
            Utils._isNode = Object.prototype.toString.call(global.process) === "[object process]";
        }
        catch (e) {
            Utils._isNode = false;
        }
        return Utils._isNode;
    }
    static _isNode;
}

class PromiseWrapper {
    static delay(time) {
        return new Promise((resolve) => setTimeout(resolve, time));
    }
    resolve;
    reject;
    promise;
    rejected = false;
    resolved = false;
    get ended() {
        return this.rejected || this.resolved;
    }
    constructor() {
        this.promise = new Promise((resolve, reject) => {
            this.resolve = (t) => {
                this.resolved = true;
                resolve(t);
            };
            this.reject = (err) => {
                this.rejected = true;
                reject(err);
            };
        });
    }
}

const timers = {};
function getAllTimers() {
    return timers;
}
function timer (timerName) {
    const existing = timers[timerName];
    if (existing) {
        return existing;
    }
    const marks = [];
    function now() {
        return new Date().getTime();
    }
    const startTime = now();
    mark("start", startTime);
    let endTime;
    let period;
    function stop() {
        endTime = now();
        mark("end", endTime);
        period = endTime - startTime;
        return period;
    }
    function mark(name, time) {
        const currentTime = time ?? now();
        let diff = 0;
        if (marks.length > 0) {
            diff = currentTime - marks[marks.length - 1].time;
        }
        marks.push({ name, time: currentTime, diff });
    }
    const timerObj = {
        get startTime() {
            return startTime;
        },
        get endTime() {
            return endTime;
        },
        get period() {
            return period;
        },
        stop,
        mark,
        marks
    };
    timers[timerName] = timerObj;
    return timerObj;
}

const WebSocketConstructor = Utils.isNode() ? require("ws") : window.WebSocket;
class WS {
    ws;
    logger;
    settings;
    startupTimer = timer("connection");
    _running = true;
    _registry = CallbackRegistryFactory();
    wsRequests = [];
    constructor(settings, logger) {
        this.settings = settings;
        this.logger = logger;
        if (!this.settings.ws) {
            throw new Error("ws is missing");
        }
    }
    onMessage(callback) {
        return this._registry.add("onMessage", callback);
    }
    send(msg, options) {
        return new Promise((resolve, reject) => {
            this.waitForSocketConnection(() => {
                try {
                    this.ws?.send(msg);
                    resolve();
                }
                catch (e) {
                    reject(e);
                }
            }, reject);
        });
    }
    open() {
        this.logger.info("opening ws...");
        this._running = true;
        return new Promise((resolve, reject) => {
            this.waitForSocketConnection(resolve, reject);
        });
    }
    close() {
        this._running = false;
        if (this.ws) {
            this.ws.close();
        }
        return Promise.resolve();
    }
    onConnectedChanged(callback) {
        return this._registry.add("onConnectedChanged", callback);
    }
    name() {
        return this.settings.ws;
    }
    reconnect() {
        this.ws?.close();
        const pw = new PromiseWrapper();
        this.waitForSocketConnection(() => {
            pw.resolve();
        });
        return pw.promise;
    }
    waitForSocketConnection(callback, failed) {
        failed = failed ?? (() => { });
        if (!this._running) {
            failed(`wait for socket on ${this.settings.ws} failed - socket closed by user`);
            return;
        }
        if (this.ws?.readyState === 1) {
            callback();
            return;
        }
        this.wsRequests.push({ callback, failed });
        if (this.wsRequests.length > 1) {
            return;
        }
        this.openSocket();
    }
    async openSocket(retryInterval, retriesLeft) {
        this.logger.info(`opening ws to ${this.settings.ws}, retryInterval: ${retryInterval}, retriesLeft: ${retriesLeft}...`);
        this.startupTimer.mark("opening-socket");
        if (retryInterval === undefined) {
            retryInterval = this.settings.reconnectInterval;
        }
        if (typeof retriesLeft === "undefined") {
            retriesLeft = this.settings.reconnectAttempts;
        }
        if (retriesLeft !== undefined) {
            if (retriesLeft === 0) {
                this.notifyForSocketState(`wait for socket on ${this.settings.ws} failed - no more retries left`);
                return;
            }
            this.logger.debug(`will retry ${retriesLeft} more times (every ${retryInterval} ms)`);
        }
        try {
            await this.initiateSocket();
            this.startupTimer.mark("socket-initiated");
            this.notifyForSocketState();
        }
        catch {
            setTimeout(() => {
                const retries = retriesLeft === undefined ? undefined : retriesLeft - 1;
                this.openSocket(retryInterval, retries);
            }, retryInterval);
        }
    }
    initiateSocket() {
        const pw = new PromiseWrapper();
        this.logger.debug(`initiating ws to ${this.settings.ws}...`);
        this.ws = new WebSocketConstructor(this.settings.ws ?? "");
        this.ws.onerror = (err) => {
            let reason = "";
            try {
                reason = JSON.stringify(err);
            }
            catch (error) {
                const seen = new WeakSet();
                const replacer = (key, value) => {
                    if (typeof value === "object" && value !== null) {
                        if (seen.has(value)) {
                            return;
                        }
                        seen.add(value);
                    }
                    return value;
                };
                reason = JSON.stringify(err, replacer);
            }
            this.logger.info(`ws error - reason: ${reason}`);
            pw.reject("error");
            this.notifyStatusChanged(false, reason);
        };
        this.ws.onclose = (err) => {
            this.logger.info(`ws closed - code: ${err?.code} reason: ${err?.reason}`);
            pw.reject("closed");
            this.notifyStatusChanged(false);
        };
        this.ws.onopen = () => {
            this.startupTimer.mark("ws-opened");
            this.logger.info(`ws opened ${this.settings.identity?.application}`);
            pw.resolve();
            this.notifyStatusChanged(true);
        };
        this.ws.onmessage = (message) => {
            this._registry.execute("onMessage", message.data);
        };
        return pw.promise;
    }
    notifyForSocketState(error) {
        this.wsRequests.forEach((wsRequest) => {
            if (error) {
                if (wsRequest.failed) {
                    wsRequest.failed(error);
                }
            }
            else {
                wsRequest.callback();
            }
        });
        this.wsRequests = [];
    }
    notifyStatusChanged(status, reason) {
        this._registry.execute("onConnectedChanged", status, reason);
    }
}

class MessageReplayerImpl {
    specs;
    specsNames = [];
    messages = {};
    isDone;
    subs = {};
    subsRefCount = {};
    connection;
    constructor(specs) {
        this.specs = {};
        for (const spec of specs) {
            this.specs[spec.name] = spec;
            this.specsNames.push(spec.name);
        }
    }
    init(connection) {
        this.connection = connection;
        for (const name of this.specsNames) {
            for (const type of this.specs[name].types) {
                let refCount = this.subsRefCount[type];
                if (!refCount) {
                    refCount = 0;
                }
                refCount += 1;
                this.subsRefCount[type] = refCount;
                if (refCount > 1) {
                    continue;
                }
                const sub = connection.on(type, (msg) => this.processMessage(type, msg));
                this.subs[type] = sub;
            }
        }
    }
    processMessage(type, msg) {
        if (this.isDone || !msg) {
            return;
        }
        for (const name of this.specsNames) {
            if (this.specs[name].types.indexOf(type) !== -1) {
                const messages = this.messages[name] || [];
                this.messages[name] = messages;
                messages.push(msg);
            }
        }
    }
    drain(name, callback) {
        if (callback) {
            (this.messages[name] || []).forEach(callback);
        }
        delete this.messages[name];
        for (const type of this.specs[name].types) {
            this.subsRefCount[type] -= 1;
            if (this.subsRefCount[type] <= 0) {
                this.connection?.off(this.subs[type]);
                delete this.subs[type];
                delete this.subsRefCount[type];
            }
        }
        delete this.specs[name];
        if (!this.specs.length) {
            this.isDone = true;
        }
    }
}

let urlAlphabet =
  'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict';
let nanoid = (size = 21) => {
  let id = '';
  let i = size;
  while (i--) {
    id += urlAlphabet[(Math.random() * 64) | 0];
  }
  return id
};

const PromisePlus = (executor, timeoutMilliseconds, timeoutMessage) => {
    return new Promise((resolve, reject) => {
        const timeout = setTimeout(() => {
            const message = timeoutMessage || `Promise timeout hit: ${timeoutMilliseconds}`;
            reject(message);
        }, timeoutMilliseconds);
        const providedPromise = new Promise(executor);
        providedPromise
            .then((result) => {
            clearTimeout(timeout);
            resolve(result);
        })
            .catch((error) => {
            clearTimeout(timeout);
            reject(error);
        });
    });
};

class WebPlatformTransport {
    settings;
    logger;
    identity;
    isPreferredActivated;
    _communicationId;
    publicWindowId;
    selfAssignedWindowId;
    iAmConnected = false;
    parentReady = false;
    rejected = false;
    parentPingResolve;
    parentPingInterval;
    connectionResolve;
    extConnectionResolve;
    extConnectionReject;
    connectionReject;
    port;
    myClientId;
    children = [];
    extContentAvailable = false;
    extContentConnecting = false;
    extContentConnected = false;
    parentWindowId;
    parentInExtMode = false;
    webNamespace = "g42_core_web";
    parent;
    parentType;
    parentPingTimeout = 5000;
    connectionRequestTimeout = 7000;
    defaultTargetString = "*";
    registry = CallbackRegistryFactory();
    messages = {
        connectionAccepted: { name: "connectionAccepted", handle: this.handleConnectionAccepted.bind(this) },
        connectionRejected: { name: "connectionRejected", handle: this.handleConnectionRejected.bind(this) },
        connectionRequest: { name: "connectionRequest", handle: this.handleConnectionRequest.bind(this) },
        parentReady: {
            name: "parentReady", handle: () => {
            }
        },
        parentPing: { name: "parentPing", handle: this.handleParentPing.bind(this) },
        platformPing: { name: "platformPing", handle: this.handlePlatformPing.bind(this) },
        platformReady: { name: "platformReady", handle: this.handlePlatformReady.bind(this) },
        clientUnload: { name: "clientUnload", handle: this.handleClientUnload.bind(this) },
        manualUnload: { name: "manualUnload", handle: this.handleManualUnload.bind(this) },
        extConnectionResponse: { name: "extConnectionResponse", handle: this.handleExtConnectionResponse.bind(this) },
        extSetupRequest: { name: "extSetupRequest", handle: this.handleExtSetupRequest.bind(this) },
        gatewayDisconnect: { name: "gatewayDisconnect", handle: this.handleGatewayDisconnect.bind(this) },
        gatewayInternalConnect: { name: "gatewayInternalConnect", handle: this.handleGatewayInternalConnect.bind(this) }
    };
    constructor(settings, logger, identity) {
        this.settings = settings;
        this.logger = logger;
        this.identity = identity;
        this.extContentAvailable = !!window.glue42ext;
        this.setUpMessageListener();
        this.setUpUnload();
        this.setupPlatformUnloadListener();
        this.parentType = window.name.includes("#wsp") ? "workspace" : undefined;
    }
    manualSetReadyState() {
        this.iAmConnected = true;
        this.parentReady = true;
    }
    get transportWindowId() {
        return this.publicWindowId;
    }
    get communicationId() {
        return this._communicationId;
    }
    async sendObject(msg) {
        if (this.extContentConnected) {
            return window.postMessage({ glue42ExtOut: msg }, this.defaultTargetString);
        }
        if (!this.port) {
            throw new Error("Cannot send message, because the port was not opened yet");
        }
        this.port.postMessage(msg);
    }
    get isObjectBasedTransport() {
        return true;
    }
    onMessage(callback) {
        return this.registry.add("onMessage", callback);
    }
    send() {
        return Promise.reject("not supported");
    }
    onConnectedChanged(callback) {
        return this.registry.add("onConnectedChanged", callback);
    }
    async open() {
        this.logger.debug("opening a connection to the web platform gateway.");
        await this.connect();
        this.notifyStatusChanged(true);
    }
    close() {
        const message = {
            glue42core: {
                type: this.messages.gatewayDisconnect.name,
                data: {
                    clientId: this.myClientId,
                    ownWindowId: this.identity?.windowId
                }
            }
        };
        this.port?.postMessage(message);
        this.parentReady = false;
        this.notifyStatusChanged(false, "manual reconnection");
        return Promise.resolve();
    }
    name() {
        return "web-platform";
    }
    async reconnect() {
        await this.close();
        return Promise.resolve();
    }
    initiateInternalConnection() {
        return new Promise((resolve, reject) => {
            this.logger.debug("opening an internal web platform connection");
            this.port = this.settings.port;
            if (this.iAmConnected) {
                this.logger.warn("cannot open a new connection, because this client is currently connected");
                return;
            }
            this.port.onmessage = (event) => {
                if (this.iAmConnected && !event.data?.glue42core) {
                    this.registry.execute("onMessage", event.data);
                    return;
                }
                const data = event.data?.glue42core;
                if (!data) {
                    return;
                }
                if (data.type === this.messages.gatewayInternalConnect.name && data.success) {
                    this.publicWindowId = this.settings.windowId;
                    if (this.identity && this.publicWindowId) {
                        this.identity.windowId = this.publicWindowId;
                        this.identity.instance = this.publicWindowId;
                    }
                    resolve();
                }
                if (data.type === this.messages.gatewayInternalConnect.name && data.error) {
                    reject(data.error);
                }
            };
            this.port.postMessage({
                glue42core: {
                    type: this.messages.gatewayInternalConnect.name
                }
            });
        });
    }
    initiateRemoteConnection(target) {
        return PromisePlus((resolve, reject) => {
            this.connectionResolve = resolve;
            this.connectionReject = reject;
            this.myClientId = this.myClientId ?? nanoid(10);
            const bridgeInstanceId = this.getMyWindowId() || nanoid(10);
            const request = {
                glue42core: {
                    type: this.messages.connectionRequest.name,
                    clientId: this.myClientId,
                    clientType: "child",
                    bridgeInstanceId,
                    selfAssignedWindowId: this.selfAssignedWindowId
                }
            };
            this.logger.debug("sending connection request");
            if (this.extContentConnecting) {
                request.glue42core.clientType = "child";
                request.glue42core.bridgeInstanceId = this.myClientId;
                request.glue42core.parentWindowId = this.parentWindowId;
                return window.postMessage(request, this.defaultTargetString);
            }
            if (!target) {
                throw new Error("Cannot send a connection request, because no glue target was specified!");
            }
            target.postMessage(request, this.defaultTargetString);
        }, this.connectionRequestTimeout, "The connection to the target glue window timed out");
    }
    async isParentCheckSuccess(parentCheck) {
        try {
            await parentCheck;
            return { success: true };
        }
        catch (error) {
            return { success: false };
        }
    }
    setUpMessageListener() {
        if (this.settings.port) {
            this.logger.debug("skipping generic message listener, because this is an internal client");
            return;
        }
        window.addEventListener("message", (event) => {
            const data = event.data?.glue42core;
            if (!data || this.rejected) {
                return;
            }
            const allowedOrigins = this.settings.allowedOrigins || [];
            if (allowedOrigins.length && !allowedOrigins.includes(event.origin)) {
                this.logger.warn(`received a message from an origin which is not in the allowed list: ${event.origin}`);
                return;
            }
            if (!this.checkMessageTypeValid(data.type)) {
                this.logger.error(`cannot handle the incoming glue42 core message, because the type is invalid: ${data.type}`);
                return;
            }
            const messageType = data.type;
            this.logger.debug(`received valid glue42core message of type: ${messageType}`);
            this.messages[messageType].handle(event);
        });
    }
    setUpUnload() {
        if (this.settings.port) {
            this.logger.debug("skipping unload event listener, because this is an internal client");
            return;
        }
        window.addEventListener("beforeunload", () => {
            if (this.extContentConnected) {
                return;
            }
            const message = {
                glue42core: {
                    type: this.messages.clientUnload.name,
                    data: {
                        clientId: this.myClientId,
                        ownWindowId: this.identity?.windowId
                    }
                }
            };
            if (this.parent) {
                this.parent.postMessage(message, this.defaultTargetString);
            }
            this.port?.postMessage(message);
        });
    }
    handlePlatformReady(event) {
        this.logger.debug("the web platform gave the ready signal");
        this.parentReady = true;
        if (this.parentPingResolve) {
            this.parentPingResolve();
            delete this.parentPingResolve;
        }
        if (this.parentPingInterval) {
            clearInterval(this.parentPingInterval);
            delete this.parentPingInterval;
        }
        this.parent = event.source;
        this.parentType = window.name.includes("#wsp") ? "workspace" : "window";
    }
    handleConnectionAccepted(event) {
        const data = event.data?.glue42core;
        if (this.myClientId === data.clientId) {
            return this.handleAcceptanceOfMyRequest(data);
        }
        return this.handleAcceptanceOfGrandChildRequest(data, event);
    }
    handleAcceptanceOfMyRequest(data) {
        this.logger.debug("handling a connection accepted signal targeted at me.");
        this.isPreferredActivated = data.isPreferredActivated;
        if (this.extContentConnecting) {
            return this.processExtContentConnection(data);
        }
        if (!data.port) {
            this.logger.error("cannot set up my connection, because I was not provided with a port");
            return;
        }
        this.publicWindowId = this.getMyWindowId();
        if (this.identity) {
            this.identity.windowId = this.publicWindowId;
            this.identity.instance = this.identity.instance ? this.identity.instance : this.publicWindowId || nanoid(10);
        }
        if (this.identity && data.appName) {
            this.identity.application = data.appName;
            this.identity.applicationName = data.appName;
        }
        this._communicationId = data.communicationId;
        this.port = data.port;
        this.port.onmessage = (e) => this.registry.execute("onMessage", e.data);
        if (this.connectionResolve) {
            this.logger.debug("my connection is set up, calling the connection resolve.");
            this.connectionResolve();
            delete this.connectionResolve;
            return;
        }
        this.logger.error("unable to call the connection resolve, because no connection promise was found");
    }
    processExtContentConnection(data) {
        this.logger.debug("handling a connection accepted signal targeted at me for extension content connection.");
        this.extContentConnecting = false;
        this.extContentConnected = true;
        this.publicWindowId = this.parentWindowId || this.myClientId;
        if (this.extContentConnecting && this.identity) {
            this.identity.windowId = this.publicWindowId;
        }
        if (this.identity && data.appName) {
            this.identity.application = data.appName;
            this.identity.applicationName = data.appName;
        }
        window.addEventListener("message", (event) => {
            const extData = event.data?.glue42ExtInc;
            if (!extData) {
                return;
            }
            const allowedOrigins = this.settings.allowedOrigins || [];
            if (allowedOrigins.length && !allowedOrigins.includes(event.origin)) {
                this.logger.warn(`received a message from an origin which is not in the allowed list: ${event.origin}`);
                return;
            }
            this.registry.execute("onMessage", extData);
        });
        if (this.connectionResolve) {
            this.logger.debug("my connection is set up, calling the connection resolve.");
            this.connectionResolve();
            delete this.connectionResolve;
            return;
        }
    }
    handleAcceptanceOfGrandChildRequest(data, event) {
        if (this.extContentConnecting || this.extContentConnected) {
            this.logger.debug("cannot process acceptance of a grandchild, because I am connected to a content script");
            return;
        }
        this.logger.debug(`handling a connection accepted signal targeted at a grandchild: ${data.clientId}`);
        const child = this.children.find((c) => c.grandChildId === data.clientId);
        if (!child) {
            this.logger.error(`cannot handle connection accepted for grandchild: ${data.clientId}, because there is no grandchild with this id`);
            return;
        }
        child.connected = true;
        this.logger.debug(`the grandchild connection for ${data.clientId} is set up, forwarding the success message and the gateway port`);
        data.parentWindowId = this.publicWindowId;
        child.source.postMessage(event.data, child.origin, [data.port]);
        return;
    }
    handleConnectionRejected(event) {
        this.logger.debug("handling a connection rejection. Most likely the reason is that this window was not created by a glue API call");
        if (!this.connectionReject) {
            return;
        }
        const errorMsg = typeof event.data.glue42core?.error === "string"
            ? `Connection was rejected. ${event.data.glue42core?.error}`
            : "The platform connection was rejected. Most likely because this window was not created by a glue API call";
        this.connectionReject(errorMsg);
        delete this.connectionReject;
    }
    handleConnectionRequest(event) {
        if (this.extContentConnecting) {
            this.logger.debug("This connection request event is targeted at the extension content");
            return;
        }
        const source = event.source;
        const data = event.data.glue42core;
        if (!data.clientType || data.clientType !== "grandChild") {
            return this.rejectConnectionRequest(source, event.origin, "rejecting a connection request, because the source was not opened by a glue API call");
        }
        if (!data.clientId) {
            return this.rejectConnectionRequest(source, event.origin, "rejecting a connection request, because the source did not provide a valid id");
        }
        if (!this.parent) {
            return this.rejectConnectionRequest(source, event.origin, "Cannot forward the connection request, because no direct connection to the platform was found");
        }
        this.logger.debug(`handling a connection request for a grandchild: ${data.clientId}`);
        this.children.push({ grandChildId: data.clientId, source, connected: false, origin: event.origin });
        this.logger.debug(`grandchild: ${data.clientId} is prepared, forwarding connection request to the platform`);
        this.parent.postMessage(event.data, this.defaultTargetString);
    }
    handleParentPing(event) {
        if (!this.parentReady) {
            this.logger.debug("my parent is not ready, I am ignoring the parent ping");
            return;
        }
        if (!this.iAmConnected) {
            this.logger.debug("i am not fully connected yet, I am ignoring the parent ping");
            return;
        }
        const message = {
            glue42core: {
                type: this.messages.parentReady.name
            }
        };
        if (this.extContentConnected) {
            message.glue42core.extMode = { windowId: this.myClientId };
        }
        const source = event.source;
        this.logger.debug("responding to a parent ping with a ready message");
        source.postMessage(message, event.origin);
    }
    setupPlatformUnloadListener() {
        this.onMessage((msg) => {
            if (msg.type === "platformUnload") {
                this.logger.debug("detected a web platform unload");
                this.parentReady = false;
                this.notifyStatusChanged(false, "Gateway unloaded");
            }
        });
    }
    handleManualUnload() {
        const message = {
            glue42core: {
                type: this.messages.clientUnload.name,
                data: {
                    clientId: this.myClientId,
                    ownWindowId: this.identity?.windowId
                }
            }
        };
        if (this.extContentConnected) {
            return window.postMessage({ glue42ExtOut: message }, this.defaultTargetString);
        }
        this.port?.postMessage(message);
    }
    handleClientUnload(event) {
        const data = event.data.glue42core;
        const clientId = data?.data.clientId;
        if (!clientId) {
            this.logger.warn("cannot process grand child unload, because the provided id was not valid");
            return;
        }
        const foundChild = this.children.find((child) => child.grandChildId === clientId);
        if (!foundChild) {
            this.logger.warn("cannot process grand child unload, because this client is unaware of this grandchild");
            return;
        }
        this.logger.debug(`handling grandchild unload for id: ${clientId}`);
        this.children = this.children.filter((child) => child.grandChildId !== clientId);
    }
    handlePlatformPing() {
        return;
    }
    notifyStatusChanged(status, reason) {
        this.iAmConnected = status;
        this.registry.execute("onConnectedChanged", status, reason);
    }
    checkMessageTypeValid(typeToValidate) {
        return typeof typeToValidate === "string" && !!this.messages[typeToValidate];
    }
    rejectConnectionRequest(source, origin, reason) {
        this.rejected = true;
        this.logger.error(reason);
        const rejection = {
            glue42core: {
                type: this.messages.connectionRejected.name
            }
        };
        source.postMessage(rejection, origin);
    }
    requestConnectionPermissionFromExt() {
        return this.waitForContentScript()
            .then(() => PromisePlus((resolve, reject) => {
            this.extConnectionResolve = resolve;
            this.extConnectionReject = reject;
            const message = {
                glue42core: {
                    type: "extSetupRequest"
                }
            };
            this.logger.debug("permission request to the extension content script was sent");
            window.postMessage(message, this.defaultTargetString);
        }, this.parentPingTimeout, "Cannot initialize glue, because this app was not opened or created by a Glue Client and the request for extension connection timed out"));
    }
    handleExtConnectionResponse(event) {
        const data = event.data?.glue42core;
        if (!data.approved) {
            return this.extConnectionReject ? this.extConnectionReject("Cannot initialize glue, because this app was not opened or created by a Glue Client and the request for extension connection was rejected") : undefined;
        }
        if (this.extConnectionResolve) {
            this.extConnectionResolve();
            delete this.extConnectionResolve;
        }
        this.extContentConnecting = true;
        this.parentType = "extension";
        this.logger.debug("The extension connection was approved, proceeding.");
    }
    handleExtSetupRequest() {
        return;
    }
    handleGatewayDisconnect() {
        return;
    }
    handleGatewayInternalConnect() {
        return;
    }
    waitForContentScript() {
        const contentReady = !!window.glue42ext?.content;
        if (contentReady) {
            return Promise.resolve();
        }
        return PromisePlus((resolve) => {
            window.addEventListener("Glue42EXTReady", () => {
                resolve();
            });
        }, this.connectionRequestTimeout, "The content script was available, but was never heard to be ready");
    }
    async connect() {
        if (this.settings.port) {
            await this.initiateInternalConnection();
            this.logger.debug("internal web platform connection completed");
            return;
        }
        this.logger.debug("opening a client web platform connection");
        await this.findParent();
        await this.initiateRemoteConnection(this.parent);
        this.logger.debug("the client is connected");
    }
    async findParent() {
        const connectionNotPossibleMsg = "Cannot initiate glue, because this window was not opened or created by a glue client";
        const myInsideParents = this.getPossibleParentsInWindow(window);
        const myOutsideParents = this.getPossibleParentsOutsideWindow(window.top?.opener, window.top);
        const uniqueParents = new Set([...myInsideParents, ...myOutsideParents]);
        if (!uniqueParents.size && !this.extContentAvailable) {
            throw new Error(connectionNotPossibleMsg);
        }
        if (!uniqueParents.size && this.extContentAvailable) {
            await this.requestConnectionPermissionFromExt();
            return;
        }
        const defaultParentCheck = await this.isParentCheckSuccess(this.confirmParent(Array.from(uniqueParents)));
        if (defaultParentCheck.success) {
            this.logger.debug("The default parent was found!");
            return;
        }
        if (!this.extContentAvailable) {
            throw new Error(connectionNotPossibleMsg);
        }
        await this.requestConnectionPermissionFromExt();
    }
    getPossibleParentsInWindow(currentWindow) {
        return (!currentWindow?.parent || currentWindow === currentWindow.parent) ? [] : [currentWindow.parent, ...this.getPossibleParentsInWindow(currentWindow.parent)];
    }
    getPossibleParentsOutsideWindow(opener, current) {
        return (!opener || !current || opener === current) ? [] : [opener, ...this.getPossibleParentsInWindow(opener), ...this.getPossibleParentsOutsideWindow(opener.opener, opener)];
    }
    confirmParent(targets) {
        const connectionNotPossibleMsg = "Cannot initiate glue, because this window was not opened or created by a glue client";
        const parentCheck = PromisePlus((resolve) => {
            this.parentPingResolve = resolve;
            const message = {
                glue42core: {
                    type: this.messages.platformPing.name
                }
            };
            this.parentPingInterval = setInterval(() => {
                targets.forEach((target) => {
                    target.postMessage(message, this.defaultTargetString);
                });
            }, 1000);
        }, this.parentPingTimeout, connectionNotPossibleMsg);
        parentCheck.catch(() => {
            if (this.parentPingInterval) {
                clearInterval(this.parentPingInterval);
                delete this.parentPingInterval;
            }
        });
        return parentCheck;
    }
    getMyWindowId() {
        if (this.parentType === "workspace") {
            return window.name.substring(0, window.name.indexOf("#wsp"));
        }
        if (window !== window.top) {
            return;
        }
        if (window.name?.includes("g42")) {
            return window.name;
        }
        this.selfAssignedWindowId = this.selfAssignedWindowId || `g42-${nanoid(10)}`;
        return this.selfAssignedWindowId;
    }
}

const waitForInvocations = (invocations, callback) => {
    let left = invocations;
    return () => {
        left--;
        if (left === 0) {
            callback();
        }
    };
};

class AsyncSequelizer {
    minSequenceInterval;
    queue = [];
    isExecutingQueue = false;
    constructor(minSequenceInterval = 0) {
        this.minSequenceInterval = minSequenceInterval;
    }
    enqueue(action) {
        return new Promise((resolve, reject) => {
            this.queue.push({ action, resolve, reject });
            this.executeQueue();
        });
    }
    async executeQueue() {
        if (this.isExecutingQueue) {
            return;
        }
        this.isExecutingQueue = true;
        while (this.queue.length) {
            const operation = this.queue.shift();
            if (!operation) {
                this.isExecutingQueue = false;
                return;
            }
            try {
                const actionResult = await operation.action();
                operation.resolve(actionResult);
            }
            catch (error) {
                operation.reject(error);
            }
            await this.intervalBreak();
        }
        this.isExecutingQueue = false;
    }
    intervalBreak() {
        return new Promise((res) => setTimeout(res, this.minSequenceInterval));
    }
}

function domainSession (domain, connection, logger, successMessages, errorMessages) {
    if (domain == null) {
        domain = "global";
    }
    successMessages = successMessages ?? ["success"];
    errorMessages = errorMessages ?? ["error"];
    let isJoined = domain === "global";
    let tryReconnecting = false;
    let _latestOptions;
    let _connectionOn = false;
    const callbacks = CallbackRegistryFactory();
    connection.disconnected(handleConnectionDisconnected);
    connection.loggedIn(handleConnectionLoggedIn);
    connection.on("success", (msg) => handleSuccessMessage(msg));
    connection.on("error", (msg) => handleErrorMessage(msg));
    connection.on("result", (msg) => handleSuccessMessage(msg));
    if (successMessages) {
        successMessages.forEach((sm) => {
            connection.on(sm, (msg) => handleSuccessMessage(msg));
        });
    }
    if (errorMessages) {
        errorMessages.forEach((sm) => {
            connection.on(sm, (msg) => handleErrorMessage(msg));
        });
    }
    const requestsMap = {};
    function join(options) {
        _latestOptions = options;
        return new Promise((resolve, reject) => {
            if (isJoined) {
                resolve({});
                return;
            }
            let joinPromise;
            if (domain === "global") {
                joinPromise = _connectionOn ? Promise.resolve({}) : Promise.reject("not connected to gateway");
            }
            else {
                logger.debug(`joining domain ${domain}`);
                const joinMsg = {
                    type: "join",
                    destination: domain,
                    domain: "global",
                    options,
                };
                joinPromise = send(joinMsg);
            }
            joinPromise
                .then(() => {
                handleJoined();
                resolve({});
            })
                .catch((err) => {
                logger.debug("error joining " + domain + " domain: " + JSON.stringify(err));
                reject(err);
            });
        });
    }
    function leave() {
        if (domain === "global") {
            return Promise.resolve();
        }
        logger.debug("stopping session " + domain + "...");
        const leaveMsg = {
            type: "leave",
            destination: domain,
            domain: "global",
        };
        tryReconnecting = false;
        return send(leaveMsg)
            .then(() => {
            isJoined = false;
            callbacks.execute("onLeft");
        })
            .catch(() => {
            isJoined = false;
            callbacks.execute("onLeft");
        });
    }
    function handleJoined() {
        logger.debug("did join " + domain);
        isJoined = true;
        const wasReconnect = tryReconnecting;
        tryReconnecting = false;
        callbacks.execute("onJoined", wasReconnect);
    }
    function handleConnectionDisconnected() {
        _connectionOn = false;
        logger.debug("connection is down");
        isJoined = false;
        tryReconnecting = true;
        callbacks.execute("onLeft", { disconnected: true });
    }
    function handleConnectionLoggedIn() {
        _connectionOn = true;
        if (tryReconnecting) {
            logger.debug("connection is now up - trying to reconnect...");
            join(_latestOptions);
        }
    }
    function onJoined(callback) {
        if (isJoined) {
            callback(false);
        }
        return callbacks.add("onJoined", callback);
    }
    function onLeft(callback) {
        if (!isJoined) {
            callback();
        }
        return callbacks.add("onLeft", callback);
    }
    function handleErrorMessage(msg) {
        if (domain !== msg.domain) {
            return;
        }
        const requestId = msg.request_id;
        if (!requestId) {
            return;
        }
        const entry = requestsMap[requestId];
        if (!entry) {
            return;
        }
        entry.error(msg);
    }
    function handleSuccessMessage(msg) {
        if (msg.domain !== domain) {
            return;
        }
        const requestId = msg.request_id;
        if (!requestId) {
            return;
        }
        const entry = requestsMap[requestId];
        if (!entry) {
            return;
        }
        entry.success(msg);
    }
    function getNextRequestId() {
        return nanoid(10);
    }
    let queuedCalls = [];
    function send(msg, tag, options) {
        const ignore = ["hello", "join"];
        if (msg.type && ignore.indexOf(msg.type) === -1) {
            if (!isJoined) {
                console.warn(`trying to send a message (${msg.domain} ${msg.type}) but not connected, will queue`);
                const pw = new PromiseWrapper();
                queuedCalls.push({ msg, tag, options, pw });
                if (queuedCalls.length === 1) {
                    const unsubscribe = onJoined(() => {
                        logger.info(`joined - will now send queued messages (${queuedCalls.length} -> [${queuedCalls.map((m) => m.msg.type)}])`);
                        queuedCalls.forEach((qm) => {
                            send(qm.msg, qm.tag, qm.options)
                                .then((t) => qm.pw.resolve(t))
                                .catch((e) => qm.pw.reject(e));
                        });
                        queuedCalls = [];
                        unsubscribe();
                    });
                }
                return pw.promise;
            }
        }
        options = options ?? {};
        msg.request_id = msg.request_id ?? getNextRequestId();
        msg.domain = msg.domain ?? domain;
        if (!options.skipPeerId) {
            msg.peer_id = connection.peerId;
        }
        const requestId = msg.request_id;
        return new Promise((resolve, reject) => {
            requestsMap[requestId] = {
                success: (successMsg) => {
                    delete requestsMap[requestId];
                    successMsg._tag = tag;
                    resolve(successMsg);
                },
                error: (errorMsg) => {
                    logger.warn(`Gateway error - ${JSON.stringify(errorMsg)}`);
                    delete requestsMap[requestId];
                    errorMsg._tag = tag;
                    reject(errorMsg);
                },
            };
            connection
                .send(msg, options)
                .catch((err) => {
                requestsMap[requestId].error({ err });
            });
        });
    }
    function sendFireAndForget(msg) {
        msg.request_id = msg.request_id ? msg.request_id : getNextRequestId();
        msg.domain = msg.domain ?? domain;
        msg.peer_id = connection.peerId;
        return connection.send(msg);
    }
    return {
        join,
        leave,
        onJoined,
        onLeft,
        send,
        sendFireAndForget,
        on: (type, callback) => {
            connection.on(type, (msg) => {
                if (msg.domain !== domain) {
                    return;
                }
                try {
                    callback(msg);
                }
                catch (e) {
                    logger.error(`Callback  failed: ${e} \n ${e.stack} \n msg was: ${JSON.stringify(msg)}`, e);
                }
            });
        },
        loggedIn: (callback) => connection.loggedIn(callback),
        connected: (callback) => connection.connected(callback),
        disconnected: (callback) => connection.disconnected(callback),
        get peerId() {
            return connection.peerId;
        },
        get domain() {
            return domain;
        },
    };
}

class Connection {
    settings;
    logger;
    protocolVersion = 3;
    peerId;
    token;
    info;
    resolvedIdentity;
    availableDomains;
    gatewayToken;
    replayer;
    messageHandlers = {};
    ids = 1;
    registry = CallbackRegistryFactory();
    _connected = false;
    isTrace = false;
    transport;
    _defaultTransport;
    _defaultAuth;
    _targetTransport;
    _targetAuth;
    _swapTransport = false;
    _switchInProgress = false;
    _transportSubscriptions = [];
    datePrefix = "#T42_DATE#";
    datePrefixLen = this.datePrefix.length;
    dateMinLen = this.datePrefixLen + 1;
    datePrefixFirstChar = this.datePrefix[0];
    _sequelizer = new AsyncSequelizer();
    _isLoggedIn = false;
    shouldTryLogin = true;
    pingTimer;
    sessions = [];
    globalDomain;
    initialLogin = true;
    initialLoginAttempts = 3;
    loginConfig;
    constructor(settings, logger) {
        this.settings = settings;
        this.logger = logger;
        settings = settings || {};
        settings.reconnectAttempts = settings.reconnectAttempts ?? 10;
        settings.reconnectInterval = settings.reconnectInterval ?? 1000;
        if (settings.inproc) {
            this.transport = new InProcTransport(settings.inproc, logger.subLogger("inMemory"));
        }
        else if (settings.sharedWorker) {
            this.transport = new SharedWorkerTransport(settings.sharedWorker, logger.subLogger("shared-worker"));
        }
        else if (settings.webPlatform) {
            this.transport = new WebPlatformTransport(settings.webPlatform, logger.subLogger("web-platform"), settings.identity);
        }
        else if (settings.ws !== undefined) {
            this.transport = new WS(settings, logger.subLogger("ws"));
        }
        else {
            throw new Error("No connection information specified");
        }
        this.isTrace = logger.canPublish("trace");
        logger.debug(`starting with ${this.transport.name()} transport`);
        const unsubConnectionChanged = this.transport.onConnectedChanged(this.handleConnectionChanged.bind(this));
        const unsubOnMessage = this.transport.onMessage(this.handleTransportMessage.bind(this));
        this._transportSubscriptions.push(unsubConnectionChanged);
        this._transportSubscriptions.push(unsubOnMessage);
        this._defaultTransport = this.transport;
        this.ping();
    }
    async switchTransport(settings) {
        return this._sequelizer.enqueue(async () => {
            if (!settings || typeof settings !== "object") {
                throw new Error("Cannot switch transports, because the settings are missing or invalid.");
            }
            if (typeof settings.type === "undefined") {
                throw new Error("Cannot switch the transport, because the type is not defined");
            }
            this.logger.trace(`Starting transport switch with settings: ${JSON.stringify(settings)}`);
            const switchTargetTransport = settings.type === "secondary" ? this.getNewSecondaryTransport(settings) : this._defaultTransport;
            this._targetTransport = switchTargetTransport;
            this._targetAuth = settings.type === "secondary" ? this.getNewSecondaryAuth(settings) : this._defaultAuth;
            const verifyPromise = this.verifyConnection();
            this._swapTransport = true;
            this._switchInProgress = true;
            this.logger.trace("The new transport has been set, closing the current transport");
            await this.transport.close();
            try {
                await verifyPromise;
                const isSwitchSuccess = this.transport === switchTargetTransport;
                this.logger.info(`The reconnection after the switch was completed. Was the switch a success: ${isSwitchSuccess}`);
                this._switchInProgress = false;
                return { success: isSwitchSuccess };
            }
            catch (error) {
                this.logger.info("The reconnection after the switch timed out, reverting back to the default transport.");
                this.switchTransport({ type: "default" });
                this._switchInProgress = false;
                return { success: false };
            }
        });
    }
    onLibReAnnounced(callback) {
        return this.registry.add("libReAnnounced", callback);
    }
    setLibReAnnounced(lib) {
        this.registry.execute("libReAnnounced", lib);
    }
    send(message, options) {
        if (this.transport.sendObject &&
            this.transport.isObjectBasedTransport) {
            const msg = this.createObjectMessage(message);
            if (this.isTrace) {
                this.logger.trace(`>> ${JSON.stringify(msg)}`);
            }
            return this.transport.sendObject(msg, options);
        }
        else {
            const strMessage = this.createStringMessage(message);
            if (this.isTrace) {
                this.logger.trace(`>> ${strMessage}`);
            }
            return this.transport.send(strMessage, options);
        }
    }
    on(type, messageHandler) {
        type = type.toLowerCase();
        if (this.messageHandlers[type] === undefined) {
            this.messageHandlers[type] = {};
        }
        const id = this.ids++;
        this.messageHandlers[type][id] = messageHandler;
        return {
            type,
            id,
        };
    }
    off(info) {
        delete this.messageHandlers[info.type.toLowerCase()][info.id];
    }
    get isConnected() {
        return this._isLoggedIn;
    }
    connected(callback) {
        return this.loggedIn(() => {
            const currentServer = this.transport.name();
            callback(currentServer);
        });
    }
    disconnected(callback) {
        return this.registry.add("disconnected", callback);
    }
    async login(authRequest, reconnect) {
        if (!this._defaultAuth) {
            this._defaultAuth = authRequest;
        }
        if (this._swapTransport) {
            this.logger.trace("Detected a transport swap, swapping transports");
            const newAuth = this.transportSwap();
            authRequest = newAuth ?? authRequest;
        }
        this.logger.trace(`Starting login for transport: ${this.transport.name()} and auth ${JSON.stringify(authRequest)}`);
        try {
            await this.transport.open();
            this.logger.trace(`Transport: ${this.transport.name()} opened, logging in`);
            timer("connection").mark("transport-opened");
            const identity = await this.loginCore(authRequest, reconnect);
            this.logger.trace(`Logged in with identity: ${JSON.stringify(identity)}`);
            timer("connection").mark("protocol-logged-in");
            return identity;
        }
        catch (error) {
            if (this._switchInProgress) {
                this.logger.trace("An error while logging in after a transport swap, preparing a default swap.");
                this.prepareDefaultSwap();
            }
            throw new Error(error);
        }
    }
    async logout() {
        await this.logoutCore();
        await this.transport.close();
    }
    loggedIn(callback) {
        if (this._isLoggedIn) {
            callback();
        }
        return this.registry.add("onLoggedIn", callback);
    }
    domain(domain, successMessages, errorMessages) {
        let session = this.sessions.find((s) => s.domain === domain);
        if (!session) {
            session = domainSession(domain, this, this.logger.subLogger(`domain=${domain}`), successMessages, errorMessages);
            this.sessions.push(session);
        }
        return session;
    }
    authToken() {
        const createTokenReq = {
            domain: "global",
            type: "create-token"
        };
        if (!this.globalDomain) {
            return Promise.reject(new Error("no global domain session"));
        }
        return this.globalDomain.send(createTokenReq)
            .then((res) => {
            return res.token;
        });
    }
    reconnect() {
        return this.transport.reconnect();
    }
    setLoggedIn(value) {
        this._isLoggedIn = value;
        if (this._isLoggedIn) {
            this.registry.execute("onLoggedIn");
        }
    }
    distributeMessage(message, type) {
        const handlers = this.messageHandlers[type.toLowerCase()];
        if (handlers !== undefined) {
            Object.keys(handlers).forEach((handlerId) => {
                const handler = handlers[handlerId];
                if (handler !== undefined) {
                    try {
                        handler(message);
                    }
                    catch (error) {
                        try {
                            this.logger.error(`Message handler failed with ${error.stack}`, error);
                        }
                        catch (loggerError) {
                            console.log("Message handler failed", error);
                        }
                    }
                }
            });
        }
    }
    handleConnectionChanged(connected) {
        if (this._connected === connected) {
            return;
        }
        this._connected = connected;
        if (connected) {
            if (this.settings?.replaySpecs?.length) {
                this.replayer = new MessageReplayerImpl(this.settings.replaySpecs);
                this.replayer.init(this);
            }
            this.registry.execute("connected");
        }
        else {
            this.handleDisconnected();
            this.registry.execute("disconnected");
        }
    }
    handleDisconnected() {
        this.setLoggedIn(false);
        const tryToLogin = this.shouldTryLogin;
        if (tryToLogin && this.initialLogin) {
            if (this.initialLoginAttempts <= 0) {
                return;
            }
            this.initialLoginAttempts--;
        }
        this.logger.debug("disconnected - will try new login?" + this.shouldTryLogin);
        if (this.shouldTryLogin) {
            if (!this.loginConfig) {
                throw new Error("no login info");
            }
            this.login(this.loginConfig, true)
                .catch(() => {
                setTimeout(this.handleDisconnected.bind(this), this.settings.reconnectInterval || 1000);
            });
        }
    }
    handleTransportMessage(msg) {
        let msgObj;
        if (typeof msg === "string") {
            msgObj = this.processStringMessage(msg);
        }
        else {
            msgObj = this.processObjectMessage(msg);
        }
        if (this.isTrace) {
            this.logger.trace(`<< ${JSON.stringify(msgObj)}`);
        }
        this.distributeMessage(msgObj.msg, msgObj.msgType);
    }
    verifyConnection() {
        return PromisePlus((resolve) => {
            let unsub;
            const ready = waitForInvocations(2, () => {
                if (unsub) {
                    unsub();
                }
                resolve();
            });
            unsub = this.onLibReAnnounced((lib) => {
                if (lib.name === "interop") {
                    return ready();
                }
                if (lib.name === "contexts") {
                    return ready();
                }
            });
        }, 10000, "Transport switch timed out waiting for all libraries to be re-announced");
    }
    getNewSecondaryTransport(settings) {
        if (!settings.transportConfig?.url) {
            throw new Error("Missing secondary transport URL.");
        }
        return new WS(Object.assign({}, this.settings, { ws: settings.transportConfig.url, reconnectAttempts: 1 }), this.logger.subLogger("ws-secondary"));
    }
    getNewSecondaryAuth(settings) {
        if (!settings.transportConfig?.auth) {
            throw new Error("Missing secondary transport auth information.");
        }
        return settings.transportConfig.auth;
    }
    transportSwap() {
        this._swapTransport = false;
        if (!this._targetTransport || !this._targetAuth) {
            this.logger.warn(`Error while switching transports - either the target transport or auth is not defined: transport defined -> ${!!this._defaultTransport}, auth defined -> ${!!this._targetAuth}. Staying on the current one.`);
            return;
        }
        this._transportSubscriptions.forEach((unsub) => unsub());
        this._transportSubscriptions = [];
        this.transport = this._targetTransport;
        const unsubConnectionChanged = this.transport.onConnectedChanged(this.handleConnectionChanged.bind(this));
        const unsubOnMessage = this.transport.onMessage(this.handleTransportMessage.bind(this));
        this._transportSubscriptions.push(unsubConnectionChanged);
        this._transportSubscriptions.push(unsubOnMessage);
        return this._targetAuth;
    }
    prepareDefaultSwap() {
        this._transportSubscriptions.forEach((unsub) => unsub());
        this._transportSubscriptions = [];
        this.transport.close().catch((error) => this.logger.warn(`Error closing the ${this.transport.name()} transport after a failed connection attempt: ${JSON.stringify(error)}`));
        this._targetTransport = this._defaultTransport;
        this._targetAuth = this._defaultAuth;
        this._swapTransport = true;
    }
    processStringMessage(message) {
        const msg = JSON.parse(message, (key, value) => {
            if (typeof value !== "string") {
                return value;
            }
            if (value.length < this.dateMinLen) {
                return value;
            }
            if (!value.startsWith(this.datePrefixFirstChar)) {
                return value;
            }
            if (value.substring(0, this.datePrefixLen) !== this.datePrefix) {
                return value;
            }
            try {
                const milliseconds = parseInt(value.substring(this.datePrefixLen, value.length), 10);
                if (isNaN(milliseconds)) {
                    return value;
                }
                return new Date(milliseconds);
            }
            catch (ex) {
                return value;
            }
        });
        return {
            msg,
            msgType: msg.type,
        };
    }
    createStringMessage(message) {
        const oldToJson = Date.prototype.toJSON;
        try {
            const datePrefix = this.datePrefix;
            Date.prototype.toJSON = function () {
                return datePrefix + this.getTime();
            };
            const result = JSON.stringify(message);
            return result;
        }
        finally {
            Date.prototype.toJSON = oldToJson;
        }
    }
    processObjectMessage(message) {
        if (!message.type) {
            throw new Error("Object should have type property");
        }
        return {
            msg: message,
            msgType: message.type,
        };
    }
    createObjectMessage(message) {
        return message;
    }
    async loginCore(config, reconnect) {
        this.logger.info("logging in...");
        this.loginConfig = config;
        if (!this.loginConfig) {
            this.loginConfig = { username: "", password: "" };
        }
        this.shouldTryLogin = true;
        const authentication = await this.setupAuthConfig(config, reconnect);
        const helloMsg = {
            type: "hello",
            identity: this.settings.identity,
            authentication
        };
        if (config.sessionId) {
            helloMsg.request_id = config.sessionId;
        }
        this.globalDomain = domainSession("global", this, this.logger.subLogger("global-domain"), [
            "welcome",
            "token",
            "authentication-request"
        ]);
        const sendOptions = { skipPeerId: true };
        if (this.initialLogin) {
            sendOptions.retryInterval = this.settings.reconnectInterval;
            sendOptions.maxRetries = this.settings.reconnectAttempts;
        }
        try {
            const welcomeMsg = await this.tryAuthenticate(this.globalDomain, helloMsg, sendOptions, config);
            this.initialLogin = false;
            this.logger.info("login successful with peerId " + welcomeMsg.peer_id);
            this.peerId = welcomeMsg.peer_id;
            this.resolvedIdentity = welcomeMsg.resolved_identity;
            this.availableDomains = welcomeMsg.available_domains;
            if (welcomeMsg.options) {
                this.token = welcomeMsg.options.access_token;
                this.info = welcomeMsg.options.info;
            }
            this.setLoggedIn(true);
            return welcomeMsg.resolved_identity;
        }
        catch (err) {
            this.logger.error("error sending hello message - " + (err.message || err.msg || err.reason || err), err);
            throw err;
        }
        finally {
            if (config?.flowCallback && config.sessionId) {
                config.flowCallback(config.sessionId, null);
            }
        }
    }
    async tryAuthenticate(globalDomain, helloMsg, sendOptions, config) {
        let welcomeMsg;
        while (true) {
            const msg = await globalDomain.send(helloMsg, undefined, sendOptions);
            if (msg.type === "authentication-request") {
                const token = Buffer.from(msg.authentication.token, "base64");
                if (config.flowCallback && config.sessionId) {
                    helloMsg.authentication.token =
                        (await config.flowCallback(config.sessionId, token))
                            .data
                            .toString("base64");
                }
                helloMsg.request_id = config.sessionId;
            }
            else if (msg.type === "welcome") {
                welcomeMsg = msg;
                break;
            }
            else if (msg.type === "error") {
                throw new Error("Authentication failed: " + msg.reason);
            }
            else {
                throw new Error("Unexpected message type during authentication: " + msg.type);
            }
        }
        return welcomeMsg;
    }
    async setupAuthConfig(config, reconnect) {
        const authentication = {};
        this.gatewayToken = config.gatewayToken;
        if (config.gatewayToken) {
            if (reconnect) {
                try {
                    config.gatewayToken = await this.getNewGWToken();
                }
                catch (e) {
                    this.logger.warn(`failed to get GW token when reconnecting ${e?.message || e}`);
                }
            }
            authentication.method = "gateway-token";
            authentication.token = config.gatewayToken;
            this.gatewayToken = config.gatewayToken;
        }
        else if (config.flowName === "sspi") {
            authentication.provider = "win";
            authentication.method = "access-token";
            if (config.flowCallback && config.sessionId) {
                authentication.token =
                    (await config.flowCallback(config.sessionId, null))
                        .data
                        .toString("base64");
            }
            else {
                throw new Error("Invalid SSPI config");
            }
        }
        else if (config.token) {
            authentication.method = "access-token";
            authentication.token = config.token;
        }
        else if (config.username) {
            authentication.method = "secret";
            authentication.login = config.username;
            authentication.secret = config.password;
        }
        else if (config.provider) {
            authentication.provider = config.provider;
            authentication.providerContext = config.providerContext;
        }
        else {
            throw new Error("invalid auth message" + JSON.stringify(config));
        }
        return authentication;
    }
    async logoutCore() {
        this.logger.debug("logging out...");
        this.shouldTryLogin = false;
        if (this.pingTimer) {
            clearTimeout(this.pingTimer);
        }
        const promises = this.sessions.map((session) => {
            session.leave();
        });
        await Promise.all(promises);
    }
    getNewGWToken() {
        if (typeof window !== "undefined") {
            const glue42gd = window.glue42gd;
            if (glue42gd) {
                return glue42gd.getGWToken();
            }
        }
        return Promise.reject(new Error("not running in GD"));
    }
    ping() {
        if (!this.shouldTryLogin) {
            return;
        }
        if (this._isLoggedIn) {
            this.send({ type: "ping" });
        }
        this.pingTimer = setTimeout(() => {
            this.ping();
        }, 30 * 1000);
    }
}

const order = ["trace", "debug", "info", "warn", "error", "off"];
class Logger {
    name;
    parent;
    static Interop;
    static InteropMethodName = "T42.AppLogger.Log";
    static Instance;
    path;
    subLoggers = [];
    _consoleLevel;
    _publishLevel;
    loggerFullName;
    includeTimeAndLevel;
    logFn = console;
    customLogFn = false;
    constructor(name, parent, logFn) {
        this.name = name;
        this.parent = parent;
        this.name = name;
        if (parent) {
            this.path = `${parent.path}.${name}`;
        }
        else {
            this.path = name;
        }
        this.loggerFullName = `[${this.path}]`;
        this.includeTimeAndLevel = !logFn;
        if (logFn) {
            this.logFn = logFn;
            this.customLogFn = true;
        }
    }
    subLogger(name) {
        const existingSub = this.subLoggers.filter((subLogger) => {
            return subLogger.name === name;
        })[0];
        if (existingSub !== undefined) {
            return existingSub;
        }
        Object.keys(this).forEach((key) => {
            if (key === name) {
                throw new Error("This sub logger name is not allowed.");
            }
        });
        const sub = new Logger(name, this, this.customLogFn ? this.logFn : undefined);
        this.subLoggers.push(sub);
        return sub;
    }
    publishLevel(level) {
        if (level) {
            this._publishLevel = level;
        }
        return this._publishLevel || this.parent?.publishLevel();
    }
    consoleLevel(level) {
        if (level) {
            this._consoleLevel = level;
        }
        return this._consoleLevel || this.parent?.consoleLevel();
    }
    log(message, level, error) {
        this.publishMessage(level || "info", message, error);
    }
    trace(message) {
        this.log(message, "trace");
    }
    debug(message) {
        this.log(message, "debug");
    }
    info(message) {
        this.log(message, "info");
    }
    warn(message) {
        this.log(message, "warn");
    }
    error(message, err) {
        this.log(message, "error", err);
    }
    canPublish(level, compareWith) {
        const levelIdx = order.indexOf(level);
        const restrictionIdx = order.indexOf(compareWith || this.consoleLevel() || "trace");
        return levelIdx >= restrictionIdx;
    }
    publishMessage(level, message, error) {
        const loggerName = this.loggerFullName;
        if (level === "error" && !error) {
            const e = new Error();
            if (e.stack) {
                message =
                    message +
                        "\n" +
                        e.stack
                            .split("\n")
                            .slice(4)
                            .join("\n");
            }
        }
        if (this.canPublish(level, this.publishLevel())) {
            const interop = Logger.Interop;
            if (interop) {
                try {
                    if (interop.methods({ name: Logger.InteropMethodName }).length > 0) {
                        const args = {
                            msg: message,
                            logger: loggerName,
                            level
                        };
                        if (error && error instanceof Error) {
                            args.error = {
                                message: error.message,
                                stack: error.stack ?? ""
                            };
                        }
                        interop.invoke(Logger.InteropMethodName, args);
                    }
                }
                catch {
                }
            }
        }
        if (this.canPublish(level)) {
            let prefix = "";
            if (this.includeTimeAndLevel) {
                const date = new Date();
                const time = `${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}:${date.getMilliseconds()}`;
                prefix = `[${time}] [${level}] `;
            }
            const toPrint = `${prefix}${loggerName}: ${message}`;
            switch (level) {
                case "trace":
                    this.logFn.debug(toPrint);
                    break;
                case "debug":
                    if (this.logFn.debug) {
                        this.logFn.debug(toPrint);
                    }
                    else {
                        this.logFn.log(toPrint);
                    }
                    break;
                case "info":
                    this.logFn.info(toPrint);
                    break;
                case "warn":
                    this.logFn.warn(toPrint);
                    break;
                case "error":
                    this.logFn.error(toPrint, error);
                    break;
            }
        }
    }
}

const GW_MESSAGE_CREATE_CONTEXT = "create-context";
const GW_MESSAGE_ACTIVITY_CREATED = "created";
const GW_MESSAGE_ACTIVITY_DESTROYED = "destroyed";
const GW_MESSAGE_CONTEXT_CREATED = "context-created";
const GW_MESSAGE_CONTEXT_ADDED = "context-added";
const GW_MESSAGE_SUBSCRIBE_CONTEXT = "subscribe-context";
const GW_MESSAGE_SUBSCRIBED_CONTEXT = "subscribed-context";
const GW_MESSAGE_UNSUBSCRIBE_CONTEXT = "unsubscribe-context";
const GW_MESSAGE_DESTROY_CONTEXT = "destroy-context";
const GW_MESSAGE_CONTEXT_DESTROYED = "context-destroyed";
const GW_MESSAGE_UPDATE_CONTEXT = "update-context";
const GW_MESSAGE_CONTEXT_UPDATED = "context-updated";
const GW_MESSAGE_JOINED_ACTIVITY = "joined";

const ContextMessageReplaySpec = {
    get name() {
        return "context";
    },
    get types() {
        return [
            GW_MESSAGE_CREATE_CONTEXT,
            GW_MESSAGE_ACTIVITY_CREATED,
            GW_MESSAGE_ACTIVITY_DESTROYED,
            GW_MESSAGE_CONTEXT_CREATED,
            GW_MESSAGE_CONTEXT_ADDED,
            GW_MESSAGE_SUBSCRIBE_CONTEXT,
            GW_MESSAGE_SUBSCRIBED_CONTEXT,
            GW_MESSAGE_UNSUBSCRIBE_CONTEXT,
            GW_MESSAGE_DESTROY_CONTEXT,
            GW_MESSAGE_CONTEXT_DESTROYED,
            GW_MESSAGE_UPDATE_CONTEXT,
            GW_MESSAGE_CONTEXT_UPDATED,
            GW_MESSAGE_JOINED_ACTIVITY
        ];
    }
};

var version = "6.5.2";

function prepareConfig (configuration, ext, glue42gd) {
    let nodeStartingContext;
    if (Utils.isNode()) {
        const startingContextString = process.env._GD_STARTING_CONTEXT_;
        if (startingContextString) {
            try {
                nodeStartingContext = JSON.parse(startingContextString);
            }
            catch {
            }
        }
    }
    function getConnection() {
        const gwConfig = configuration.gateway;
        const protocolVersion = gwConfig?.protocolVersion ?? 3;
        const reconnectInterval = gwConfig?.reconnectInterval;
        const reconnectAttempts = gwConfig?.reconnectAttempts;
        const defaultWs = "ws://localhost:8385";
        let ws = gwConfig?.ws;
        const sharedWorker = gwConfig?.sharedWorker;
        const inproc = gwConfig?.inproc;
        const webPlatform = gwConfig?.webPlatform ?? undefined;
        if (glue42gd) {
            ws = glue42gd.gwURL;
        }
        if (Utils.isNode() && nodeStartingContext && nodeStartingContext.gwURL) {
            ws = nodeStartingContext.gwURL;
        }
        if (!ws && !sharedWorker && !inproc) {
            ws = defaultWs;
        }
        let instanceId;
        let windowId;
        let pid;
        let environment;
        let region;
        const appName = getApplication();
        let uniqueAppName = appName;
        if (typeof glue42gd !== "undefined") {
            windowId = glue42gd.windowId;
            pid = glue42gd.pid;
            if (glue42gd.env) {
                environment = glue42gd.env.env;
                region = glue42gd.env.region;
            }
            uniqueAppName = glue42gd.application ?? "glue-app";
            instanceId = glue42gd.appInstanceId;
        }
        else if (Utils.isNode()) {
            pid = process.pid;
            if (nodeStartingContext) {
                environment = nodeStartingContext.env;
                region = nodeStartingContext.region;
                instanceId = nodeStartingContext.instanceId;
            }
        }
        else if (typeof window?.glue42electron !== "undefined") {
            windowId = window?.glue42electron.instanceId;
            pid = window?.glue42electron.pid;
            environment = window?.glue42electron.env;
            region = window?.glue42electron.region;
            uniqueAppName = window?.glue42electron.application ?? "glue-app";
            instanceId = window?.glue42electron.instanceId;
        }
        else ;
        const replaySpecs = configuration.gateway?.replaySpecs ?? [];
        replaySpecs.push(ContextMessageReplaySpec);
        let identity = {
            application: uniqueAppName,
            applicationName: appName,
            windowId,
            instance: instanceId,
            process: pid,
            region,
            environment,
            api: ext.version || version
        };
        if (configuration.identity) {
            identity = Object.assign(identity, configuration.identity);
        }
        return {
            identity,
            reconnectInterval,
            ws,
            sharedWorker,
            webPlatform,
            inproc,
            protocolVersion,
            reconnectAttempts,
            replaySpecs,
        };
    }
    function getContexts() {
        if (typeof configuration.contexts === "undefined") {
            return { reAnnounceKnownContexts: true };
        }
        if (typeof configuration.contexts === "boolean" && configuration.contexts) {
            return { reAnnounceKnownContexts: true };
        }
        if (typeof configuration.contexts === "object") {
            return Object.assign({}, { reAnnounceKnownContexts: true }, configuration.contexts);
        }
        return false;
    }
    function getApplication() {
        if (configuration.application) {
            return configuration.application;
        }
        if (glue42gd) {
            return glue42gd.applicationName;
        }
        if (typeof window !== "undefined" && typeof window.glue42electron !== "undefined") {
            return window.glue42electron.application;
        }
        const uid = nanoid(10);
        if (Utils.isNode()) {
            if (nodeStartingContext) {
                return nodeStartingContext.applicationConfig.name;
            }
            return "NodeJS" + uid;
        }
        if (typeof window !== "undefined" && typeof document !== "undefined") {
            return document.title + ` (${uid})`;
        }
        return uid;
    }
    function getAuth() {
        if (typeof configuration.auth === "string") {
            return {
                token: configuration.auth
            };
        }
        if (configuration.auth) {
            return configuration.auth;
        }
        if (Utils.isNode() && nodeStartingContext && nodeStartingContext.gwToken) {
            return {
                gatewayToken: nodeStartingContext.gwToken
            };
        }
        if (configuration.gateway?.webPlatform || configuration.gateway?.inproc || configuration.gateway?.sharedWorker) {
            return {
                username: "glue42", password: "glue42"
            };
        }
    }
    function getLogger() {
        let config = configuration.logger;
        const defaultLevel = "warn";
        if (!config) {
            config = defaultLevel;
        }
        let gdConsoleLevel;
        if (glue42gd) {
            gdConsoleLevel = glue42gd.consoleLogLevel;
        }
        if (typeof config === "string") {
            return { console: gdConsoleLevel ?? config, publish: defaultLevel };
        }
        return {
            console: gdConsoleLevel ?? config.console ?? defaultLevel,
            publish: config.publish ?? defaultLevel
        };
    }
    const connection = getConnection();
    let application = getApplication();
    if (typeof window !== "undefined") {
        const windowAsAny = window;
        const containerApplication = windowAsAny.htmlContainer ?
            `${windowAsAny.htmlContainer.containerName}.${windowAsAny.htmlContainer.application}` :
            windowAsAny?.glue42gd?.application;
        if (containerApplication) {
            application = containerApplication;
        }
    }
    return {
        bus: configuration.bus ?? false,
        application,
        auth: getAuth(),
        logger: getLogger(),
        connection,
        metrics: configuration.metrics ?? true,
        contexts: getContexts(),
        version: ext.version || version,
        libs: ext.libs ?? [],
        customLogger: configuration.customLogger
    };
}

class GW3ContextData {
    name;
    contextId;
    context;
    isAnnounced;
    joinedActivity;
    updateCallbacks = {};
    activityId;
    sentExplicitSubscription;
    hasReceivedSnapshot;
    constructor(contextId, name, isAnnounced, activityId) {
        this.contextId = contextId;
        this.name = name;
        this.isAnnounced = isAnnounced;
        this.activityId = activityId;
        this.context = {};
    }
    hasCallbacks() {
        return Object.keys(this.updateCallbacks).length > 0;
    }
    getState() {
        if (this.isAnnounced && this.hasCallbacks()) {
            return 3;
        }
        if (this.isAnnounced) {
            return 2;
        }
        if (this.hasCallbacks()) {
            return 1;
        }
        return 0;
    }
}

var lodash_clonedeep = {exports: {}};

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
lodash_clonedeep.exports;

(function (module, exports) {
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;

	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';

	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';

	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;

	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;

	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;

	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;

	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();

	/** Detect free variable `exports`. */
	var freeExports = exports && !exports.nodeType && exports;

	/** Detect free variable `module`. */
	var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;

	/**
	 * Adds the key-value `pair` to `map`.
	 *
	 * @private
	 * @param {Object} map The map to modify.
	 * @param {Array} pair The key-value pair to add.
	 * @returns {Object} Returns `map`.
	 */
	function addMapEntry(map, pair) {
	  // Don't return `map.set` because it's not chainable in IE 11.
	  map.set(pair[0], pair[1]);
	  return map;
	}

	/**
	 * Adds `value` to `set`.
	 *
	 * @private
	 * @param {Object} set The set to modify.
	 * @param {*} value The value to add.
	 * @returns {Object} Returns `set`.
	 */
	function addSetEntry(set, value) {
	  // Don't return `set.add` because it's not chainable in IE 11.
	  set.add(value);
	  return set;
	}

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array ? array.length : 0;

	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;

	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}

	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array ? array.length : 0;
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);

	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}

	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);

	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);

	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}

	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;

	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];

	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());

	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;

	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;

	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;

	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);

	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    Symbol = root.Symbol,
	    Uint8Array = root.Uint8Array,
	    getPrototype = overArg(Object.getPrototypeOf, Object),
	    objectCreate = Object.create,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice;

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols,
	    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	    nativeKeys = overArg(Object.keys, Object);

	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView'),
	    Map = getNative(root, 'Map'),
	    Promise = getNative(root, 'Promise'),
	    Set = getNative(root, 'Set'),
	    WeakMap = getNative(root, 'WeakMap'),
	    nativeCreate = getNative(Object, 'create');

	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);

	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;

	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}

	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}

	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}

	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}

	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}

	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;

	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;

	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}

	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);

	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}

	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);

	  return index < 0 ? undefined : data[index][1];
	}

	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}

	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);

	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}

	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;

	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;

	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}

	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}

	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}

	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}

	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}

	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}

	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;

	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  this.__data__ = new ListCache(entries);
	}

	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	}

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  return this.__data__['delete'](key);
	}

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}

	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var cache = this.__data__;
	  if (cache instanceof ListCache) {
	    var pairs = cache.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      return this;
	    }
	    cache = this.__data__ = new MapCache(pairs);
	  }
	  cache.set(key, value);
	  return this;
	}

	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;

	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  // Safari 9 makes `arguments.length` enumerable in strict mode.
	  var result = (isArray(value) || isArguments(value))
	    ? baseTimes(value.length, String)
	    : [];

	  var length = result.length,
	      skipIndexes = !!length;

	  for (var key in value) {
	    if ((hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}

	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    object[key] = value;
	  }
	}

	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}

	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}

	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @param {boolean} [isFull] Specify a clone including symbols.
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
	  var result;
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;

	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      if (isHostObject(value)) {
	        return object ? value : {};
	      }
	      result = initCloneObject(isFunc ? {} : value);
	      if (!isDeep) {
	        return copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, baseClone, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);

	  if (!isArr) {
	    var props = isFull ? getAllKeys(value) : keys(value);
	  }
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    // Recursively populate clone (susceptible to call stack limits).
	    assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
	  });
	  return result;
	}

	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} prototype The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	function baseCreate(proto) {
	  return isObject(proto) ? objectCreate(proto) : {};
	}

	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}

	/**
	 * The base implementation of `getTag`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  return objectToString.call(value);
	}

	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}

	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}

	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var result = new buffer.constructor(buffer.length);
	  buffer.copy(result);
	  return result;
	}

	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}

	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}

	/**
	 * Creates a clone of `map`.
	 *
	 * @private
	 * @param {Object} map The map to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned map.
	 */
	function cloneMap(map, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
	  return arrayReduce(array, addMapEntry, new map.constructor);
	}

	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}

	/**
	 * Creates a clone of `set`.
	 *
	 * @private
	 * @param {Object} set The set to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned set.
	 */
	function cloneSet(set, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
	  return arrayReduce(array, addSetEntry, new set.constructor);
	}

	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}

	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;

	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}

	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  object || (object = {});

	  var index = -1,
	      length = props.length;

	  while (++index < length) {
	    var key = props[index];

	    var newValue = undefined;

	    assignValue(object, key, newValue === undefined ? source[key] : newValue);
	  }
	  return object;
	}

	/**
	 * Copies own symbol properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}

	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}

	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}

	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}

	/**
	 * Creates an array of the own enumerable symbol properties of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;

	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;

	// Fallback for data views, maps, sets, and weak maps in IE 11,
	// for data views in Edge < 14, and promises in Node.js.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = objectToString.call(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : undefined;

	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}

	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = array.constructor(length);

	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}

	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}

	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, cloneFunc, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);

	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);

	    case dataViewTag:
	      return cloneDataView(object, isDeep);

	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);

	    case mapTag:
	      return cloneMap(object, isDeep, cloneFunc);

	    case numberTag:
	    case stringTag:
	      return new Ctor(object);

	    case regexpTag:
	      return cloneRegExp(object);

	    case setTag:
	      return cloneSet(object, isDeep, cloneFunc);

	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}

	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}

	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}

	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

	  return value === proto;
	}

	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}

	/**
	 * This method is like `_.clone` except that it recursively clones `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.0.0
	 * @category Lang
	 * @param {*} value The value to recursively clone.
	 * @returns {*} Returns the deep cloned value.
	 * @see _.clone
	 * @example
	 *
	 * var objects = [{ 'a': 1 }, { 'b': 2 }];
	 *
	 * var deep = _.cloneDeep(objects);
	 * console.log(deep[0] === objects[0]);
	 * // => false
	 */
	function cloneDeep(value) {
	  return baseClone(value, true, true);
	}

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}

	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;

	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}

	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}

	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;

	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}

	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}

	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}

	module.exports = cloneDeep; 
} (lodash_clonedeep, lodash_clonedeep.exports));

var lodash_clonedeepExports = lodash_clonedeep.exports;
var cloneDeep = /*@__PURE__*/getDefaultExportFromCjs(lodash_clonedeepExports);

function applyContextDelta(context, delta, logger) {
    try {
        if (logger?.canPublish("trace")) {
            logger?.trace(`applying context delta ${JSON.stringify(delta)} on context ${JSON.stringify(context)}`);
        }
        if (!delta) {
            return context;
        }
        if (delta.reset) {
            context = { ...delta.reset };
            return context;
        }
        context = deepClone(context, undefined);
        if (delta.commands) {
            for (const command of delta.commands) {
                if (command.type === "remove") {
                    deletePath(context, command.path);
                }
                else if (command.type === "set") {
                    setValueToPath(context, command.value, command.path);
                }
            }
            return context;
        }
        const added = delta.added;
        const updated = delta.updated;
        const removed = delta.removed;
        if (added) {
            Object.keys(added).forEach((key) => {
                context[key] = added[key];
            });
        }
        if (updated) {
            Object.keys(updated).forEach((key) => {
                mergeObjectsProperties(key, context, updated);
            });
        }
        if (removed) {
            removed.forEach((key) => {
                delete context[key];
            });
        }
        return context;
    }
    catch (e) {
        logger?.error(`error applying context delta ${JSON.stringify(delta)} on context ${JSON.stringify(context)}`, e);
        return context;
    }
}
function deepClone(obj, hash) {
    return cloneDeep(obj);
}
const mergeObjectsProperties = (key, what, withWhat) => {
    const right = withWhat[key];
    if (right === undefined) {
        return what;
    }
    const left = what[key];
    if (!left || !right) {
        what[key] = right;
        return what;
    }
    if (typeof left === "string" ||
        typeof left === "number" ||
        typeof left === "boolean" ||
        typeof right === "string" ||
        typeof right === "number" ||
        typeof right === "boolean" ||
        Array.isArray(left) ||
        Array.isArray(right)) {
        what[key] = right;
        return what;
    }
    what[key] = Object.assign({}, left, right);
    return what;
};
function deepEqual(x, y) {
    if (x === y) {
        return true;
    }
    if (!(x instanceof Object) || !(y instanceof Object)) {
        return false;
    }
    if (x.constructor !== y.constructor) {
        return false;
    }
    for (const p in x) {
        if (!x.hasOwnProperty(p)) {
            continue;
        }
        if (!y.hasOwnProperty(p)) {
            return false;
        }
        if (x[p] === y[p]) {
            continue;
        }
        if (typeof (x[p]) !== "object") {
            return false;
        }
        if (!deepEqual(x[p], y[p])) {
            return false;
        }
    }
    for (const p in y) {
        if (y.hasOwnProperty(p) && !x.hasOwnProperty(p)) {
            return false;
        }
    }
    return true;
}
function setValueToPath(obj, value, path) {
    const pathArr = path.split(".");
    let i;
    for (i = 0; i < pathArr.length - 1; i++) {
        if (!obj[pathArr[i]]) {
            obj[pathArr[i]] = {};
        }
        if (typeof obj[pathArr[i]] !== "object") {
            obj[pathArr[i]] = {};
        }
        obj = obj[pathArr[i]];
    }
    obj[pathArr[i]] = value;
}
function isSubset(superObj, subObj) {
    return Object.keys(subObj).every((ele) => {
        if (typeof subObj[ele] === "object") {
            return isSubset(superObj?.[ele] || {}, subObj[ele] || {});
        }
        return subObj[ele] === superObj?.[ele];
    });
}
function deletePath(obj, path) {
    const pathArr = path.split(".");
    let i;
    for (i = 0; i < pathArr.length - 1; i++) {
        if (!obj[pathArr[i]]) {
            return;
        }
        obj = obj[pathArr[i]];
    }
    delete obj[pathArr[i]];
}

class GW3Bridge {
    _logger;
    _connection;
    _trackAllContexts;
    _reAnnounceKnownContexts;
    _gw3Session;
    _contextNameToData = {};
    _gw3Subscriptions = [];
    _nextCallbackSubscriptionNumber = 0;
    _creationPromises = {};
    _contextNameToId = {};
    _contextIdToName = {};
    _protocolVersion = undefined;
    _contextsTempCache = {};
    _contextsSubscriptionsCache = [];
    _systemContextsSubKey;
    get protocolVersion() {
        if (!this._protocolVersion) {
            const contextsDomainInfo = this._connection.availableDomains.find((d) => d.uri === "context");
            this._protocolVersion = contextsDomainInfo?.version ?? 1;
        }
        return this._protocolVersion;
    }
    get setPathSupported() {
        return this.protocolVersion >= 2;
    }
    constructor(config) {
        this._connection = config.connection;
        this._logger = config.logger;
        this._trackAllContexts = config.trackAllContexts;
        this._reAnnounceKnownContexts = config.reAnnounceKnownContexts;
        this._gw3Session = this._connection.domain("global", [
            GW_MESSAGE_CONTEXT_CREATED,
            GW_MESSAGE_SUBSCRIBED_CONTEXT,
            GW_MESSAGE_CONTEXT_DESTROYED,
            GW_MESSAGE_CONTEXT_UPDATED,
        ]);
        this._gw3Session.disconnected(this.resetState.bind(this));
        this._gw3Session.onJoined((wasReconnect) => {
            if (!wasReconnect) {
                return;
            }
            if (!this._reAnnounceKnownContexts) {
                return this._connection.setLibReAnnounced({ name: "contexts" });
            }
            this.reInitiateState().then(() => this._connection.setLibReAnnounced({ name: "contexts" }));
        });
        this.subscribeToContextCreatedMessages();
        this.subscribeToContextUpdatedMessages();
        this.subscribeToContextDestroyedMessages();
        this._connection.replayer?.drain(ContextMessageReplaySpec.name, (message) => {
            const type = message.type;
            if (!type) {
                return;
            }
            if (type === GW_MESSAGE_CONTEXT_CREATED ||
                type === GW_MESSAGE_CONTEXT_ADDED ||
                type === GW_MESSAGE_ACTIVITY_CREATED) {
                this.handleContextCreatedMessage(message);
            }
            else if (type === GW_MESSAGE_SUBSCRIBED_CONTEXT ||
                type === GW_MESSAGE_CONTEXT_UPDATED ||
                type === GW_MESSAGE_JOINED_ACTIVITY) {
                this.handleContextUpdatedMessage(message);
            }
            else if (type === GW_MESSAGE_CONTEXT_DESTROYED ||
                type === GW_MESSAGE_ACTIVITY_DESTROYED) {
                this.handleContextDestroyedMessage(message);
            }
        });
    }
    dispose() {
        for (const sub of this._gw3Subscriptions) {
            this._connection.off(sub);
        }
        this._gw3Subscriptions.length = 0;
        for (const contextName in this._contextNameToData) {
            if (this._contextNameToId.hasOwnProperty(contextName)) {
                delete this._contextNameToData[contextName];
            }
        }
    }
    createContext(name, data) {
        if (name in this._creationPromises) {
            return this._creationPromises[name];
        }
        this._creationPromises[name] =
            this._gw3Session
                .send({
                type: GW_MESSAGE_CREATE_CONTEXT,
                domain: "global",
                name,
                data,
                lifetime: "retained",
            })
                .then((createContextMsg) => {
                this._contextNameToId[name] = createContextMsg.context_id;
                this._contextIdToName[createContextMsg.context_id] = name;
                const contextData = this._contextNameToData[name] || new GW3ContextData(createContextMsg.context_id, name, true, undefined);
                contextData.isAnnounced = true;
                contextData.name = name;
                contextData.contextId = createContextMsg.context_id;
                contextData.context = createContextMsg.data || deepClone(data);
                contextData.hasReceivedSnapshot = true;
                this._contextNameToData[name] = contextData;
                delete this._creationPromises[name];
                return createContextMsg.context_id;
            });
        return this._creationPromises[name];
    }
    all() {
        return Object.keys(this._contextNameToData)
            .filter((name) => this._contextNameToData[name].isAnnounced);
    }
    async update(name, delta) {
        if (delta) {
            delta = deepClone(delta);
        }
        if (name in this._creationPromises) {
            await this._creationPromises[name];
        }
        const contextData = this._contextNameToData[name];
        if (!contextData || !contextData.isAnnounced) {
            return this.createContext(name, delta);
        }
        let currentContext = contextData.context;
        if (!contextData.hasCallbacks()) {
            currentContext = await this.get(contextData.name);
        }
        const calculatedDelta = this.setPathSupported ?
            this.calculateContextDeltaV2(currentContext, delta) :
            this.calculateContextDeltaV1(currentContext, delta);
        if (!Object.keys(calculatedDelta.added).length
            && !Object.keys(calculatedDelta.updated).length
            && !calculatedDelta.removed.length
            && !calculatedDelta.commands?.length) {
            return Promise.resolve();
        }
        return this._gw3Session
            .send({
            type: GW_MESSAGE_UPDATE_CONTEXT,
            domain: "global",
            context_id: contextData.contextId,
            delta: calculatedDelta,
        }, {}, { skipPeerId: false })
            .then((gwResponse) => {
            this.handleUpdated(contextData, calculatedDelta, {
                updaterId: gwResponse.peer_id
            });
        });
    }
    async set(name, data) {
        if (data) {
            data = deepClone(data);
        }
        if (name in this._creationPromises) {
            await this._creationPromises[name];
        }
        const contextData = this._contextNameToData[name];
        if (!contextData || !contextData.isAnnounced) {
            return this.createContext(name, data);
        }
        return this._gw3Session
            .send({
            type: GW_MESSAGE_UPDATE_CONTEXT,
            domain: "global",
            context_id: contextData.contextId,
            delta: { reset: data },
        }, {}, { skipPeerId: false })
            .then((gwResponse) => {
            this.handleUpdated(contextData, {
                reset: data,
                added: {},
                removed: [],
                updated: {}
            }, {
                updaterId: gwResponse.peer_id
            });
        });
    }
    setPath(name, path, value) {
        if (!this.setPathSupported) {
            return Promise.reject("glue.contexts.setPath operation is not supported, use Glue42 3.10 or later");
        }
        return this.setPaths(name, [{ path, value }]);
    }
    async setPaths(name, pathValues) {
        if (!this.setPathSupported) {
            return Promise.reject("glue.contexts.setPaths operation is not supported, use Glue42 3.10 or later");
        }
        if (pathValues) {
            pathValues = deepClone(pathValues);
        }
        if (name in this._creationPromises) {
            await this._creationPromises[name];
        }
        const contextData = this._contextNameToData[name];
        if (!contextData || !contextData.isAnnounced) {
            const obj = {};
            for (const pathValue of pathValues) {
                setValueToPath(obj, pathValue.value, pathValue.path);
            }
            return this.createContext(name, obj);
        }
        const commands = [];
        for (const pathValue of pathValues) {
            if (pathValue.value === null) {
                commands.push({ type: "remove", path: pathValue.path });
            }
            else {
                commands.push({ type: "set", path: pathValue.path, value: pathValue.value });
            }
        }
        return this._gw3Session
            .send({
            type: GW_MESSAGE_UPDATE_CONTEXT,
            domain: "global",
            context_id: contextData.contextId,
            delta: { commands }
        }, {}, { skipPeerId: false })
            .then((gwResponse) => {
            this.handleUpdated(contextData, {
                added: {},
                removed: [],
                updated: {},
                commands
            }, {
                updaterId: gwResponse.peer_id
            });
        });
    }
    async get(name) {
        if (name in this._creationPromises) {
            await this._creationPromises[name];
        }
        const contextData = this._contextNameToData[name];
        if (!contextData || !contextData.isAnnounced) {
            return Promise.resolve({});
        }
        if (contextData && (!contextData.hasCallbacks() || !contextData.hasReceivedSnapshot)) {
            return new Promise((resolve) => {
                this.subscribe(name, (data, _d, _r, un) => {
                    this.unsubscribe(un);
                    resolve(data);
                });
            });
        }
        const context = contextData?.context ?? {};
        return Promise.resolve(deepClone(context));
    }
    async subscribe(name, callback, subscriptionKey) {
        if (name in this._creationPromises) {
            await this._creationPromises[name];
        }
        const thisCallbackSubscriptionNumber = typeof subscriptionKey === "undefined" ? this._nextCallbackSubscriptionNumber : subscriptionKey;
        if (typeof subscriptionKey === "undefined") {
            this._nextCallbackSubscriptionNumber += 1;
        }
        if (this._contextsSubscriptionsCache.every((subscription) => subscription.subKey !== this._nextCallbackSubscriptionNumber)) {
            this._contextsSubscriptionsCache.push({ contextName: name, subKey: thisCallbackSubscriptionNumber, callback });
        }
        let contextData = this._contextNameToData[name];
        if (!contextData ||
            !contextData.isAnnounced) {
            contextData = contextData || new GW3ContextData(undefined, name, false, undefined);
            this._contextNameToData[name] = contextData;
            contextData.updateCallbacks[thisCallbackSubscriptionNumber] = callback;
            return Promise.resolve(thisCallbackSubscriptionNumber);
        }
        const hadCallbacks = contextData.hasCallbacks();
        contextData.updateCallbacks[thisCallbackSubscriptionNumber] = callback;
        if (!hadCallbacks) {
            if (!contextData.joinedActivity) {
                if (contextData.context && contextData.sentExplicitSubscription) {
                    if (contextData.hasReceivedSnapshot) {
                        const clone = deepClone(contextData.context);
                        callback(clone, clone, [], thisCallbackSubscriptionNumber);
                    }
                    return Promise.resolve(thisCallbackSubscriptionNumber);
                }
                return this.sendSubscribe(contextData)
                    .then(() => thisCallbackSubscriptionNumber);
            }
            else {
                if (contextData.hasReceivedSnapshot) {
                    const clone = deepClone(contextData.context);
                    callback(clone, clone, [], thisCallbackSubscriptionNumber);
                }
                return Promise.resolve(thisCallbackSubscriptionNumber);
            }
        }
        else {
            if (contextData.hasReceivedSnapshot) {
                const clone = deepClone(contextData.context);
                callback(clone, clone, [], thisCallbackSubscriptionNumber);
            }
            return Promise.resolve(thisCallbackSubscriptionNumber);
        }
    }
    unsubscribe(subscriptionKey) {
        this._contextsSubscriptionsCache = this._contextsSubscriptionsCache.filter((subscription) => subscription.subKey !== subscriptionKey);
        for (const name of Object.keys(this._contextNameToData)) {
            const contextData = this._contextNameToData[name];
            if (!contextData) {
                return;
            }
            const hadCallbacks = contextData.hasCallbacks();
            delete contextData.updateCallbacks[subscriptionKey];
            if (contextData.isAnnounced &&
                hadCallbacks &&
                !contextData.hasCallbacks() &&
                contextData.sentExplicitSubscription) {
                this.sendUnsubscribe(contextData).catch(() => { });
            }
            if (!contextData.isAnnounced &&
                !contextData.hasCallbacks()) {
                delete this._contextNameToData[name];
            }
        }
    }
    async destroy(name) {
        if (name in this._creationPromises) {
            await this._creationPromises[name];
        }
        const contextData = this._contextNameToData[name];
        if (!contextData) {
            return Promise.reject(`context with ${name} does not exist`);
        }
        return this._gw3Session
            .send({
            type: GW_MESSAGE_DESTROY_CONTEXT,
            domain: "global",
            context_id: contextData.contextId,
        }).then((_) => undefined);
    }
    handleUpdated(contextData, delta, extraData) {
        const oldContext = contextData.context;
        contextData.context = applyContextDelta(contextData.context, delta, this._logger);
        contextData.hasReceivedSnapshot = true;
        if (this._contextNameToData[contextData.name] === contextData &&
            !deepEqual(oldContext, contextData.context)) {
            this.invokeUpdateCallbacks(contextData, delta, extraData);
        }
    }
    subscribeToContextCreatedMessages() {
        const createdMessageTypes = [
            GW_MESSAGE_CONTEXT_ADDED,
            GW_MESSAGE_CONTEXT_CREATED,
            GW_MESSAGE_ACTIVITY_CREATED,
        ];
        for (const createdMessageType of createdMessageTypes) {
            const sub = this._connection.on(createdMessageType, this.handleContextCreatedMessage.bind(this));
            this._gw3Subscriptions.push(sub);
        }
    }
    handleContextCreatedMessage(contextCreatedMsg) {
        const createdMessageType = contextCreatedMsg.type;
        if (createdMessageType === GW_MESSAGE_ACTIVITY_CREATED) {
            this._contextNameToId[contextCreatedMsg.activity_id] = contextCreatedMsg.context_id;
            this._contextIdToName[contextCreatedMsg.context_id] = contextCreatedMsg.activity_id;
        }
        else if (createdMessageType === GW_MESSAGE_CONTEXT_ADDED) {
            this._contextNameToId[contextCreatedMsg.name] = contextCreatedMsg.context_id;
            this._contextIdToName[contextCreatedMsg.context_id] = contextCreatedMsg.name;
        }
        else ;
        const name = this._contextIdToName[contextCreatedMsg.context_id];
        if (!name) {
            throw new Error("Received created event for context with unknown name: " + contextCreatedMsg.context_id);
        }
        if (!this._contextNameToId[name]) {
            throw new Error("Received created event for context with unknown id: " + contextCreatedMsg.context_id);
        }
        let contextData = this._contextNameToData[name];
        if (contextData) {
            if (contextData.isAnnounced) {
                return;
            }
            else {
                if (!contextData.hasCallbacks()) {
                    throw new Error("Assertion failure: contextData.hasCallbacks()");
                }
                contextData.isAnnounced = true;
                contextData.contextId = contextCreatedMsg.context_id;
                contextData.activityId = contextCreatedMsg.activity_id;
                if (!contextData.sentExplicitSubscription) {
                    this.sendSubscribe(contextData);
                }
            }
        }
        else {
            this._contextNameToData[name] = contextData =
                new GW3ContextData(contextCreatedMsg.context_id, name, true, contextCreatedMsg.activity_id);
            if (this._trackAllContexts) {
                this.subscribe(name, () => { }).then((subKey) => this._systemContextsSubKey = subKey);
            }
        }
    }
    subscribeToContextUpdatedMessages() {
        const updatedMessageTypes = [
            GW_MESSAGE_CONTEXT_UPDATED,
            GW_MESSAGE_SUBSCRIBED_CONTEXT,
            GW_MESSAGE_JOINED_ACTIVITY,
        ];
        for (const updatedMessageType of updatedMessageTypes) {
            const sub = this._connection.on(updatedMessageType, this.handleContextUpdatedMessage.bind(this));
            this._gw3Subscriptions.push(sub);
        }
    }
    handleContextUpdatedMessage(contextUpdatedMsg) {
        const updatedMessageType = contextUpdatedMsg.type;
        const contextId = contextUpdatedMsg.context_id;
        let contextData = this._contextNameToData[this._contextIdToName[contextId]];
        const justSeen = !contextData || !contextData.isAnnounced;
        if (updatedMessageType === GW_MESSAGE_JOINED_ACTIVITY) {
            if (!contextData) {
                contextData =
                    this._contextNameToData[contextUpdatedMsg.activity_id] ||
                        new GW3ContextData(contextId, contextUpdatedMsg.activity_id, true, contextUpdatedMsg.activity_id);
            }
            this._contextNameToData[contextUpdatedMsg.activity_id] = contextData;
            this._contextIdToName[contextId] = contextUpdatedMsg.activity_id;
            this._contextNameToId[contextUpdatedMsg.activity_id] = contextId;
            contextData.contextId = contextId;
            contextData.isAnnounced = true;
            contextData.activityId = contextUpdatedMsg.activity_id;
            contextData.joinedActivity = true;
        }
        else {
            if (!contextData || !contextData.isAnnounced) {
                if (updatedMessageType === GW_MESSAGE_SUBSCRIBED_CONTEXT) {
                    contextData = contextData || new GW3ContextData(contextId, contextUpdatedMsg.name, true, undefined);
                    contextData.sentExplicitSubscription = true;
                    this._contextNameToData[contextUpdatedMsg.name] = contextData;
                    this._contextIdToName[contextId] = contextUpdatedMsg.name;
                    this._contextNameToId[contextUpdatedMsg.name] = contextId;
                }
                else {
                    this._logger.error(`Received 'update' for unknown context: ${contextId}`);
                }
                return;
            }
        }
        const oldContext = contextData.context;
        contextData.hasReceivedSnapshot = true;
        if (updatedMessageType === GW_MESSAGE_SUBSCRIBED_CONTEXT) {
            contextData.context = contextUpdatedMsg.data || {};
        }
        else if (updatedMessageType === GW_MESSAGE_JOINED_ACTIVITY) {
            contextData.context = contextUpdatedMsg.context_snapshot || {};
        }
        else if (updatedMessageType === GW_MESSAGE_CONTEXT_UPDATED) {
            contextData.context = applyContextDelta(contextData.context, contextUpdatedMsg.delta, this._logger);
        }
        else {
            throw new Error("Unrecognized context update message " + updatedMessageType);
        }
        if (justSeen ||
            !deepEqual(contextData.context, oldContext) ||
            updatedMessageType === GW_MESSAGE_SUBSCRIBED_CONTEXT) {
            this.invokeUpdateCallbacks(contextData, contextUpdatedMsg.delta, { updaterId: contextUpdatedMsg.updater_id });
        }
    }
    invokeUpdateCallbacks(contextData, delta, extraData) {
        delta = delta || { added: {}, updated: {}, reset: {}, removed: [] };
        if (delta.commands) {
            delta.added = delta.updated = delta.reset = {};
            delta.removed = [];
            for (const command of delta.commands) {
                if (command.type === "remove") {
                    if (command.path.indexOf(".") === -1) {
                        delta.removed.push(command.path);
                    }
                    setValueToPath(delta.updated, null, command.path);
                }
                else if (command.type === "set") {
                    setValueToPath(delta.updated, command.value, command.path);
                }
            }
        }
        for (const updateCallbackIndex in contextData.updateCallbacks) {
            if (contextData.updateCallbacks.hasOwnProperty(updateCallbackIndex)) {
                try {
                    const updateCallback = contextData.updateCallbacks[updateCallbackIndex];
                    updateCallback(deepClone(contextData.context), deepClone(Object.assign({}, delta.added || {}, delta.updated || {}, delta.reset || {})), delta.removed, parseInt(updateCallbackIndex, 10), extraData);
                }
                catch (err) {
                    this._logger.debug("callback error: " + JSON.stringify(err));
                }
            }
        }
    }
    subscribeToContextDestroyedMessages() {
        const destroyedMessageTypes = [
            GW_MESSAGE_CONTEXT_DESTROYED,
            GW_MESSAGE_ACTIVITY_DESTROYED,
        ];
        for (const destroyedMessageType of destroyedMessageTypes) {
            const sub = this._connection.on(destroyedMessageType, this.handleContextDestroyedMessage.bind(this));
            this._gw3Subscriptions.push(sub);
        }
    }
    handleContextDestroyedMessage(destroyedMsg) {
        const destroyedMessageType = destroyedMsg.type;
        let contextId;
        let name;
        if (destroyedMessageType === GW_MESSAGE_ACTIVITY_DESTROYED) {
            name = destroyedMsg.activity_id;
            contextId = this._contextNameToId[name];
            if (!contextId) {
                this._logger.error(`Received 'destroyed' for unknown activity: ${destroyedMsg.activity_id}`);
                return;
            }
        }
        else {
            contextId = destroyedMsg.context_id;
            name = this._contextIdToName[contextId];
            if (!name) {
                this._logger.error(`Received 'destroyed' for unknown context: ${destroyedMsg.context_id}`);
                return;
            }
        }
        delete this._contextIdToName[contextId];
        delete this._contextNameToId[name];
        const contextData = this._contextNameToData[name];
        delete this._contextNameToData[name];
        if (!contextData || !contextData.isAnnounced) {
            this._logger.error(`Received 'destroyed' for unknown context: ${contextId}`);
            return;
        }
    }
    sendSubscribe(contextData) {
        contextData.sentExplicitSubscription = true;
        return this._gw3Session
            .send({
            type: GW_MESSAGE_SUBSCRIBE_CONTEXT,
            domain: "global",
            context_id: contextData.contextId,
        }).then((_) => undefined);
    }
    sendUnsubscribe(contextData) {
        contextData.sentExplicitSubscription = false;
        return this._gw3Session
            .send({
            type: GW_MESSAGE_UNSUBSCRIBE_CONTEXT,
            domain: "global",
            context_id: contextData.contextId,
        }).then((_) => undefined);
    }
    calculateContextDeltaV1(from, to) {
        const delta = { added: {}, updated: {}, removed: [], reset: undefined };
        if (from) {
            for (const x of Object.keys(from)) {
                if (Object.keys(to).indexOf(x) !== -1
                    && to[x] !== null
                    && !deepEqual(from[x], to[x])) {
                    delta.updated[x] = to[x];
                }
            }
        }
        for (const x of Object.keys(to)) {
            if (!from || (Object.keys(from).indexOf(x) === -1)) {
                if (to[x] !== null) {
                    delta.added[x] = to[x];
                }
            }
            else if (to[x] === null) {
                delta.removed.push(x);
            }
        }
        return delta;
    }
    calculateContextDeltaV2(from, to) {
        const delta = { added: {}, updated: {}, removed: [], reset: undefined, commands: [] };
        for (const x of Object.keys(to)) {
            if (to[x] !== null) {
                const fromX = from ? from[x] : null;
                if (!deepEqual(fromX, to[x])) {
                    delta.commands?.push({ type: "set", path: x, value: to[x] });
                }
            }
            else {
                delta.commands?.push({ type: "remove", path: x });
            }
        }
        return delta;
    }
    resetState() {
        for (const sub of this._gw3Subscriptions) {
            this._connection.off(sub);
        }
        if (this._systemContextsSubKey) {
            this.unsubscribe(this._systemContextsSubKey);
            delete this._systemContextsSubKey;
        }
        this._gw3Subscriptions = [];
        this._contextNameToId = {};
        this._contextIdToName = {};
        delete this._protocolVersion;
        this._contextsTempCache = Object.keys(this._contextNameToData).reduce((cacheSoFar, ctxName) => {
            cacheSoFar[ctxName] = this._contextNameToData[ctxName].context;
            return cacheSoFar;
        }, {});
        this._contextNameToData = {};
    }
    async reInitiateState() {
        this.subscribeToContextCreatedMessages();
        this.subscribeToContextUpdatedMessages();
        this.subscribeToContextDestroyedMessages();
        this._connection.replayer?.drain(ContextMessageReplaySpec.name, (message) => {
            const type = message.type;
            if (!type) {
                return;
            }
            if (type === GW_MESSAGE_CONTEXT_CREATED ||
                type === GW_MESSAGE_CONTEXT_ADDED ||
                type === GW_MESSAGE_ACTIVITY_CREATED) {
                this.handleContextCreatedMessage(message);
            }
            else if (type === GW_MESSAGE_SUBSCRIBED_CONTEXT ||
                type === GW_MESSAGE_CONTEXT_UPDATED ||
                type === GW_MESSAGE_JOINED_ACTIVITY) {
                this.handleContextUpdatedMessage(message);
            }
            else if (type === GW_MESSAGE_CONTEXT_DESTROYED ||
                type === GW_MESSAGE_ACTIVITY_DESTROYED) {
                this.handleContextDestroyedMessage(message);
            }
        });
        await Promise.all(this._contextsSubscriptionsCache.map((subscription) => this.subscribe(subscription.contextName, subscription.callback, subscription.subKey)));
        await this.flushQueue();
        for (const ctxName in this._contextsTempCache) {
            if (typeof this._contextsTempCache[ctxName] !== "object" || Object.keys(this._contextsTempCache[ctxName]).length === 0) {
                continue;
            }
            const lastKnownData = this._contextsTempCache[ctxName];
            this._logger.info(`Re-announcing known context: ${ctxName}`);
            await this.flushQueue();
            await this.update(ctxName, lastKnownData);
        }
        this._contextsTempCache = {};
        this._logger.info("Contexts are re-announced");
    }
    flushQueue() {
        return new Promise((resolve) => setTimeout(() => resolve(), 0));
    }
}

class ContextsModule {
    initTime;
    initStartTime;
    initEndTime;
    _bridge;
    constructor(config) {
        this._bridge = new GW3Bridge(config);
    }
    all() {
        return this._bridge.all();
    }
    update(name, data) {
        this.checkName(name);
        this.checkData(data);
        return this._bridge.update(name, data);
    }
    set(name, data) {
        this.checkName(name);
        this.checkData(data);
        return this._bridge.set(name, data);
    }
    setPath(name, path, data) {
        this.checkName(name);
        this.checkPath(path);
        const isTopLevelPath = path === "";
        if (isTopLevelPath) {
            this.checkData(data);
            return this.set(name, data);
        }
        return this._bridge.setPath(name, path, data);
    }
    setPaths(name, paths) {
        this.checkName(name);
        if (!Array.isArray(paths)) {
            throw new Error("Please provide the paths as an array of PathValues!");
        }
        for (const { path, value } of paths) {
            this.checkPath(path);
            const isTopLevelPath = path === "";
            if (isTopLevelPath) {
                this.checkData(value);
            }
        }
        return this._bridge.setPaths(name, paths);
    }
    subscribe(name, callback) {
        this.checkName(name);
        if (typeof callback !== "function") {
            throw new Error("Please provide the callback as a function!");
        }
        return this._bridge
            .subscribe(name, (data, delta, removed, key, extraData) => callback(data, delta, removed, () => this._bridge.unsubscribe(key), extraData))
            .then((key) => () => {
            this._bridge.unsubscribe(key);
        });
    }
    get(name) {
        this.checkName(name);
        return this._bridge.get(name);
    }
    ready() {
        return Promise.resolve(this);
    }
    destroy(name) {
        this.checkName(name);
        return this._bridge.destroy(name);
    }
    get setPathSupported() {
        return this._bridge.setPathSupported;
    }
    checkName(name) {
        if (typeof name !== "string" || name === "") {
            throw new Error("Please provide the name as a non-empty string!");
        }
    }
    checkPath(path) {
        if (typeof path !== "string") {
            throw new Error("Please provide the path as a dot delimited string!");
        }
    }
    checkData(data) {
        if (typeof data !== "object") {
            throw new Error("Please provide the data as an object!");
        }
    }
}

function promisify (promise, successCallback, errorCallback) {
    if (typeof successCallback !== "function" && typeof errorCallback !== "function") {
        return promise;
    }
    if (typeof successCallback !== "function") {
        successCallback = () => { };
    }
    else if (typeof errorCallback !== "function") {
        errorCallback = () => { };
    }
    return promise.then(successCallback, errorCallback);
}

function rejectAfter(ms = 0, promise, error) {
    let timeout;
    const clearTimeoutIfThere = () => {
        if (timeout) {
            clearTimeout(timeout);
        }
    };
    promise
        .then(() => {
        clearTimeoutIfThere();
    })
        .catch(() => {
        clearTimeoutIfThere();
    });
    return new Promise((resolve, reject) => {
        timeout = setTimeout(() => reject(error), ms);
    });
}

var InvokeStatus;
(function (InvokeStatus) {
    InvokeStatus[InvokeStatus["Success"] = 0] = "Success";
    InvokeStatus[InvokeStatus["Error"] = 1] = "Error";
})(InvokeStatus || (InvokeStatus = {}));
class Client {
    protocol;
    repo;
    instance;
    configuration;
    constructor(protocol, repo, instance, configuration) {
        this.protocol = protocol;
        this.repo = repo;
        this.instance = instance;
        this.configuration = configuration;
    }
    subscribe(method, options, successCallback, errorCallback, existingSub) {
        const callProtocolSubscribe = (targetServers, stream, successProxy, errorProxy) => {
            options.methodResponseTimeout = options.methodResponseTimeout ?? options.waitTimeoutMs;
            this.protocol.client.subscribe(stream, options, targetServers, successProxy, errorProxy, existingSub);
        };
        const promise = new Promise((resolve, reject) => {
            const successProxy = (sub) => {
                resolve(sub);
            };
            const errorProxy = (err) => {
                reject(err);
            };
            if (!method) {
                reject(`Method definition is required. Please, provide either a unique string for a method name or a “methodDefinition” object with a required “name” property.`);
                return;
            }
            let methodDef;
            if (typeof method === "string") {
                methodDef = { name: method };
            }
            else {
                methodDef = method;
            }
            if (!methodDef.name) {
                reject(`Method definition is required. Please, provide either a unique string for a method name or a “methodDefinition” object with a required “name” property.`);
                return;
            }
            if (options === undefined) {
                options = {};
            }
            let target = options.target;
            if (target === undefined) {
                target = "best";
            }
            if (typeof target === "string" && target !== "all" && target !== "best") {
                reject(new Error(`"${target}" is not a valid target. Valid targets are "all", "best", or an instance.`));
                return;
            }
            if (options.methodResponseTimeout === undefined) {
                options.methodResponseTimeout = options.method_response_timeout;
                if (options.methodResponseTimeout === undefined) {
                    options.methodResponseTimeout = this.configuration.methodResponseTimeout;
                }
            }
            if (options.waitTimeoutMs === undefined) {
                options.waitTimeoutMs = options.wait_for_method_timeout;
                if (options.waitTimeoutMs === undefined) {
                    options.waitTimeoutMs = this.configuration.waitTimeoutMs;
                }
            }
            const delayStep = 500;
            let delayTillNow = 0;
            let currentServers = this.getServerMethodsByFilterAndTarget(methodDef, target);
            if (currentServers.length > 0) {
                callProtocolSubscribe(currentServers, currentServers[0].methods[0], successProxy, errorProxy);
            }
            else {
                const retry = () => {
                    if (!target || !(options.waitTimeoutMs)) {
                        return;
                    }
                    delayTillNow += delayStep;
                    currentServers = this.getServerMethodsByFilterAndTarget(methodDef, target);
                    if (currentServers.length > 0) {
                        const streamInfo = currentServers[0].methods[0];
                        callProtocolSubscribe(currentServers, streamInfo, successProxy, errorProxy);
                    }
                    else if (delayTillNow >= options.waitTimeoutMs) {
                        const def = typeof method === "string" ? { name: method } : method;
                        callProtocolSubscribe(currentServers, def, successProxy, errorProxy);
                    }
                    else {
                        setTimeout(retry, delayStep);
                    }
                };
                setTimeout(retry, delayStep);
            }
        });
        return promisify(promise, successCallback, errorCallback);
    }
    servers(methodFilter) {
        const filterCopy = methodFilter === undefined
            ? undefined
            : { ...methodFilter };
        return this.getServers(filterCopy).map((serverMethodMap) => {
            return serverMethodMap.server.instance;
        });
    }
    methods(methodFilter) {
        if (typeof methodFilter === "string") {
            methodFilter = { name: methodFilter };
        }
        else {
            methodFilter = { ...methodFilter };
        }
        return this.getMethods(methodFilter);
    }
    methodsForInstance(instance) {
        return this.getMethodsForInstance(instance);
    }
    methodAdded(callback) {
        return this.repo.onMethodAdded(callback);
    }
    methodRemoved(callback) {
        return this.repo.onMethodRemoved(callback);
    }
    serverAdded(callback) {
        return this.repo.onServerAdded(callback);
    }
    serverRemoved(callback) {
        return this.repo.onServerRemoved((server, reason) => {
            callback(server, reason);
        });
    }
    serverMethodAdded(callback) {
        return this.repo.onServerMethodAdded((server, method) => {
            callback({ server, method });
        });
    }
    serverMethodRemoved(callback) {
        return this.repo.onServerMethodRemoved((server, method) => {
            callback({ server, method });
        });
    }
    async invoke(methodFilter, argumentObj, target, additionalOptions, success, error) {
        const getInvokePromise = async () => {
            let methodDefinition;
            if (typeof methodFilter === "string") {
                methodDefinition = { name: methodFilter };
            }
            else {
                methodDefinition = { ...methodFilter };
            }
            if (!methodDefinition.name) {
                return Promise.reject(`Method definition is required. Please, provide either a unique string for a method name or a “methodDefinition” object with a required “name” property.`);
            }
            if (!argumentObj) {
                argumentObj = {};
            }
            if (!target) {
                target = "best";
            }
            if (typeof target === "string" && target !== "all" && target !== "best" && target !== "skipMine") {
                return Promise.reject(new Error(`"${target}" is not a valid target. Valid targets are "all" and "best".`));
            }
            if (!additionalOptions) {
                additionalOptions = {};
            }
            if (additionalOptions.methodResponseTimeoutMs === undefined) {
                additionalOptions.methodResponseTimeoutMs = additionalOptions.method_response_timeout;
                if (additionalOptions.methodResponseTimeoutMs === undefined) {
                    additionalOptions.methodResponseTimeoutMs = this.configuration.methodResponseTimeout;
                }
            }
            if (additionalOptions.waitTimeoutMs === undefined) {
                additionalOptions.waitTimeoutMs = additionalOptions.wait_for_method_timeout;
                if (additionalOptions.waitTimeoutMs === undefined) {
                    additionalOptions.waitTimeoutMs = this.configuration.waitTimeoutMs;
                }
            }
            if (additionalOptions.waitTimeoutMs !== undefined && typeof additionalOptions.waitTimeoutMs !== "number") {
                return Promise.reject(new Error(`"${additionalOptions.waitTimeoutMs}" is not a valid number for "waitTimeoutMs" `));
            }
            if (typeof argumentObj !== "object") {
                return Promise.reject(new Error(`The method arguments must be an object. method: ${methodDefinition.name}`));
            }
            let serversMethodMap = this.getServerMethodsByFilterAndTarget(methodDefinition, target);
            if (serversMethodMap.length === 0) {
                try {
                    serversMethodMap = await this.tryToAwaitForMethods(methodDefinition, target, additionalOptions);
                }
                catch (err) {
                    const method = {
                        ...methodDefinition,
                        getServers: () => [],
                        supportsStreaming: false,
                        objectTypes: methodDefinition.objectTypes ?? [],
                        flags: methodDefinition.flags?.metadata ?? {}
                    };
                    const errorObj = {
                        method,
                        called_with: argumentObj,
                        message: `Can not find a method matching ${JSON.stringify(methodFilter)} with server filter ${JSON.stringify(target)}`,
                        executed_by: undefined,
                        returned: undefined,
                        status: undefined,
                    };
                    return Promise.reject(errorObj);
                }
            }
            const timeout = additionalOptions.methodResponseTimeoutMs;
            const additionalOptionsCopy = additionalOptions;
            const invokePromises = serversMethodMap.map((serversMethodPair) => {
                const invId = nanoid(10);
                const method = serversMethodPair.methods[0];
                const server = serversMethodPair.server;
                const invokePromise = this.protocol.client.invoke(invId, method, argumentObj, server, additionalOptionsCopy);
                return Promise.race([
                    invokePromise,
                    rejectAfter(timeout, invokePromise, {
                        invocationId: invId,
                        message: `Invocation timeout (${timeout} ms) reached for method name: ${method?.name}, target instance: ${JSON.stringify(server.instance)}, options: ${JSON.stringify(additionalOptionsCopy)}`,
                        status: InvokeStatus.Error,
                    })
                ]);
            });
            const invocationMessages = await Promise.all(invokePromises);
            const results = this.getInvocationResultObj(invocationMessages, methodDefinition, argumentObj);
            const allRejected = invocationMessages.every((result) => result.status === InvokeStatus.Error);
            if (allRejected) {
                return Promise.reject(results);
            }
            return results;
        };
        return promisify(getInvokePromise(), success, error);
    }
    getInvocationResultObj(invocationResults, method, calledWith) {
        const all_return_values = invocationResults
            .filter((invokeMessage) => invokeMessage.status === InvokeStatus.Success)
            .reduce((allValues, currentValue) => {
            allValues = [
                ...allValues,
                {
                    executed_by: currentValue.instance,
                    returned: currentValue.result,
                    called_with: calledWith,
                    method,
                    message: currentValue.message,
                    status: currentValue.status,
                }
            ];
            return allValues;
        }, []);
        const all_errors = invocationResults
            .filter((invokeMessage) => invokeMessage.status === InvokeStatus.Error)
            .reduce((allErrors, currError) => {
            allErrors = [
                ...allErrors,
                {
                    executed_by: currError.instance,
                    called_with: calledWith,
                    name: method.name,
                    message: currError.message,
                }
            ];
            return allErrors;
        }, []);
        const invResult = invocationResults[0];
        const result = {
            method,
            called_with: calledWith,
            returned: invResult.result,
            executed_by: invResult.instance,
            all_return_values,
            all_errors,
            message: invResult.message,
            status: invResult.status
        };
        return result;
    }
    tryToAwaitForMethods(methodDefinition, target, additionalOptions) {
        return new Promise((resolve, reject) => {
            if (additionalOptions.waitTimeoutMs === 0) {
                reject();
                return;
            }
            const delayStep = 500;
            let delayTillNow = 0;
            const retry = () => {
                delayTillNow += delayStep;
                const serversMethodMap = this.getServerMethodsByFilterAndTarget(methodDefinition, target);
                if (serversMethodMap.length > 0) {
                    clearInterval(interval);
                    resolve(serversMethodMap);
                }
                else if (delayTillNow >= (additionalOptions.waitTimeoutMs || 10000)) {
                    clearInterval(interval);
                    reject();
                    return;
                }
            };
            const interval = setInterval(retry, delayStep);
        });
    }
    filterByTarget(target, serverMethodMap) {
        if (typeof target === "string") {
            if (target === "all") {
                return [...serverMethodMap];
            }
            else if (target === "best") {
                const localMachine = serverMethodMap
                    .find((s) => s.server.instance.isLocal);
                if (localMachine) {
                    return [localMachine];
                }
                if (serverMethodMap[0] !== undefined) {
                    return [serverMethodMap[0]];
                }
            }
            else if (target === "skipMine") {
                return serverMethodMap.filter(({ server }) => server.instance.peerId !== this.instance.peerId);
            }
        }
        else {
            let targetArray;
            if (!Array.isArray(target)) {
                targetArray = [target];
            }
            else {
                targetArray = target;
            }
            const allServersMatching = targetArray.reduce((matches, filter) => {
                const myMatches = serverMethodMap.filter((serverMethodPair) => {
                    return this.instanceMatch(filter, serverMethodPair.server.instance);
                });
                return matches.concat(myMatches);
            }, []);
            return allServersMatching;
        }
        return [];
    }
    instanceMatch(instanceFilter, instanceDefinition) {
        if (instanceFilter?.peerId && instanceFilter?.instance) {
            instanceFilter = { ...instanceFilter };
            delete instanceFilter.peerId;
        }
        return this.containsProps(instanceFilter, instanceDefinition);
    }
    methodMatch(methodFilter, methodDefinition) {
        return this.containsProps(methodFilter, methodDefinition);
    }
    containsProps(filter, repoMethod) {
        const filterProps = Object.keys(filter)
            .filter((prop) => {
            return filter[prop] !== undefined
                && filter[prop] !== null
                && typeof filter[prop] !== "function"
                && prop !== "object_types"
                && prop !== "display_name"
                && prop !== "id"
                && prop !== "gatewayId"
                && prop !== "identifier"
                && prop[0] !== "_";
        });
        return filterProps.every((prop) => {
            let isMatch;
            const filterValue = filter[prop];
            const repoMethodValue = repoMethod[prop];
            switch (prop) {
                case "objectTypes":
                    isMatch = (filterValue || []).every((filterValueEl) => {
                        return (repoMethodValue || []).includes(filterValueEl);
                    });
                    break;
                case "flags":
                    isMatch = isSubset(repoMethodValue || {}, filterValue || {});
                    break;
                default:
                    isMatch = String(filterValue).toLowerCase() === String(repoMethodValue).toLowerCase();
            }
            return isMatch;
        });
    }
    getMethods(methodFilter) {
        if (methodFilter === undefined) {
            return this.repo.getMethods();
        }
        const methods = this.repo.getMethods().filter((method) => {
            return this.methodMatch(methodFilter, method);
        });
        return methods;
    }
    getMethodsForInstance(instanceFilter) {
        const allServers = this.repo.getServers();
        const matchingServers = allServers.filter((server) => {
            return this.instanceMatch(instanceFilter, server.instance);
        });
        if (matchingServers.length === 0) {
            return [];
        }
        let resultMethodsObject = {};
        if (matchingServers.length === 1) {
            resultMethodsObject = matchingServers[0].methods;
        }
        else {
            matchingServers.forEach((server) => {
                Object.keys(server.methods).forEach((methodKey) => {
                    const method = server.methods[methodKey];
                    resultMethodsObject[method.identifier] = method;
                });
            });
        }
        return Object.keys(resultMethodsObject)
            .map((key) => {
            return resultMethodsObject[key];
        });
    }
    getServers(methodFilter) {
        const servers = this.repo.getServers();
        if (methodFilter === undefined) {
            return servers.map((server) => {
                return { server, methods: [] };
            });
        }
        return servers.reduce((prev, current) => {
            const methodsForServer = Object.values(current.methods);
            const matchingMethods = methodsForServer.filter((method) => {
                return this.methodMatch(methodFilter, method);
            });
            if (matchingMethods.length > 0) {
                prev.push({ server: current, methods: matchingMethods });
            }
            return prev;
        }, []);
    }
    getServerMethodsByFilterAndTarget(methodFilter, target) {
        const serversMethodMap = this.getServers(methodFilter);
        return this.filterByTarget(target, serversMethodMap);
    }
}

class ServerSubscription {
    protocol;
    repoMethod;
    subscription;
    constructor(protocol, repoMethod, subscription) {
        this.protocol = protocol;
        this.repoMethod = repoMethod;
        this.subscription = subscription;
    }
    get stream() {
        if (!this.repoMethod.stream) {
            throw new Error("no stream");
        }
        return this.repoMethod.stream;
    }
    get arguments() { return this.subscription.arguments || {}; }
    get branchKey() { return this.subscription.branchKey; }
    get instance() {
        if (!this.subscription.instance) {
            throw new Error("no instance");
        }
        return this.subscription.instance;
    }
    close() {
        this.protocol.server.closeSingleSubscription(this.repoMethod, this.subscription);
    }
    push(data) {
        this.protocol.server.pushDataToSingle(this.repoMethod, this.subscription, data);
    }
}

class Request {
    protocol;
    repoMethod;
    requestContext;
    arguments;
    instance;
    constructor(protocol, repoMethod, requestContext) {
        this.protocol = protocol;
        this.repoMethod = repoMethod;
        this.requestContext = requestContext;
        this.arguments = requestContext.arguments;
        this.instance = requestContext.instance;
    }
    accept() {
        this.protocol.server.acceptRequestOnBranch(this.requestContext, this.repoMethod, "");
    }
    acceptOnBranch(branch) {
        this.protocol.server.acceptRequestOnBranch(this.requestContext, this.repoMethod, branch);
    }
    reject(reason) {
        this.protocol.server.rejectRequest(this.requestContext, this.repoMethod, reason);
    }
}

let ServerStreaming$1 = class ServerStreaming {
    protocol;
    server;
    constructor(protocol, server) {
        this.protocol = protocol;
        this.server = server;
        protocol.server.onSubRequest((rc, rm) => this.handleSubRequest(rc, rm));
        protocol.server.onSubAdded((sub, rm) => this.handleSubAdded(sub, rm));
        protocol.server.onSubRemoved((sub, rm) => this.handleSubRemoved(sub, rm));
    }
    handleSubRequest(requestContext, repoMethod) {
        if (!(repoMethod &&
            repoMethod.streamCallbacks &&
            typeof repoMethod.streamCallbacks.subscriptionRequestHandler === "function")) {
            return;
        }
        const request = new Request(this.protocol, repoMethod, requestContext);
        repoMethod.streamCallbacks.subscriptionRequestHandler(request);
    }
    handleSubAdded(subscription, repoMethod) {
        if (!(repoMethod &&
            repoMethod.streamCallbacks &&
            typeof repoMethod.streamCallbacks.subscriptionAddedHandler === "function")) {
            return;
        }
        const sub = new ServerSubscription(this.protocol, repoMethod, subscription);
        repoMethod.streamCallbacks.subscriptionAddedHandler(sub);
    }
    handleSubRemoved(subscription, repoMethod) {
        if (!(repoMethod &&
            repoMethod.streamCallbacks &&
            typeof repoMethod.streamCallbacks.subscriptionRemovedHandler === "function")) {
            return;
        }
        const sub = new ServerSubscription(this.protocol, repoMethod, subscription);
        repoMethod.streamCallbacks.subscriptionRemovedHandler(sub);
    }
};

class ServerBranch {
    key;
    protocol;
    repoMethod;
    constructor(key, protocol, repoMethod) {
        this.key = key;
        this.protocol = protocol;
        this.repoMethod = repoMethod;
    }
    subscriptions() {
        const subList = this.protocol.server.getSubscriptionList(this.repoMethod, this.key);
        return subList.map((sub) => {
            return new ServerSubscription(this.protocol, this.repoMethod, sub);
        });
    }
    close() {
        this.protocol.server.closeAllSubscriptions(this.repoMethod, this.key);
    }
    push(data) {
        this.protocol.server.pushData(this.repoMethod, data, [this.key]);
    }
}

class ServerStream {
    _protocol;
    _repoMethod;
    _server;
    name;
    constructor(_protocol, _repoMethod, _server) {
        this._protocol = _protocol;
        this._repoMethod = _repoMethod;
        this._server = _server;
        this.name = this._repoMethod.definition.name;
    }
    branches(key) {
        const bList = this._protocol.server.getBranchList(this._repoMethod);
        if (key) {
            if (bList.indexOf(key) > -1) {
                return new ServerBranch(key, this._protocol, this._repoMethod);
            }
            return undefined;
        }
        else {
            return bList.map((branchKey) => {
                return new ServerBranch(branchKey, this._protocol, this._repoMethod);
            });
        }
    }
    branch(key) {
        return this.branches(key);
    }
    subscriptions() {
        const subList = this._protocol.server.getSubscriptionList(this._repoMethod);
        return subList.map((sub) => {
            return new ServerSubscription(this._protocol, this._repoMethod, sub);
        });
    }
    get definition() {
        const def2 = this._repoMethod.definition;
        return {
            accepts: def2.accepts,
            description: def2.description,
            displayName: def2.displayName,
            name: def2.name,
            objectTypes: def2.objectTypes,
            returns: def2.returns,
            supportsStreaming: def2.supportsStreaming,
            flags: def2.flags?.metadata,
        };
    }
    close() {
        this._protocol.server.closeAllSubscriptions(this._repoMethod);
        this._server.unregister(this._repoMethod.definition, true);
    }
    push(data, branches) {
        if (typeof branches !== "string" && !Array.isArray(branches) && branches !== undefined) {
            throw new Error("invalid branches should be string or string array");
        }
        if (typeof data !== "object") {
            throw new Error("Invalid arguments. Data must be an object.");
        }
        this._protocol.server.pushData(this._repoMethod, data, branches);
    }
    updateRepoMethod(repoMethod) {
        this._repoMethod = repoMethod;
    }
}

class Server {
    protocol;
    serverRepository;
    streaming;
    invocations = 0;
    currentlyUnregistering = {};
    constructor(protocol, serverRepository) {
        this.protocol = protocol;
        this.serverRepository = serverRepository;
        this.streaming = new ServerStreaming$1(protocol, this);
        this.protocol.server.onInvoked(this.onMethodInvoked.bind(this));
    }
    createStream(streamDef, callbacks, successCallback, errorCallback, existingStream) {
        const promise = new Promise((resolve, reject) => {
            if (!streamDef) {
                reject("The stream name must be unique! Please, provide either a unique string for a stream name to “glue.interop.createStream()” or a “methodDefinition” object with a unique “name” property for the stream.");
                return;
            }
            let streamMethodDefinition;
            if (typeof streamDef === "string") {
                streamMethodDefinition = { name: "" + streamDef };
            }
            else {
                streamMethodDefinition = { ...streamDef };
            }
            if (!streamMethodDefinition.name) {
                return reject(`The “name” property is required for the “streamDefinition” object and must be unique. Stream definition: ${JSON.stringify(streamMethodDefinition)}`);
            }
            const nameAlreadyExists = this.serverRepository.getList()
                .some((serverMethod) => serverMethod.definition.name === streamMethodDefinition.name);
            if (nameAlreadyExists) {
                return reject(`A stream with the name "${streamMethodDefinition.name}" already exists! Please, provide a unique name for the stream.`);
            }
            streamMethodDefinition.supportsStreaming = true;
            if (!callbacks) {
                callbacks = {};
            }
            if (typeof callbacks.subscriptionRequestHandler !== "function") {
                callbacks.subscriptionRequestHandler = (request) => {
                    request.accept();
                };
            }
            const repoMethod = this.serverRepository.add({
                definition: streamMethodDefinition,
                streamCallbacks: callbacks,
                protocolState: {},
            });
            this.protocol.server.createStream(repoMethod)
                .then(() => {
                let streamUserObject;
                if (existingStream) {
                    streamUserObject = existingStream;
                    existingStream.updateRepoMethod(repoMethod);
                }
                else {
                    streamUserObject = new ServerStream(this.protocol, repoMethod, this);
                }
                repoMethod.stream = streamUserObject;
                resolve(streamUserObject);
            })
                .catch((err) => {
                if (repoMethod.repoId) {
                    this.serverRepository.remove(repoMethod.repoId);
                }
                reject(err);
            });
        });
        return promisify(promise, successCallback, errorCallback);
    }
    register(methodDefinition, callback) {
        if (!methodDefinition) {
            return Promise.reject("Method definition is required. Please, provide either a unique string for a method name or a “methodDefinition” object with a required “name” property.");
        }
        if (typeof callback !== "function") {
            return Promise.reject(`The second parameter must be a callback function. Method: ${typeof methodDefinition === "string" ? methodDefinition : methodDefinition.name}`);
        }
        const wrappedCallbackFunction = async (context, resultCallback) => {
            try {
                const result = callback(context.args, context.instance);
                if (result && typeof result.then === "function") {
                    const resultValue = await result;
                    resultCallback(undefined, resultValue);
                }
                else {
                    resultCallback(undefined, result);
                }
            }
            catch (e) {
                resultCallback(e ?? "", e ?? "");
            }
        };
        wrappedCallbackFunction.userCallback = callback;
        return this.registerCore(methodDefinition, wrappedCallbackFunction);
    }
    registerAsync(methodDefinition, callback) {
        if (!methodDefinition) {
            return Promise.reject("Method definition is required. Please, provide either a unique string for a method name or a “methodDefinition” object with a required “name” property.");
        }
        if (typeof callback !== "function") {
            return Promise.reject(`The second parameter must be a callback function. Method: ${typeof methodDefinition === "string" ? methodDefinition : methodDefinition.name}`);
        }
        const wrappedCallback = async (context, resultCallback) => {
            try {
                let resultCalled = false;
                const success = (result) => {
                    if (!resultCalled) {
                        resultCallback(undefined, result);
                    }
                    resultCalled = true;
                };
                const error = (e) => {
                    if (!resultCalled) {
                        if (!e) {
                            e = "";
                        }
                        resultCallback(e, e);
                    }
                    resultCalled = true;
                };
                const methodResult = callback(context.args, context.instance, success, error);
                if (methodResult && typeof methodResult.then === "function") {
                    methodResult
                        .then(success)
                        .catch(error);
                }
            }
            catch (e) {
                resultCallback(e, undefined);
            }
        };
        wrappedCallback.userCallbackAsync = callback;
        return this.registerCore(methodDefinition, wrappedCallback);
    }
    async unregister(methodFilter, forStream = false) {
        if (methodFilter === undefined) {
            return Promise.reject("Please, provide either a unique string for a name or an object containing a “name” property.");
        }
        if (typeof methodFilter === "function") {
            await this.unregisterWithPredicate(methodFilter, forStream);
            return;
        }
        let methodDefinition;
        if (typeof methodFilter === "string") {
            methodDefinition = { name: methodFilter };
        }
        else {
            methodDefinition = methodFilter;
        }
        if (methodDefinition.name === undefined) {
            return Promise.reject("Method name is required. Cannot find a method if the method name is undefined!");
        }
        const methodToBeRemoved = this.serverRepository.getList().find((serverMethod) => {
            return serverMethod.definition.name === methodDefinition.name
                && (serverMethod.definition.supportsStreaming || false) === forStream;
        });
        if (!methodToBeRemoved) {
            return Promise.reject(`Method with a name "${methodDefinition.name}" does not exist or is not registered by your application!`);
        }
        await this.removeMethodsOrStreams([methodToBeRemoved]);
    }
    async unregisterWithPredicate(filterPredicate, forStream) {
        const methodsOrStreamsToRemove = this.serverRepository.getList()
            .filter((sm) => filterPredicate(sm.definition))
            .filter((serverMethod) => (serverMethod.definition.supportsStreaming || false) === forStream);
        if (!methodsOrStreamsToRemove || methodsOrStreamsToRemove.length === 0) {
            return Promise.reject(`Could not find a ${forStream ? "stream" : "method"} matching the specified condition!`);
        }
        await this.removeMethodsOrStreams(methodsOrStreamsToRemove);
    }
    removeMethodsOrStreams(methodsToRemove) {
        const methodUnregPromises = [];
        methodsToRemove.forEach((method) => {
            const promise = this.protocol.server.unregister(method)
                .then(() => {
                if (method.repoId) {
                    this.serverRepository.remove(method.repoId);
                }
            });
            methodUnregPromises.push(promise);
            this.addAsCurrentlyUnregistering(method.definition.name, promise);
        });
        return Promise.all(methodUnregPromises);
    }
    async addAsCurrentlyUnregistering(methodName, promise) {
        const timeout = new Promise((resolve) => setTimeout(resolve, 5000));
        this.currentlyUnregistering[methodName] = Promise.race([promise, timeout]).then(() => {
            delete this.currentlyUnregistering[methodName];
        });
    }
    async registerCore(method, theFunction) {
        let methodDefinition;
        if (typeof method === "string") {
            methodDefinition = { name: "" + method };
        }
        else {
            methodDefinition = { ...method };
        }
        if (!methodDefinition.name) {
            return Promise.reject(`Please, provide a (unique) string value for the “name” property in the “methodDefinition” object: ${JSON.stringify(method)}`);
        }
        const unregisterInProgress = this.currentlyUnregistering[methodDefinition.name];
        if (typeof unregisterInProgress !== "undefined") {
            await unregisterInProgress;
        }
        const nameAlreadyExists = this.serverRepository.getList()
            .some((serverMethod) => serverMethod.definition.name === methodDefinition.name);
        if (nameAlreadyExists) {
            return Promise.reject(`A method with the name "${methodDefinition.name}" already exists! Please, provide a unique name for the method.`);
        }
        if (methodDefinition.supportsStreaming) {
            return Promise.reject(`When you create methods with “glue.interop.register()” or “glue.interop.registerAsync()” the property “supportsStreaming” cannot be “true”. If you want “${methodDefinition.name}” to be a stream, please use the “glue.interop.createStream()” method.`);
        }
        const repoMethod = this.serverRepository.add({
            definition: methodDefinition,
            theFunction,
            protocolState: {},
        });
        return this.protocol.server.register(repoMethod)
            .catch((err) => {
            if (repoMethod?.repoId) {
                this.serverRepository.remove(repoMethod.repoId);
            }
            throw err;
        });
    }
    onMethodInvoked(methodToExecute, invocationId, invocationArgs) {
        if (!methodToExecute || !methodToExecute.theFunction) {
            return;
        }
        methodToExecute.theFunction(invocationArgs, (err, result) => {
            if (err !== undefined && err !== null) {
                if (err.message && typeof err.message === "string") {
                    err = err.message;
                }
                else if (typeof err !== "string") {
                    try {
                        err = JSON.stringify(err);
                    }
                    catch (unStrException) {
                        err = `un-stringifyable error in onMethodInvoked! Top level prop names: ${Object.keys(err)}`;
                    }
                }
            }
            if (!result) {
                result = {};
            }
            else if (typeof result !== "object" || Array.isArray(result)) {
                result = { _value: result };
            }
            this.protocol.server.methodInvocationResult(methodToExecute, invocationId, err, result);
        });
    }
}

class InstanceWrapper {
    wrapped = {};
    constructor(API, instance, connection) {
        this.wrapped.getMethods = function () {
            return API.methodsForInstance(this);
        };
        this.wrapped.getStreams = function () {
            return API.methodsForInstance(this).filter((m) => m.supportsStreaming);
        };
        if (instance) {
            this.refreshWrappedObject(instance);
        }
        if (connection) {
            connection.loggedIn(() => {
                this.refresh(connection);
            });
            this.refresh(connection);
        }
    }
    unwrap() {
        return this.wrapped;
    }
    refresh(connection) {
        if (!connection) {
            return;
        }
        const resolvedIdentity = connection?.resolvedIdentity;
        const instance = Object.assign({}, resolvedIdentity ?? {}, { peerId: connection?.peerId });
        this.refreshWrappedObject(instance);
    }
    refreshWrappedObject(resolvedIdentity) {
        Object.keys(resolvedIdentity).forEach((key) => {
            this.wrapped[key] = resolvedIdentity[key];
        });
        this.wrapped.user = resolvedIdentity.user;
        this.wrapped.instance = resolvedIdentity.instance;
        this.wrapped.application = resolvedIdentity.application ?? nanoid(10);
        this.wrapped.applicationName = resolvedIdentity.applicationName;
        this.wrapped.pid = resolvedIdentity.pid ?? resolvedIdentity.process ?? Math.floor(Math.random() * 10000000000);
        this.wrapped.machine = resolvedIdentity.machine;
        this.wrapped.environment = resolvedIdentity.environment;
        this.wrapped.region = resolvedIdentity.region;
        this.wrapped.windowId = resolvedIdentity.windowId;
        this.wrapped.isLocal = resolvedIdentity.isLocal ?? true;
        this.wrapped.api = resolvedIdentity.api;
        this.wrapped.service = resolvedIdentity.service;
        this.wrapped.peerId = resolvedIdentity.peerId;
    }
}

const hideMethodSystemFlags = (method) => {
    return {
        ...method,
        flags: method.flags.metadata || {}
    };
};
class ClientRepository {
    logger;
    API;
    servers = {};
    myServer;
    methodsCount = {};
    callbacks = CallbackRegistryFactory();
    constructor(logger, API) {
        this.logger = logger;
        this.API = API;
        const peerId = this.API.instance.peerId;
        this.myServer = {
            id: peerId,
            methods: {},
            instance: this.API.instance,
            wrapper: this.API.unwrappedInstance,
        };
        this.servers[peerId] = this.myServer;
    }
    addServer(info, serverId) {
        this.logger.debug(`adding server ${serverId}`);
        const current = this.servers[serverId];
        if (current) {
            return current.id;
        }
        const wrapper = new InstanceWrapper(this.API, info);
        const serverEntry = {
            id: serverId,
            methods: {},
            instance: wrapper.unwrap(),
            wrapper,
        };
        this.servers[serverId] = serverEntry;
        this.callbacks.execute("onServerAdded", serverEntry.instance);
        return serverId;
    }
    removeServerById(id, reason) {
        const server = this.servers[id];
        if (!server) {
            this.logger.warn(`not aware of server ${id}, my state ${JSON.stringify(Object.keys(this.servers))}`);
            return;
        }
        else {
            this.logger.debug(`removing server ${id}`);
        }
        Object.keys(server.methods).forEach((methodId) => {
            this.removeServerMethod(id, methodId);
        });
        delete this.servers[id];
        this.callbacks.execute("onServerRemoved", server.instance, reason);
    }
    addServerMethod(serverId, method) {
        const server = this.servers[serverId];
        if (!server) {
            throw new Error("server does not exists");
        }
        if (server.methods[method.id]) {
            return;
        }
        const identifier = this.createMethodIdentifier(method);
        const that = this;
        const methodDefinition = {
            identifier,
            gatewayId: method.id,
            name: method.name,
            displayName: method.display_name,
            description: method.description,
            version: method.version,
            objectTypes: method.object_types || [],
            accepts: method.input_signature,
            returns: method.result_signature,
            supportsStreaming: typeof method.flags !== "undefined" ? method.flags.streaming : false,
            flags: method.flags ?? {},
            getServers: () => {
                return that.getServersByMethod(identifier);
            }
        };
        methodDefinition.object_types = methodDefinition.objectTypes;
        methodDefinition.display_name = methodDefinition.displayName;
        methodDefinition.version = methodDefinition.version;
        server.methods[method.id] = methodDefinition;
        const clientMethodDefinition = hideMethodSystemFlags(methodDefinition);
        if (!this.methodsCount[identifier]) {
            this.methodsCount[identifier] = 0;
            this.callbacks.execute("onMethodAdded", clientMethodDefinition);
        }
        this.methodsCount[identifier] = this.methodsCount[identifier] + 1;
        this.callbacks.execute("onServerMethodAdded", server.instance, clientMethodDefinition);
        return methodDefinition;
    }
    removeServerMethod(serverId, methodId) {
        const server = this.servers[serverId];
        if (!server) {
            throw new Error("server does not exists");
        }
        const method = server.methods[methodId];
        delete server.methods[methodId];
        const clientMethodDefinition = hideMethodSystemFlags(method);
        this.methodsCount[method.identifier] = this.methodsCount[method.identifier] - 1;
        if (this.methodsCount[method.identifier] === 0) {
            this.callbacks.execute("onMethodRemoved", clientMethodDefinition);
        }
        this.callbacks.execute("onServerMethodRemoved", server.instance, clientMethodDefinition);
    }
    getMethods() {
        return this.extractMethodsFromServers(Object.values(this.servers)).map(hideMethodSystemFlags);
    }
    getServers() {
        return Object.values(this.servers).map(this.hideServerMethodSystemFlags);
    }
    onServerAdded(callback) {
        const unsubscribeFunc = this.callbacks.add("onServerAdded", callback);
        const serversWithMethodsToReplay = this.getServers().map((s) => s.instance);
        return this.returnUnsubWithDelayedReplay(unsubscribeFunc, serversWithMethodsToReplay, callback);
    }
    onMethodAdded(callback) {
        const unsubscribeFunc = this.callbacks.add("onMethodAdded", callback);
        const methodsToReplay = this.getMethods();
        return this.returnUnsubWithDelayedReplay(unsubscribeFunc, methodsToReplay, callback);
    }
    onServerMethodAdded(callback) {
        const unsubscribeFunc = this.callbacks.add("onServerMethodAdded", callback);
        let unsubCalled = false;
        const servers = this.getServers();
        setTimeout(() => {
            servers.forEach((server) => {
                const methods = server.methods;
                Object.keys(methods).forEach((methodId) => {
                    if (!unsubCalled) {
                        callback(server.instance, methods[methodId]);
                    }
                });
            });
        }, 0);
        return () => {
            unsubCalled = true;
            unsubscribeFunc();
        };
    }
    onMethodRemoved(callback) {
        const unsubscribeFunc = this.callbacks.add("onMethodRemoved", callback);
        return unsubscribeFunc;
    }
    onServerRemoved(callback) {
        const unsubscribeFunc = this.callbacks.add("onServerRemoved", callback);
        return unsubscribeFunc;
    }
    onServerMethodRemoved(callback) {
        const unsubscribeFunc = this.callbacks.add("onServerMethodRemoved", callback);
        return unsubscribeFunc;
    }
    getServerById(id) {
        const server = this.servers[id];
        if (!server) {
            return undefined;
        }
        return this.hideServerMethodSystemFlags(this.servers[id]);
    }
    reset() {
        Object.keys(this.servers).forEach((key) => {
            this.removeServerById(key, "reset");
        });
        this.servers = {
            [this.myServer.id]: this.myServer
        };
        this.methodsCount = {};
    }
    createMethodIdentifier(methodInfo) {
        const accepts = methodInfo.input_signature ?? "";
        const returns = methodInfo.result_signature ?? "";
        return (methodInfo.name + accepts + returns).toLowerCase();
    }
    getServersByMethod(identifier) {
        const allServers = [];
        Object.values(this.servers).forEach((server) => {
            Object.values(server.methods).forEach((method) => {
                if (method.identifier === identifier) {
                    allServers.push(server.instance);
                }
            });
        });
        return allServers;
    }
    returnUnsubWithDelayedReplay(unsubscribeFunc, collectionToReplay, callback) {
        let unsubCalled = false;
        setTimeout(() => {
            collectionToReplay.forEach((item) => {
                if (!unsubCalled) {
                    callback(item);
                }
            });
        }, 0);
        return () => {
            unsubCalled = true;
            unsubscribeFunc();
        };
    }
    hideServerMethodSystemFlags(server) {
        const clientMethods = {};
        Object.entries(server.methods).forEach(([name, method]) => {
            clientMethods[name] = hideMethodSystemFlags(method);
        });
        return {
            ...server,
            methods: clientMethods
        };
    }
    extractMethodsFromServers(servers) {
        const methods = Object.values(servers).reduce((clientMethods, server) => {
            return [...clientMethods, ...Object.values(server.methods)];
        }, []);
        return methods;
    }
}

class ServerRepository {
    nextId = 0;
    methods = [];
    add(method) {
        method.repoId = String(this.nextId);
        this.nextId += 1;
        this.methods.push(method);
        return method;
    }
    remove(repoId) {
        if (typeof repoId !== "string") {
            return new TypeError("Expecting a string");
        }
        this.methods = this.methods.filter((m) => {
            return m.repoId !== repoId;
        });
    }
    getById(id) {
        if (typeof id !== "string") {
            return undefined;
        }
        return this.methods.find((m) => {
            return m.repoId === id;
        });
    }
    getList() {
        return this.methods.map((m) => m);
    }
    length() {
        return this.methods.length;
    }
    reset() {
        this.methods = [];
    }
}

const SUBSCRIPTION_REQUEST = "onSubscriptionRequest";
const SUBSCRIPTION_ADDED = "onSubscriptionAdded";
const SUBSCRIPTION_REMOVED = "onSubscriptionRemoved";
class ServerStreaming {
    session;
    repository;
    serverRepository;
    ERR_URI_SUBSCRIPTION_FAILED = "com.tick42.agm.errors.subscription.failure";
    callbacks = CallbackRegistryFactory();
    nextStreamId = 0;
    constructor(session, repository, serverRepository) {
        this.session = session;
        this.repository = repository;
        this.serverRepository = serverRepository;
        session.on("add-interest", (msg) => {
            this.handleAddInterest(msg);
        });
        session.on("remove-interest", (msg) => {
            this.handleRemoveInterest(msg);
        });
    }
    acceptRequestOnBranch(requestContext, streamingMethod, branch) {
        if (typeof branch !== "string") {
            branch = "";
        }
        if (typeof streamingMethod.protocolState.subscriptionsMap !== "object") {
            throw new TypeError("The streaming method is missing its subscriptions.");
        }
        if (!Array.isArray(streamingMethod.protocolState.branchKeyToStreamIdMap)) {
            throw new TypeError("The streaming method is missing its branches.");
        }
        const streamId = this.getStreamId(streamingMethod, branch);
        const key = requestContext.msg.subscription_id;
        const subscription = {
            id: key,
            arguments: requestContext.arguments,
            instance: requestContext.instance,
            branchKey: branch,
            streamId,
            subscribeMsg: requestContext.msg,
        };
        streamingMethod.protocolState.subscriptionsMap[key] = subscription;
        this.session.sendFireAndForget({
            type: "accepted",
            subscription_id: key,
            stream_id: streamId,
        });
        this.callbacks.execute(SUBSCRIPTION_ADDED, subscription, streamingMethod);
    }
    rejectRequest(requestContext, streamingMethod, reason) {
        if (typeof reason !== "string") {
            reason = "";
        }
        this.sendSubscriptionFailed("Subscription rejected by user. " + reason, requestContext.msg.subscription_id);
    }
    pushData(streamingMethod, data, branches) {
        if (typeof streamingMethod !== "object" || !Array.isArray(streamingMethod.protocolState.branchKeyToStreamIdMap)) {
            return;
        }
        if (typeof data !== "object") {
            throw new Error("Invalid arguments. Data must be an object.");
        }
        if (typeof branches === "string") {
            branches = [branches];
        }
        else if (!Array.isArray(branches) || branches.length <= 0) {
            branches = [];
        }
        const streamIdList = streamingMethod.protocolState.branchKeyToStreamIdMap
            .filter((br) => {
            if (!branches || branches.length === 0) {
                return true;
            }
            return branches.indexOf(br.key) >= 0;
        }).map((br) => {
            return br.streamId;
        });
        streamIdList.forEach((streamId) => {
            const publishMessage = {
                type: "publish",
                stream_id: streamId,
                data,
            };
            this.session.sendFireAndForget(publishMessage);
        });
    }
    pushDataToSingle(method, subscription, data) {
        if (typeof data !== "object") {
            throw new Error("Invalid arguments. Data must be an object.");
        }
        const postMessage = {
            type: "post",
            subscription_id: subscription.id,
            data,
        };
        this.session.sendFireAndForget(postMessage);
    }
    closeSingleSubscription(streamingMethod, subscription) {
        if (streamingMethod.protocolState.subscriptionsMap) {
            delete streamingMethod.protocolState.subscriptionsMap[subscription.id];
        }
        const dropSubscriptionMessage = {
            type: "drop-subscription",
            subscription_id: subscription.id,
            reason: "Server dropping a single subscription",
        };
        this.session.sendFireAndForget(dropSubscriptionMessage);
        subscription.instance;
        this.callbacks.execute(SUBSCRIPTION_REMOVED, subscription, streamingMethod);
    }
    closeMultipleSubscriptions(streamingMethod, branchKey) {
        if (typeof streamingMethod !== "object" || typeof streamingMethod.protocolState.subscriptionsMap !== "object") {
            return;
        }
        if (!streamingMethod.protocolState.subscriptionsMap) {
            return;
        }
        const subscriptionsMap = streamingMethod.protocolState.subscriptionsMap;
        let subscriptionsToClose = Object.keys(subscriptionsMap)
            .map((key) => {
            return subscriptionsMap[key];
        });
        if (typeof branchKey === "string") {
            subscriptionsToClose = subscriptionsToClose.filter((sub) => {
                return sub.branchKey === branchKey;
            });
        }
        subscriptionsToClose.forEach((subscription) => {
            delete subscriptionsMap[subscription.id];
            const drop = {
                type: "drop-subscription",
                subscription_id: subscription.id,
                reason: "Server dropping all subscriptions on stream_id: " + subscription.streamId,
            };
            this.session.sendFireAndForget(drop);
        });
    }
    getSubscriptionList(streamingMethod, branchKey) {
        if (typeof streamingMethod !== "object") {
            return [];
        }
        let subscriptions = [];
        if (!streamingMethod.protocolState.subscriptionsMap) {
            return [];
        }
        const subscriptionsMap = streamingMethod.protocolState.subscriptionsMap;
        const allSubscriptions = Object.keys(subscriptionsMap)
            .map((key) => {
            return subscriptionsMap[key];
        });
        if (typeof branchKey !== "string") {
            subscriptions = allSubscriptions;
        }
        else {
            subscriptions = allSubscriptions.filter((sub) => {
                return sub.branchKey === branchKey;
            });
        }
        return subscriptions;
    }
    getBranchList(streamingMethod) {
        if (typeof streamingMethod !== "object") {
            return [];
        }
        if (!streamingMethod.protocolState.subscriptionsMap) {
            return [];
        }
        const subscriptionsMap = streamingMethod.protocolState.subscriptionsMap;
        const allSubscriptions = Object.keys(subscriptionsMap)
            .map((key) => {
            return subscriptionsMap[key];
        });
        const result = [];
        allSubscriptions.forEach((sub) => {
            let branch = "";
            if (typeof sub === "object" && typeof sub.branchKey === "string") {
                branch = sub.branchKey;
            }
            if (result.indexOf(branch) === -1) {
                result.push(branch);
            }
        });
        return result;
    }
    onSubAdded(callback) {
        this.onSubscriptionLifetimeEvent(SUBSCRIPTION_ADDED, callback);
    }
    onSubRequest(callback) {
        this.onSubscriptionLifetimeEvent(SUBSCRIPTION_REQUEST, callback);
    }
    onSubRemoved(callback) {
        this.onSubscriptionLifetimeEvent(SUBSCRIPTION_REMOVED, callback);
    }
    handleRemoveInterest(msg) {
        const streamingMethod = this.serverRepository.getById(msg.method_id);
        if (typeof msg.subscription_id !== "string" ||
            typeof streamingMethod !== "object") {
            return;
        }
        if (!streamingMethod.protocolState.subscriptionsMap) {
            return;
        }
        if (typeof streamingMethod.protocolState.subscriptionsMap[msg.subscription_id] !== "object") {
            return;
        }
        const subscription = streamingMethod.protocolState.subscriptionsMap[msg.subscription_id];
        delete streamingMethod.protocolState.subscriptionsMap[msg.subscription_id];
        this.callbacks.execute(SUBSCRIPTION_REMOVED, subscription, streamingMethod);
    }
    onSubscriptionLifetimeEvent(eventName, handlerFunc) {
        this.callbacks.add(eventName, handlerFunc);
    }
    getNextStreamId() {
        return this.nextStreamId++ + "";
    }
    handleAddInterest(msg) {
        const caller = this.repository.getServerById(msg.caller_id);
        const instance = caller?.instance ?? {};
        const requestContext = {
            msg,
            arguments: msg.arguments_kv || {},
            instance,
        };
        const streamingMethod = this.serverRepository.getById(msg.method_id);
        if (streamingMethod === undefined) {
            const errorMsg = "No method with id " + msg.method_id + " on this server.";
            this.sendSubscriptionFailed(errorMsg, msg.subscription_id);
            return;
        }
        if (streamingMethod.protocolState.subscriptionsMap &&
            streamingMethod.protocolState.subscriptionsMap[msg.subscription_id]) {
            this.sendSubscriptionFailed("A subscription with id " + msg.subscription_id + " already exists.", msg.subscription_id);
            return;
        }
        this.callbacks.execute(SUBSCRIPTION_REQUEST, requestContext, streamingMethod);
    }
    sendSubscriptionFailed(reason, subscriptionId) {
        const errorMessage = {
            type: "error",
            reason_uri: this.ERR_URI_SUBSCRIPTION_FAILED,
            reason,
            request_id: subscriptionId,
        };
        this.session.sendFireAndForget(errorMessage);
    }
    getStreamId(streamingMethod, branchKey) {
        if (typeof branchKey !== "string") {
            branchKey = "";
        }
        if (!streamingMethod.protocolState.branchKeyToStreamIdMap) {
            throw new Error(`streaming ${streamingMethod.definition.name} method without protocol state`);
        }
        const needleBranch = streamingMethod.protocolState.branchKeyToStreamIdMap.filter((branch) => {
            return branch.key === branchKey;
        })[0];
        let streamId = (needleBranch ? needleBranch.streamId : undefined);
        if (typeof streamId !== "string" || streamId === "") {
            streamId = this.getNextStreamId();
            streamingMethod.protocolState.branchKeyToStreamIdMap.push({ key: branchKey, streamId });
        }
        return streamId;
    }
}

class ServerProtocol {
    session;
    clientRepository;
    serverRepository;
    logger;
    callbacks = CallbackRegistryFactory();
    streaming;
    constructor(session, clientRepository, serverRepository, logger) {
        this.session = session;
        this.clientRepository = clientRepository;
        this.serverRepository = serverRepository;
        this.logger = logger;
        this.streaming = new ServerStreaming(session, clientRepository, serverRepository);
        this.session.on("invoke", (msg) => this.handleInvokeMessage(msg));
    }
    createStream(repoMethod) {
        repoMethod.protocolState.subscriptionsMap = {};
        repoMethod.protocolState.branchKeyToStreamIdMap = [];
        return this.register(repoMethod, true);
    }
    register(repoMethod, isStreaming) {
        const methodDef = repoMethod.definition;
        const flags = Object.assign({}, { metadata: methodDef.flags ?? {} }, { streaming: isStreaming || false });
        const registerMsg = {
            type: "register",
            methods: [{
                    id: repoMethod.repoId,
                    name: methodDef.name,
                    display_name: methodDef.displayName,
                    description: methodDef.description,
                    version: methodDef.version,
                    flags,
                    object_types: methodDef.objectTypes || methodDef.object_types,
                    input_signature: methodDef.accepts,
                    result_signature: methodDef.returns,
                    restrictions: undefined,
                }],
        };
        return this.session.send(registerMsg, { methodId: repoMethod.repoId })
            .then(() => {
            this.logger.debug("registered method " + repoMethod.definition.name + " with id " + repoMethod.repoId);
        })
            .catch((msg) => {
            this.logger.warn(`failed to register method ${repoMethod.definition.name} with id ${repoMethod.repoId} - ${JSON.stringify(msg)}`);
            throw msg;
        });
    }
    onInvoked(callback) {
        this.callbacks.add("onInvoked", callback);
    }
    methodInvocationResult(method, invocationId, err, result) {
        let msg;
        if (err || err === "") {
            msg = {
                type: "error",
                request_id: invocationId,
                reason_uri: "agm.errors.client_error",
                reason: err,
                context: result,
                peer_id: undefined,
            };
        }
        else {
            msg = {
                type: "yield",
                invocation_id: invocationId,
                peer_id: this.session.peerId,
                result,
                request_id: undefined,
            };
        }
        this.session.sendFireAndForget(msg);
    }
    async unregister(method) {
        const msg = {
            type: "unregister",
            methods: [method.repoId],
        };
        await this.session.send(msg);
    }
    getBranchList(method) {
        return this.streaming.getBranchList(method);
    }
    getSubscriptionList(method, branchKey) {
        return this.streaming.getSubscriptionList(method, branchKey);
    }
    closeAllSubscriptions(method, branchKey) {
        this.streaming.closeMultipleSubscriptions(method, branchKey);
    }
    pushData(method, data, branches) {
        this.streaming.pushData(method, data, branches);
    }
    pushDataToSingle(method, subscription, data) {
        this.streaming.pushDataToSingle(method, subscription, data);
    }
    closeSingleSubscription(method, subscription) {
        this.streaming.closeSingleSubscription(method, subscription);
    }
    acceptRequestOnBranch(requestContext, method, branch) {
        this.streaming.acceptRequestOnBranch(requestContext, method, branch);
    }
    rejectRequest(requestContext, method, reason) {
        this.streaming.rejectRequest(requestContext, method, reason);
    }
    onSubRequest(callback) {
        this.streaming.onSubRequest(callback);
    }
    onSubAdded(callback) {
        this.streaming.onSubAdded(callback);
    }
    onSubRemoved(callback) {
        this.streaming.onSubRemoved(callback);
    }
    handleInvokeMessage(msg) {
        const invocationId = msg.invocation_id;
        const callerId = msg.caller_id;
        const methodId = msg.method_id;
        const args = msg.arguments_kv;
        const methodList = this.serverRepository.getList();
        const method = methodList.filter((m) => {
            return m.repoId === methodId;
        })[0];
        if (method === undefined) {
            return;
        }
        const client = this.clientRepository.getServerById(callerId)?.instance;
        const invocationArgs = { args, instance: client };
        this.callbacks.execute("onInvoked", method, invocationId, invocationArgs);
    }
}

class UserSubscription {
    repository;
    subscriptionData;
    get requestArguments() {
        return this.subscriptionData.params.arguments || {};
    }
    get servers() {
        return this.subscriptionData.trackedServers.reduce((servers, pair) => {
            if (pair.subscriptionId) {
                const server = this.repository.getServerById(pair.serverId)?.instance;
                if (server) {
                    servers.push(server);
                }
            }
            return servers;
        }, []);
    }
    get serverInstance() {
        return this.servers[0];
    }
    get stream() {
        return this.subscriptionData.method;
    }
    constructor(repository, subscriptionData) {
        this.repository = repository;
        this.subscriptionData = subscriptionData;
    }
    onData(dataCallback) {
        if (typeof dataCallback !== "function") {
            throw new TypeError("The data callback must be a function.");
        }
        this.subscriptionData.handlers.onData.push(dataCallback);
        if (this.subscriptionData.handlers.onData.length === 1 && this.subscriptionData.queued.data.length > 0) {
            this.subscriptionData.queued.data.forEach((dataItem) => {
                dataCallback(dataItem);
            });
        }
    }
    onClosed(closedCallback) {
        if (typeof closedCallback !== "function") {
            throw new TypeError("The callback must be a function.");
        }
        this.subscriptionData.handlers.onClosed.push(closedCallback);
    }
    onFailed(callback) {
    }
    onConnected(callback) {
        if (typeof callback !== "function") {
            throw new TypeError("The callback must be a function.");
        }
        this.subscriptionData.handlers.onConnected.push(callback);
    }
    close() {
        this.subscriptionData.close();
    }
    setNewSubscription(newSub) {
        this.subscriptionData = newSub;
    }
}

class TimedCache {
    config;
    cache = [];
    timeoutIds = [];
    constructor(config) {
        this.config = config;
    }
    add(element) {
        const id = nanoid(10);
        this.cache.push({ id, element });
        const timeoutId = setTimeout(() => {
            const elementIdx = this.cache.findIndex((entry) => entry.id === id);
            if (elementIdx < 0) {
                return;
            }
            this.cache.splice(elementIdx, 1);
        }, this.config.ELEMENT_TTL_MS);
        this.timeoutIds.push(timeoutId);
    }
    flush() {
        const elements = this.cache.map((entry) => entry.element);
        this.timeoutIds.forEach((id) => clearInterval(id));
        this.cache = [];
        this.timeoutIds = [];
        return elements;
    }
}

const STATUS_AWAITING_ACCEPT = "awaitingAccept";
const STATUS_SUBSCRIBED = "subscribed";
const ERR_MSG_SUB_FAILED = "Subscription failed.";
const ERR_MSG_SUB_REJECTED = "Subscription rejected.";
const ON_CLOSE_MSG_SERVER_INIT = "ServerInitiated";
const ON_CLOSE_MSG_CLIENT_INIT = "ClientInitiated";
class ClientStreaming {
    session;
    repository;
    logger;
    subscriptionsList = {};
    timedCache = new TimedCache({ ELEMENT_TTL_MS: 10000 });
    subscriptionIdToLocalKeyMap = {};
    nextSubLocalKey = 0;
    constructor(session, repository, logger) {
        this.session = session;
        this.repository = repository;
        this.logger = logger;
        session.on("subscribed", this.handleSubscribed);
        session.on("event", this.handleEventData);
        session.on("subscription-cancelled", this.handleSubscriptionCancelled);
    }
    subscribe(streamingMethod, params, targetServers, success, error, existingSub) {
        if (targetServers.length === 0) {
            error({
                method: streamingMethod,
                called_with: params.arguments,
                message: ERR_MSG_SUB_FAILED + " No available servers matched the target params.",
            });
            return;
        }
        const subLocalKey = this.getNextSubscriptionLocalKey();
        const pendingSub = this.registerSubscription(subLocalKey, streamingMethod, params, success, error, params.methodResponseTimeout || 10000, existingSub);
        if (typeof pendingSub !== "object") {
            error({
                method: streamingMethod,
                called_with: params.arguments,
                message: ERR_MSG_SUB_FAILED + " Unable to register the user callbacks.",
            });
            return;
        }
        targetServers.forEach((target) => {
            const serverId = target.server.id;
            const method = target.methods.find((m) => m.name === streamingMethod.name);
            if (!method) {
                this.logger.error(`can not find method ${streamingMethod.name} for target ${target.server.id}`);
                return;
            }
            pendingSub.trackedServers.push({
                serverId,
                subscriptionId: undefined,
            });
            const msg = {
                type: "subscribe",
                server_id: serverId,
                method_id: method.gatewayId,
                arguments_kv: params.arguments,
            };
            this.session.send(msg, { serverId, subLocalKey })
                .then((m) => this.handleSubscribed(m))
                .catch((err) => this.handleErrorSubscribing(err));
        });
    }
    drainSubscriptions() {
        const existing = Object.values(this.subscriptionsList);
        this.subscriptionsList = {};
        this.subscriptionIdToLocalKeyMap = {};
        return existing;
    }
    drainSubscriptionsCache() {
        return this.timedCache.flush();
    }
    getNextSubscriptionLocalKey() {
        const current = this.nextSubLocalKey;
        this.nextSubLocalKey += 1;
        return current;
    }
    registerSubscription(subLocalKey, method, params, success, error, timeout, existingSub) {
        const subsInfo = {
            localKey: subLocalKey,
            status: STATUS_AWAITING_ACCEPT,
            method,
            params,
            success,
            error,
            trackedServers: [],
            handlers: {
                onData: existingSub?.handlers.onData || [],
                onClosed: existingSub?.handlers.onClosed || [],
                onConnected: existingSub?.handlers.onConnected || [],
            },
            queued: {
                data: [],
                closers: [],
            },
            timeoutId: undefined,
            close: () => this.closeSubscription(subLocalKey),
            subscription: existingSub?.subscription
        };
        if (!existingSub) {
            if (params.onData) {
                subsInfo.handlers.onData.push(params.onData);
            }
            if (params.onClosed) {
                subsInfo.handlers.onClosed.push(params.onClosed);
            }
            if (params.onConnected) {
                subsInfo.handlers.onConnected.push(params.onConnected);
            }
        }
        this.subscriptionsList[subLocalKey] = subsInfo;
        subsInfo.timeoutId = setTimeout(() => {
            if (this.subscriptionsList[subLocalKey] === undefined) {
                return;
            }
            const pendingSub = this.subscriptionsList[subLocalKey];
            if (pendingSub.status === STATUS_AWAITING_ACCEPT) {
                error({
                    method,
                    called_with: params.arguments,
                    message: ERR_MSG_SUB_FAILED + " Subscription attempt timed out after " + timeout + " ms.",
                });
                delete this.subscriptionsList[subLocalKey];
            }
            else if (pendingSub.status === STATUS_SUBSCRIBED && pendingSub.trackedServers.length > 0) {
                pendingSub.trackedServers = pendingSub.trackedServers.filter((server) => {
                    return (typeof server.subscriptionId !== "undefined");
                });
                delete pendingSub.timeoutId;
                if (pendingSub.trackedServers.length <= 0) {
                    this.callOnClosedHandlers(pendingSub);
                    delete this.subscriptionsList[subLocalKey];
                }
            }
        }, timeout);
        return subsInfo;
    }
    handleErrorSubscribing = (errorResponse) => {
        const tag = errorResponse._tag;
        const subLocalKey = tag.subLocalKey;
        const pendingSub = this.subscriptionsList[subLocalKey];
        if (typeof pendingSub !== "object") {
            return;
        }
        pendingSub.trackedServers = pendingSub.trackedServers.filter((server) => {
            return server.serverId !== tag.serverId;
        });
        if (pendingSub.trackedServers.length <= 0) {
            clearTimeout(pendingSub.timeoutId);
            if (pendingSub.status === STATUS_AWAITING_ACCEPT) {
                const reason = (typeof errorResponse.reason === "string" && errorResponse.reason !== "") ?
                    ' Publisher said "' + errorResponse.reason + '".' :
                    " No reason given.";
                const callArgs = typeof pendingSub.params.arguments === "object" ?
                    JSON.stringify(pendingSub.params.arguments) :
                    "{}";
                pendingSub.error({
                    message: ERR_MSG_SUB_REJECTED + reason + " Called with:" + callArgs,
                    called_with: pendingSub.params.arguments,
                    method: pendingSub.method,
                });
            }
            else if (pendingSub.status === STATUS_SUBSCRIBED) {
                this.callOnClosedHandlers(pendingSub);
            }
            delete this.subscriptionsList[subLocalKey];
        }
    };
    handleSubscribed = (msg) => {
        const subLocalKey = msg._tag.subLocalKey;
        const pendingSub = this.subscriptionsList[subLocalKey];
        if (typeof pendingSub !== "object") {
            return;
        }
        const serverId = msg._tag.serverId;
        const acceptingServer = pendingSub.trackedServers
            .filter((server) => {
            return server.serverId === serverId;
        })[0];
        if (typeof acceptingServer !== "object") {
            return;
        }
        acceptingServer.subscriptionId = msg.subscription_id;
        this.subscriptionIdToLocalKeyMap[msg.subscription_id] = subLocalKey;
        const isFirstResponse = (pendingSub.status === STATUS_AWAITING_ACCEPT);
        pendingSub.status = STATUS_SUBSCRIBED;
        if (isFirstResponse) {
            let reconnect = false;
            let sub = pendingSub.subscription;
            if (sub) {
                sub.setNewSubscription(pendingSub);
                pendingSub.success(sub);
                reconnect = true;
            }
            else {
                sub = new UserSubscription(this.repository, pendingSub);
                pendingSub.subscription = sub;
                pendingSub.success(sub);
            }
            for (const handler of pendingSub.handlers.onConnected) {
                try {
                    handler(sub.serverInstance, reconnect);
                }
                catch (e) {
                }
            }
        }
    };
    handleEventData = (msg) => {
        const subLocalKey = this.subscriptionIdToLocalKeyMap[msg.subscription_id];
        if (typeof subLocalKey === "undefined") {
            return;
        }
        const subscription = this.subscriptionsList[subLocalKey];
        if (typeof subscription !== "object") {
            return;
        }
        const trackedServersFound = subscription.trackedServers.filter((s) => {
            return s.subscriptionId === msg.subscription_id;
        });
        if (trackedServersFound.length !== 1) {
            return;
        }
        const isPrivateData = msg.oob;
        const sendingServerId = trackedServersFound[0].serverId;
        const server = this.repository.getServerById(sendingServerId);
        const receivedStreamData = () => {
            return {
                data: msg.data,
                server: server?.instance ?? {},
                requestArguments: subscription.params.arguments,
                message: undefined,
                private: isPrivateData,
            };
        };
        const onDataHandlers = subscription.handlers.onData;
        const queuedData = subscription.queued.data;
        if (onDataHandlers.length > 0) {
            onDataHandlers.forEach((callback) => {
                if (typeof callback === "function") {
                    callback(receivedStreamData());
                }
            });
        }
        else {
            queuedData.push(receivedStreamData());
        }
    };
    handleSubscriptionCancelled = (msg) => {
        const subLocalKey = this.subscriptionIdToLocalKeyMap[msg.subscription_id];
        if (typeof subLocalKey === "undefined") {
            return;
        }
        const subscription = this.subscriptionsList[subLocalKey];
        if (typeof subscription !== "object") {
            return;
        }
        const expectedNewLength = subscription.trackedServers.length - 1;
        subscription.trackedServers = subscription.trackedServers.filter((server) => {
            if (server.subscriptionId === msg.subscription_id) {
                subscription.queued.closers.push(server.serverId);
                return false;
            }
            else {
                return true;
            }
        });
        if (subscription.trackedServers.length !== expectedNewLength) {
            return;
        }
        if (subscription.trackedServers.length <= 0) {
            this.timedCache.add(subscription);
            clearTimeout(subscription.timeoutId);
            this.callOnClosedHandlers(subscription);
            delete this.subscriptionsList[subLocalKey];
        }
        delete this.subscriptionIdToLocalKeyMap[msg.subscription_id];
    };
    callOnClosedHandlers(subscription, reason) {
        const closersCount = subscription.queued.closers.length;
        const closingServerId = (closersCount > 0) ? subscription.queued.closers[closersCount - 1] : null;
        let closingServer;
        if (closingServerId !== undefined && typeof closingServerId === "string") {
            closingServer = this.repository.getServerById(closingServerId)?.instance ?? {};
        }
        subscription.handlers.onClosed.forEach((callback) => {
            if (typeof callback !== "function") {
                return;
            }
            callback({
                message: reason || ON_CLOSE_MSG_SERVER_INIT,
                requestArguments: subscription.params.arguments || {},
                server: closingServer,
                stream: subscription.method,
            });
        });
    }
    closeSubscription(subLocalKey) {
        const subscription = this.subscriptionsList[subLocalKey];
        if (typeof subscription !== "object") {
            return;
        }
        subscription.trackedServers.forEach((server) => {
            if (typeof server.subscriptionId === "undefined") {
                return;
            }
            subscription.queued.closers.push(server.serverId);
            this.session.sendFireAndForget({
                type: "unsubscribe",
                subscription_id: server.subscriptionId,
                reason_uri: "",
                reason: ON_CLOSE_MSG_CLIENT_INIT,
            });
            delete this.subscriptionIdToLocalKeyMap[server.subscriptionId];
        });
        subscription.trackedServers = [];
        this.callOnClosedHandlers(subscription, ON_CLOSE_MSG_CLIENT_INIT);
        delete this.subscriptionsList[subLocalKey];
    }
}

class ClientProtocol {
    session;
    repository;
    logger;
    streaming;
    constructor(session, repository, logger) {
        this.session = session;
        this.repository = repository;
        this.logger = logger;
        session.on("peer-added", (msg) => this.handlePeerAdded(msg));
        session.on("peer-removed", (msg) => this.handlePeerRemoved(msg));
        session.on("methods-added", (msg) => this.handleMethodsAddedMessage(msg));
        session.on("methods-removed", (msg) => this.handleMethodsRemovedMessage(msg));
        this.streaming = new ClientStreaming(session, repository, logger);
    }
    subscribe(stream, options, targetServers, success, error, existingSub) {
        this.streaming.subscribe(stream, options, targetServers, success, error, existingSub);
    }
    invoke(id, method, args, target) {
        const serverId = target.id;
        const methodId = method.gatewayId;
        const msg = {
            type: "call",
            server_id: serverId,
            method_id: methodId,
            arguments_kv: args,
        };
        return this.session.send(msg, { invocationId: id, serverId })
            .then((m) => this.handleResultMessage(m))
            .catch((err) => this.handleInvocationError(err));
    }
    drainSubscriptions() {
        return this.streaming.drainSubscriptions();
    }
    drainSubscriptionsCache() {
        return this.streaming.drainSubscriptionsCache();
    }
    handlePeerAdded(msg) {
        const newPeerId = msg.new_peer_id;
        const remoteId = msg.identity;
        const isLocal = msg.meta ? msg.meta.local : true;
        const pid = Number(remoteId.process);
        const serverInfo = {
            machine: remoteId.machine,
            pid: isNaN(pid) ? remoteId.process : pid,
            instance: remoteId.instance,
            application: remoteId.application,
            applicationName: remoteId.applicationName,
            environment: remoteId.environment,
            region: remoteId.region,
            user: remoteId.user,
            windowId: remoteId.windowId,
            peerId: newPeerId,
            api: remoteId.api,
            isLocal
        };
        this.repository.addServer(serverInfo, newPeerId);
    }
    handlePeerRemoved(msg) {
        const removedPeerId = msg.removed_id;
        const reason = msg.reason;
        this.repository.removeServerById(removedPeerId, reason);
    }
    handleMethodsAddedMessage(msg) {
        const serverId = msg.server_id;
        const methods = msg.methods;
        methods.forEach((method) => {
            this.repository.addServerMethod(serverId, method);
        });
    }
    handleMethodsRemovedMessage(msg) {
        const serverId = msg.server_id;
        const methodIdList = msg.methods;
        const server = this.repository.getServerById(serverId);
        if (server) {
            const serverMethodKeys = Object.keys(server.methods);
            serverMethodKeys.forEach((methodKey) => {
                const method = server.methods[methodKey];
                if (methodIdList.indexOf(method.gatewayId) > -1) {
                    this.repository.removeServerMethod(serverId, methodKey);
                }
            });
        }
    }
    handleResultMessage(msg) {
        const invocationId = msg._tag.invocationId;
        const result = msg.result;
        const serverId = msg._tag.serverId;
        const server = this.repository.getServerById(serverId);
        return {
            invocationId,
            result,
            instance: server?.instance,
            status: InvokeStatus.Success,
            message: ""
        };
    }
    handleInvocationError(msg) {
        this.logger.debug(`handle invocation error ${JSON.stringify(msg)}`);
        if ("_tag" in msg) {
            const invocationId = msg._tag.invocationId;
            const serverId = msg._tag.serverId;
            const server = this.repository.getServerById(serverId);
            const message = msg.reason;
            const context = msg.context;
            return {
                invocationId,
                result: context,
                instance: server?.instance,
                status: InvokeStatus.Error,
                message
            };
        }
        else {
            return {
                invocationId: "",
                message: msg.message,
                status: InvokeStatus.Error,
                error: msg
            };
        }
    }
}

function gW3ProtocolFactory (instance, connection, clientRepository, serverRepository, libConfig, interop) {
    const logger = libConfig.logger.subLogger("gw3-protocol");
    let resolveReadyPromise;
    const readyPromise = new Promise((resolve) => {
        resolveReadyPromise = resolve;
    });
    const session = connection.domain("agm", ["subscribed"]);
    const server = new ServerProtocol(session, clientRepository, serverRepository, logger.subLogger("server"));
    const client = new ClientProtocol(session, clientRepository, logger.subLogger("client"));
    async function handleReconnect() {
        logger.info("reconnected - will replay registered methods and subscriptions");
        client.drainSubscriptionsCache().forEach((sub) => {
            const methodInfo = sub.method;
            const params = Object.assign({}, sub.params);
            logger.info(`trying to soft-re-subscribe to method ${methodInfo.name}, with params: ${JSON.stringify(params)}`);
            interop.client.subscribe(methodInfo, params, undefined, undefined, sub).then(() => logger.info(`soft-subscribing to method ${methodInfo.name} DONE`)).catch((error) => logger.warn(`subscribing to method ${methodInfo.name} failed: ${JSON.stringify(error)}}`));
        });
        const reconnectionPromises = [];
        const existingSubscriptions = client.drainSubscriptions();
        for (const sub of existingSubscriptions) {
            const methodInfo = sub.method;
            const params = Object.assign({}, sub.params);
            logger.info(`trying to re-subscribe to method ${methodInfo.name}, with params: ${JSON.stringify(params)}`);
            reconnectionPromises.push(interop.client.subscribe(methodInfo, params, undefined, undefined, sub).then(() => logger.info(`subscribing to method ${methodInfo.name} DONE`)));
        }
        const registeredMethods = serverRepository.getList();
        serverRepository.reset();
        for (const method of registeredMethods) {
            const def = method.definition;
            if (method.stream) {
                reconnectionPromises.push(interop.server.createStream(def, method.streamCallbacks, undefined, undefined, method.stream)
                    .then(() => logger.info(`subscribing to method ${def.name} DONE`))
                    .catch(() => logger.warn(`subscribing to method ${def.name} FAILED`)));
            }
            else if (method?.theFunction?.userCallback) {
                reconnectionPromises.push(interop.register(def, method.theFunction.userCallback)
                    .then(() => logger.info(`registering method ${def.name} DONE`))
                    .catch(() => logger.warn(`registering method ${def.name} FAILED`)));
            }
            else if (method?.theFunction?.userCallbackAsync) {
                reconnectionPromises.push(interop.registerAsync(def, method.theFunction.userCallbackAsync)
                    .then(() => logger.info(`registering method ${def.name} DONE`))
                    .catch(() => logger.warn(`registering method ${def.name} FAILED`)));
            }
        }
        await Promise.all(reconnectionPromises);
        logger.info("Interop is re-announced");
    }
    function handleInitialJoin() {
        if (resolveReadyPromise) {
            resolveReadyPromise({
                client,
                server,
            });
            resolveReadyPromise = undefined;
        }
    }
    session.onJoined((reconnect) => {
        clientRepository.addServer(instance, connection.peerId);
        if (reconnect) {
            handleReconnect().then(() => connection.setLibReAnnounced({ name: "interop" })).catch((error) => logger.warn(`Error while re-announcing interop: ${JSON.stringify(error)}`));
        }
        else {
            handleInitialJoin();
        }
    });
    session.onLeft(() => {
        clientRepository.reset();
    });
    session.join();
    return readyPromise;
}

class Interop {
    instance;
    readyPromise;
    client;
    server;
    unwrappedInstance;
    protocol;
    clientRepository;
    serverRepository;
    constructor(configuration) {
        if (typeof configuration === "undefined") {
            throw new Error("configuration is required");
        }
        if (typeof configuration.connection === "undefined") {
            throw new Error("configuration.connections is required");
        }
        const connection = configuration.connection;
        if (typeof configuration.methodResponseTimeout !== "number") {
            configuration.methodResponseTimeout = 30 * 1000;
        }
        if (typeof configuration.waitTimeoutMs !== "number") {
            configuration.waitTimeoutMs = 30 * 1000;
        }
        this.unwrappedInstance = new InstanceWrapper(this, undefined, connection);
        this.instance = this.unwrappedInstance.unwrap();
        this.clientRepository = new ClientRepository(configuration.logger.subLogger("cRep"), this);
        this.serverRepository = new ServerRepository();
        let protocolPromise;
        if (connection.protocolVersion === 3) {
            protocolPromise = gW3ProtocolFactory(this.instance, connection, this.clientRepository, this.serverRepository, configuration, this);
        }
        else {
            throw new Error(`protocol ${connection.protocolVersion} not supported`);
        }
        this.readyPromise = protocolPromise.then((protocol) => {
            this.protocol = protocol;
            this.client = new Client(this.protocol, this.clientRepository, this.instance, configuration);
            this.server = new Server(this.protocol, this.serverRepository);
            return this;
        });
    }
    ready() {
        return this.readyPromise;
    }
    serverRemoved(callback) {
        return this.client.serverRemoved(callback);
    }
    serverAdded(callback) {
        return this.client.serverAdded(callback);
    }
    serverMethodRemoved(callback) {
        return this.client.serverMethodRemoved(callback);
    }
    serverMethodAdded(callback) {
        return this.client.serverMethodAdded(callback);
    }
    methodRemoved(callback) {
        return this.client.methodRemoved(callback);
    }
    methodAdded(callback) {
        return this.client.methodAdded(callback);
    }
    methodsForInstance(instance) {
        return this.client.methodsForInstance(instance);
    }
    methods(methodFilter) {
        return this.client.methods(methodFilter);
    }
    servers(methodFilter) {
        return this.client.servers(methodFilter);
    }
    subscribe(method, options, successCallback, errorCallback) {
        return this.client.subscribe(method, options, successCallback, errorCallback);
    }
    createStream(streamDef, callbacks, successCallback, errorCallback) {
        return this.server.createStream(streamDef, callbacks, successCallback, errorCallback);
    }
    unregister(methodFilter) {
        return this.server.unregister(methodFilter);
    }
    registerAsync(methodDefinition, callback) {
        return this.server.registerAsync(methodDefinition, callback);
    }
    register(methodDefinition, callback) {
        return this.server.register(methodDefinition, callback);
    }
    invoke(methodFilter, argumentObj, target, additionalOptions, success, error) {
        return this.client.invoke(methodFilter, argumentObj, target, additionalOptions, success, error);
    }
    waitForMethod(name) {
        const pw = new PromiseWrapper();
        const unsubscribe = this.client.methodAdded((m) => {
            if (m.name === name) {
                unsubscribe();
                pw.resolve(m);
            }
        });
        return pw.promise;
    }
}

const successMessages = ["subscribed", "success"];
class MessageBus {
    connection;
    logger;
    peerId;
    session;
    subscriptions;
    readyPromise;
    constructor(connection, logger) {
        this.connection = connection;
        this.logger = logger;
        this.peerId = connection.peerId;
        this.subscriptions = [];
        this.session = connection.domain("bus", successMessages);
        this.readyPromise = this.session.join();
        this.readyPromise.then(() => {
            this.watchOnEvent();
        });
    }
    ready() {
        return this.readyPromise;
    }
    publish = (topic, data, options) => {
        const { routingKey, target } = options || {};
        const args = this.removeEmptyValues({
            type: "publish",
            topic,
            data,
            peer_id: this.peerId,
            routing_key: routingKey,
            target_identity: target
        });
        this.session.send(args);
    };
    subscribe = (topic, callback, options) => {
        return new Promise((resolve, reject) => {
            const { routingKey, target } = options || {};
            const args = this.removeEmptyValues({
                type: "subscribe",
                topic,
                peer_id: this.peerId,
                routing_key: routingKey,
                source: target
            });
            this.session.send(args)
                .then((response) => {
                const { subscription_id } = response;
                this.subscriptions.push({ subscription_id, topic, callback, source: target });
                resolve({
                    unsubscribe: () => {
                        this.session.send({ type: "unsubscribe", subscription_id, peer_id: this.peerId });
                        this.subscriptions = this.subscriptions.filter((s) => s.subscription_id !== subscription_id);
                        return Promise.resolve();
                    }
                });
            })
                .catch((error) => reject(error));
        });
    };
    watchOnEvent = () => {
        this.session.on("event", (args) => {
            const { data, subscription_id } = args;
            const source = args["publisher-identity"];
            const subscription = this.subscriptions.find((s) => s.subscription_id === subscription_id);
            if (subscription) {
                if (!subscription.source) {
                    subscription.callback(data, subscription.topic, source);
                }
                else {
                    if (this.keysMatch(subscription.source, source)) {
                        subscription.callback(data, subscription.topic, source);
                    }
                }
            }
        });
    };
    removeEmptyValues(obj) {
        const cleaned = {};
        Object.keys(obj).forEach((key) => {
            if (obj[key] !== undefined && obj[key] !== null) {
                cleaned[key] = obj[key];
            }
        });
        return cleaned;
    }
    keysMatch(obj1, obj2) {
        const keysObj1 = Object.keys(obj1);
        let allMatch = true;
        keysObj1.forEach((key) => {
            if (obj1[key] !== obj2[key]) {
                allMatch = false;
            }
        });
        return allMatch;
    }
}

const IOConnectCoreFactory = (userConfig, ext) => {
    const iodesktop = typeof window === "object" ? (window.iodesktop ?? window.glue42gd) : undefined;
    const preloadPromise = typeof window === "object" ? (window.gdPreloadPromise ?? Promise.resolve()) : Promise.resolve();
    const glueInitTimer = timer("glue");
    userConfig = userConfig || {};
    ext = ext || {};
    const internalConfig = prepareConfig(userConfig, ext, iodesktop);
    let _connection;
    let _interop;
    let _logger;
    let _metrics;
    let _contexts;
    let _bus;
    let _allowTrace;
    const libs = {};
    function registerLib(name, inner, t) {
        _allowTrace = _logger.canPublish("trace");
        if (_allowTrace) {
            _logger.trace(`registering ${name} module`);
        }
        const done = (e) => {
            inner.initTime = t.stop();
            inner.initEndTime = t.endTime;
            inner.marks = t.marks;
            if (!_allowTrace) {
                return;
            }
            const traceMessage = e ?
                `${name} failed - ${e.message}` :
                `${name} is ready - ${t.endTime - t.startTime}`;
            _logger.trace(traceMessage);
        };
        inner.initStartTime = t.startTime;
        if (inner.ready) {
            inner.ready()
                .then(() => {
                done();
            })
                .catch((e) => {
                const error = typeof e === "string" ? new Error(e) : e;
                done(error);
            });
        }
        else {
            done();
        }
        if (!Array.isArray(name)) {
            name = [name];
        }
        name.forEach((n) => {
            libs[n] = inner;
            IOConnectCoreFactory[n] = inner;
        });
    }
    function setupConnection() {
        const initTimer = timer("connection");
        _connection = new Connection(internalConfig.connection, _logger.subLogger("connection"));
        let authPromise = Promise.resolve(internalConfig.auth);
        if (internalConfig.connection && !internalConfig.auth) {
            if (iodesktop) {
                authPromise = iodesktop.getGWToken()
                    .then((token) => {
                    return {
                        gatewayToken: token
                    };
                });
            }
            else if (typeof window !== "undefined" && window?.glue42electron) {
                if (typeof window.glue42electron.gwToken === "string") {
                    authPromise = Promise.resolve({
                        gatewayToken: window.glue42electron.gwToken
                    });
                }
            }
            else {
                authPromise = Promise.reject("You need to provide auth information");
            }
        }
        return authPromise
            .then((authConfig) => {
            initTimer.mark("auth-promise-resolved");
            let authRequest;
            if (Object.prototype.toString.call(authConfig) === "[object Object]") {
                authRequest = authConfig;
            }
            else {
                throw new Error("Invalid auth object - " + JSON.stringify(authConfig));
            }
            return _connection.login(authRequest);
        })
            .then(() => {
            registerLib("connection", _connection, initTimer);
            return internalConfig;
        })
            .catch((e) => {
            if (_connection) {
                _connection.logout();
            }
            throw e;
        });
    }
    function setupLogger() {
        const initTimer = timer("logger");
        _logger = new Logger(`${internalConfig.connection.identity?.application}`, undefined, internalConfig.customLogger);
        _logger.consoleLevel(internalConfig.logger.console);
        _logger.publishLevel(internalConfig.logger.publish);
        if (_logger.canPublish("debug")) {
            _logger.debug("initializing glue...");
        }
        registerLib("logger", _logger, initTimer);
        return Promise.resolve(undefined);
    }
    function setupMetrics() {
        const initTimer = timer("metrics");
        const config = internalConfig.metrics;
        const metricsPublishingEnabledFunc = iodesktop?.getMetricsPublishingEnabled;
        const identity = internalConfig.connection.identity;
        const canUpdateMetric = metricsPublishingEnabledFunc ? metricsPublishingEnabledFunc : () => true;
        const disableAutoAppSystem = (typeof config !== "boolean" && config.disableAutoAppSystem) ?? false;
        _metrics = metrics({
            connection: config ? _connection : undefined,
            logger: _logger.subLogger("metrics"),
            canUpdateMetric,
            system: "Glue42",
            service: identity?.service ?? iodesktop?.applicationName ?? internalConfig.application,
            instance: identity?.instance ?? identity?.windowId ?? nanoid(10),
            disableAutoAppSystem,
            pagePerformanceMetrics: typeof config !== "boolean" ? config?.pagePerformanceMetrics : undefined
        });
        registerLib("metrics", _metrics, initTimer);
        return Promise.resolve();
    }
    function setupInterop() {
        const initTimer = timer("interop");
        const agmConfig = {
            connection: _connection,
            logger: _logger.subLogger("interop"),
        };
        _interop = new Interop(agmConfig);
        Logger.Interop = _interop;
        registerLib(["interop", "agm"], _interop, initTimer);
        return Promise.resolve();
    }
    function setupContexts() {
        const hasActivities = (internalConfig.activities && _connection.protocolVersion === 3);
        const needsContexts = internalConfig.contexts || hasActivities;
        if (needsContexts) {
            const initTimer = timer("contexts");
            _contexts = new ContextsModule({
                connection: _connection,
                logger: _logger.subLogger("contexts"),
                trackAllContexts: typeof internalConfig.contexts === "object" ? internalConfig.contexts.trackAllContexts : false,
                reAnnounceKnownContexts: typeof internalConfig.contexts === "object" ? internalConfig.contexts.reAnnounceKnownContexts : false
            });
            registerLib("contexts", _contexts, initTimer);
            return _contexts;
        }
        else {
            const replayer = _connection.replayer;
            if (replayer) {
                replayer.drain(ContextMessageReplaySpec.name);
            }
        }
    }
    async function setupBus() {
        if (!internalConfig.bus) {
            return Promise.resolve();
        }
        const initTimer = timer("bus");
        _bus = new MessageBus(_connection, _logger.subLogger("bus"));
        registerLib("bus", _bus, initTimer);
        return Promise.resolve();
    }
    function setupExternalLibs(externalLibs) {
        try {
            externalLibs.forEach((lib) => {
                setupExternalLib(lib.name, lib.create);
            });
            return Promise.resolve();
        }
        catch (e) {
            return Promise.reject(e);
        }
    }
    function setupExternalLib(name, createCallback) {
        const initTimer = timer(name);
        const lib = createCallback(libs);
        if (lib) {
            registerLib(name, lib, initTimer);
        }
    }
    function waitForLibs() {
        const libsReadyPromises = Object.keys(libs).map((key) => {
            const lib = libs[key];
            return lib.ready ?
                lib.ready() : Promise.resolve();
        });
        return Promise.all(libsReadyPromises);
    }
    function constructGlueObject() {
        const feedbackFunc = (feedbackInfo) => {
            if (!_interop) {
                return;
            }
            _interop.invoke("T42.ACS.Feedback", feedbackInfo, "best");
        };
        const info = {
            coreVersion: version,
            version: internalConfig.version
        };
        glueInitTimer.stop();
        const glue = {
            feedback: feedbackFunc,
            info,
            logger: _logger,
            interop: _interop,
            agm: _interop,
            connection: _connection,
            metrics: _metrics,
            contexts: _contexts,
            bus: _bus,
            version: internalConfig.version,
            userConfig,
            done: () => {
                _logger?.info("done called by user...");
                return _connection.logout();
            }
        };
        glue.performance = {
            get glueVer() {
                return internalConfig.version;
            },
            get glueConfig() {
                return JSON.stringify(userConfig);
            },
            get browser() {
                return window.performance.timing.toJSON();
            },
            get memory() {
                return window.performance.memory;
            },
            get initTimes() {
                const all = getAllTimers();
                return Object.keys(all).map((key) => {
                    const t = all[key];
                    return {
                        name: key,
                        duration: t.endTime - t.startTime,
                        marks: t.marks,
                        startTime: t.startTime,
                        endTime: t.endTime
                    };
                });
            }
        };
        Object.keys(libs).forEach((key) => {
            const lib = libs[key];
            glue[key] = lib;
        });
        glue.config = {};
        Object.keys(internalConfig).forEach((k) => {
            glue.config[k] = internalConfig[k];
        });
        if (ext && ext.extOptions) {
            Object.keys(ext.extOptions).forEach((k) => {
                glue.config[k] = ext?.extOptions[k];
            });
        }
        if (ext?.enrichGlue) {
            ext.enrichGlue(glue);
        }
        if (iodesktop && iodesktop.updatePerfData) {
            iodesktop.updatePerfData(glue.performance);
        }
        if (glue.agm) {
            const deprecatedDecorator = (fn, wrong, proper) => {
                return function () {
                    glue.logger.warn(`glue.js - 'glue.agm.${wrong}' method is deprecated, use 'glue.interop.${proper}' instead.`);
                    return fn.apply(glue.agm, arguments);
                };
            };
            const agmAny = glue.agm;
            agmAny.method_added = deprecatedDecorator(glue.agm.methodAdded, "method_added", "methodAdded");
            agmAny.method_removed = deprecatedDecorator(glue.agm.methodRemoved, "method_removed", "methodRemoved");
            agmAny.server_added = deprecatedDecorator(glue.agm.serverAdded, "server_added", "serverAdded");
            agmAny.server_method_aded = deprecatedDecorator(glue.agm.serverMethodAdded, "server_method_aded", "serverMethodAdded");
            agmAny.server_method_removed = deprecatedDecorator(glue.agm.serverMethodRemoved, "server_method_removed", "serverMethodRemoved");
        }
        return glue;
    }
    async function registerInstanceIfNeeded() {
        const RegisterInstanceMethodName = "T42.ACS.RegisterInstance";
        if (Utils.isNode() && typeof process.env._GD_STARTING_CONTEXT_ === "undefined" && typeof userConfig?.application !== "undefined") {
            const isMethodAvailable = _interop.methods({ name: RegisterInstanceMethodName }).length > 0;
            if (isMethodAvailable) {
                try {
                    await _interop.invoke(RegisterInstanceMethodName, { appName: userConfig?.application, pid: process.pid });
                }
                catch (error) {
                    const typedError = error;
                    _logger.error(`Cannot register as an instance: ${JSON.stringify(typedError.message)}`);
                }
            }
        }
    }
    return preloadPromise
        .then(setupLogger)
        .then(setupConnection)
        .then(() => Promise.all([setupMetrics(), setupInterop(), setupContexts(), setupBus()]))
        .then(() => _interop.readyPromise)
        .then(() => registerInstanceIfNeeded())
        .then(() => {
        return setupExternalLibs(internalConfig.libs || []);
    })
        .then(waitForLibs)
        .then(constructGlueObject)
        .catch((err) => {
        return Promise.reject({
            err,
            libs
        });
    });
};
if (typeof window !== "undefined") {
    window.IOConnectCore = IOConnectCoreFactory;
}
IOConnectCoreFactory.version = version;
IOConnectCoreFactory.default = IOConnectCoreFactory;

export { IOConnectCoreFactory as default };
//# sourceMappingURL=core.es.js.map
